webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each__ = __webpack_require__(90);



/* harmony default export */ __webpack_exports__["a"] = ({
  init: function init() {},

  res: null,
  errorHandler: function errorHandler(error) {
    var h = this.$createElement;
    var errors = [];

    if (error.body && error.status !== 500) {
      if (error.status !== 401) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__each__["a" /* default */])(error.body, function (item, key) {
          if (item.constructor === Array) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__each__["a" /* default */])(item, function (subItem) {
              errors.push(h('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(subItem)));
            });
          } else {
            errors.push(h('div', item));
          }
        });
      }
    } else {
      errors.push(h('div', 'Ops something went wrong'));
    }

    if (errors.length > 0) {
      this.$notify.error({
        title: 'Error',
        duration: 15000,
        message: h('div', errors)
      });
    }
  }
});

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_encrypt_storage__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_encrypt_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_encrypt_storage__);


var encryptStorage = new __WEBPACK_IMPORTED_MODULE_0_encrypt_storage__["EncryptStorage"]('secret-key-value', {
  storageType: 'sessionStorage'
});

/* harmony default export */ __webpack_exports__["a"] = (encryptStorage);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = (function (data, strFileName, strMimeType) {
  var self = window,
      defaultMime = "application/octet-stream",
      mimeType = strMimeType || defaultMime,
      payload = data,
      url = !strFileName && !strMimeType && payload,
      anchor = document.createElement("a"),
      toString = function toString(a) {
    return String(a);
  },
      myBlob = self.Blob || self.MozBlob || self.WebKitBlob || toString,
      fileName = strFileName || "download",
      blob,
      reader;
  myBlob = myBlob.call ? myBlob.bind(self) : Blob;

  if (String(this) === "true") {
    payload = [payload, mimeType];
    mimeType = payload[0];
    payload = payload[1];
  }

  if (url && url.length < 2048) {
    fileName = url.split("/").pop().split("?")[0];
    anchor.href = url;
    if (anchor.href.indexOf(url) !== -1) {
      var ajax = new XMLHttpRequest();
      ajax.open("GET", url, true);
      ajax.responseType = 'blob';
      ajax.onload = function (e) {
        download(e.target.response, fileName, defaultMime);
      };
      setTimeout(function () {
        ajax.send();
      }, 0);
      return ajax;
    }
  }
  if (/^data\:[\w+\-]+\/[\w+\-]+[,;]/.test(payload)) {

    if (payload.length > 1024 * 1024 * 1.999 && myBlob !== toString) {
      payload = dataUrlToBlob(payload);
      mimeType = payload.type || defaultMime;
    } else {
      return navigator.msSaveBlob ? navigator.msSaveBlob(dataUrlToBlob(payload), fileName) : saver(payload);
    }
  }

  blob = payload instanceof myBlob ? payload : new myBlob([payload], { type: mimeType });

  function dataUrlToBlob(strUrl) {
    var parts = strUrl.split(/[:;,]/),
        type = parts[1],
        decoder = parts[2] == "base64" ? atob : decodeURIComponent,
        binData = decoder(parts.pop()),
        mx = binData.length,
        i = 0,
        uiArr = new Uint8Array(mx);

    for (i; i < mx; ++i) {
      uiArr[i] = binData.charCodeAt(i);
    }return new myBlob([uiArr], { type: type });
  }

  function saver(url, winMode) {

    if ('download' in anchor) {
      anchor.href = url;
      anchor.setAttribute("download", fileName);
      anchor.className = "download-js-link";
      anchor.innerHTML = "downloading...";
      anchor.style.display = "none";
      document.body.appendChild(anchor);
      setTimeout(function () {
        anchor.click();
        document.body.removeChild(anchor);
        if (winMode === true) {
          setTimeout(function () {
            self.URL.revokeObjectURL(anchor.href);
          }, 250);
        }
      }, 66);
      return true;
    }

    if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
      url = url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
      if (!window.open(url)) {
        if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) {
          location.href = url;
        }
      }
      return true;
    }

    var f = document.createElement("iframe");
    document.body.appendChild(f);

    if (!winMode) {
      url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
    }
    f.src = url;
    setTimeout(function () {
      document.body.removeChild(f);
    }, 333);
  }

  if (navigator.msSaveBlob) {
    return navigator.msSaveBlob(blob, fileName);
  }

  if (self.URL) {
    saver(self.URL.createObjectURL(blob), true);
  } else {
    if (typeof blob === "string" || blob.constructor === toString) {
      try {
        return saver("data:" + mimeType + ";base64," + self.btoa(blob));
      } catch (y) {
        return saver("data:" + mimeType + "," + encodeURIComponent(blob));
      }
    }

    reader = new FileReader();
    reader.onload = function (e) {
      saver(this.result);
    };
    reader.readAsDataURL(blob);
  }
  return true;
});

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var chartColors = ['#09b3af', '#f0ad4e', '#d9544f'];

/* harmony default export */ __webpack_exports__["a"] = (chartColors);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function currency(value, currency, decimals) {
  var digitsRE = /(\d{3})(?=\d)/g;
  value = parseFloat(value);
  if (!isFinite(value) || !value && value !== 0) return '';
  currency = currency != null ? currency : '$';
  decimals = decimals != null ? decimals : 2;
  var stringified = Math.abs(value).toFixed(decimals);
  var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
  var i = _int.length % 3;
  var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
  var _float = decimals ? stringified.slice(-1 - decimals) : '';
  var sign = value < 0 ? '-' : '';
  return sign + currency + ' ' + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
}

/* harmony default export */ __webpack_exports__["a"] = (currency);

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function chartData(type, reportData, definition, key, currency) {
  var labelKeys = definition.chartLabelKeys;
  var labels = reportData.map(function (e) {
    return labelKeys.map(function (key) {
      return e[key];
    }).join(' - ');
  });
  var format = definition.table.find(function (e) {
    return e.key === type;
  }).format;

  switch (definition.chart) {
    case 'PIE':
      return { labels: labels, values: reportData.map(function (e) {
          return e[type];
        }), format: format, isBestseller: key === 'best_seller' ? 20 : undefined, currency: currency };

    case 'BAR_AND_LINE':
      var values = definition.chartValuePrefix.map(function (prefix) {
        return reportData.map(function (e) {
          return e[prefix + type];
        });
      });
      var valueLabels = definition.chartValueLabel;
      var types = definition.chartValuePrefix.map(function () {
        return 'bar';
      });

      var showAverage = definition.table.find(function (e) {
        return e.key === type;
      }).chartAverage;
      if (showAverage) {
        values = [reportData.map(function (e) {
          return e['ema'];
        })].concat(values);
        valueLabels = ['10 days average'].concat(valueLabels);
        types = ['line'].concat(types);
      }

      return { labels: labels, values: values, valueLabels: valueLabels, types: types, showAverage: showAverage, format: format, currency: currency };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (chartData);

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (object, cb) {
  for (var index in object) {
    if (object.hasOwnProperty(index)) {
      cb(object[index], index);
    }
  }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormatEnum */
/* unused harmony export ChartTypeEnum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);



var FormatEnum = { 'CURRENCY': 'CURRENCY', 'DATE': 'DATE' };
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(FormatEnum);

var ChartTypeEnum = { 'PIE': 'PIE', 'BAR_AND_LINE': 'BAR_AND_LINE' };
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(ChartTypeEnum);

var orderDetails = {
  title: 'Orders',
  api: 'get_order_details',
  chart: ChartTypeEnum.BAR_AND_LINE,
  chartLabelKeys: ['date'],
  chartValuePrefix: ['successful_', 'open_', 'failed_'],
  chartValueLabel: ['Shipped, Received and Payment Confirmed', 'Open', 'Abandoned'],
  filterPreselect: 'total',
  filterTabs: ['day', 'month', 'year'],
  table: [{
    key: 'date',
    label: 'Date'
  }, {
    key: 'number_of_orders',
    label: 'Orders',
    filterable: true
  }, {
    key: 'average_total',
    label: 'Average Total',
    format: FormatEnum.CURRENCY,
    filterable: true
  }, {
    key: 'products_count',
    label: 'Products',
    filterable: true
  }, {
    key: 'total',
    label: 'Total',
    format: FormatEnum.CURRENCY,
    filterable: true,
    chartAverage: true
  }]
};

var bestseller = {
  title: 'Bestseller',
  api: 'get_best_seller',
  chart: ChartTypeEnum.PIE,
  chartLabelKeys: ['sku', 'name'],
  table: [{
    key: 'sku',
    label: 'SKU'
  }, {
    key: 'name',
    label: 'Name'
  }, {
    key: 'quantity',
    label: 'Amount',
    filterable: true
  }, {
    key: 'total',
    label: 'Total',
    format: FormatEnum.CURRENCY,
    filterable: true
  }]
};

var gender = {
  title: 'Gender',
  api: 'get_gender_orders',
  chart: ChartTypeEnum.PIE,
  chartLabelKeys: ['gender'],
  table: [{
    key: 'gender',
    label: 'Type'
  }, {
    key: 'number_of_orders',
    label: 'Orders',
    filterable: true
  }, {
    key: 'average_total',
    label: 'Average Total',
    format: FormatEnum.CURRENCY,
    filterable: true
  }, {
    key: 'number_of_products',
    label: 'Products',
    filterable: true
  }, {
    key: 'total',
    label: 'Total',
    format: FormatEnum.CURRENCY,
    filterable: true
  }]
};

var abandoned = {
  title: 'Abandoned carts',
  api: 'get_abandoned_vs_completed',
  chart: ChartTypeEnum.PIE,
  chartLabelKeys: ['type'],
  table: [{
    key: 'type',
    label: 'Type'
  }, {
    key: 'orders_number',
    label: 'Orders',
    filterable: true
  }, {
    key: 'average_total',
    label: 'Average Total',
    format: FormatEnum.CURRENCY,
    filterable: true
  }, {
    key: 'products_count',
    label: 'Products',
    filterable: true
  }, {
    key: 'total',
    label: 'Total',
    format: FormatEnum.CURRENCY,
    filterable: true
  }]
};

var returningVisitors = {
  title: 'New x returning customers',
  api: 'get_new_customers_orders',
  chart: ChartTypeEnum.PIE,
  chartLabelKeys: ['type'],
  table: [{
    key: 'type',
    label: 'Type'
  }, {
    key: 'orders',
    label: 'Orders',
    filterable: true
  }]
};

var boletoConversion = {
  title: 'Created x Paid invoices',
  api: 'get_aborted_vs_paid_orders',
  chart: ChartTypeEnum.PIE,
  chartLabelKeys: ['type'],
  table: [{
    key: 'type',
    label: 'Type'
  }, {
    key: 'orders_number',
    label: 'Orders',
    filterable: true
  }, {
    key: 'average_total',
    label: 'Average Total',
    format: FormatEnum.CURRENCY,
    filterable: true
  }, {
    key: 'products_count',
    label: 'Products',
    filterable: true
  }, {
    key: 'total',
    label: 'Total',
    format: FormatEnum.CURRENCY,
    filterable: true
  }]
};

var paymentMethods = {
  title: 'Payment methods',
  api: 'get_payment_methods',
  chart: ChartTypeEnum.PIE,
  chartLabelKeys: ['payment_type'],
  table: [{
    key: 'payment_type',
    label: 'Type'
  }, {
    key: 'orders_number',
    label: 'Orders',
    filterable: true
  }, {
    key: 'average_total',
    label: 'Average Total',
    format: FormatEnum.CURRENCY,
    filterable: true
  }, {
    key: 'number_of_products',
    label: 'Products',
    filterable: true
  }, {
    key: 'total',
    label: 'Total',
    format: FormatEnum.CURRENCY,
    filterable: true
  }]
};

var reportDefinition = {
  'order_details': orderDetails,
  'best_seller': bestseller,
  'abandoned': abandoned,
  'returning_visitors': returningVisitors,
  'gender': gender,
  'boleto_conversion': boletoConversion,
  'payment_methods': paymentMethods
};

/* harmony default export */ __webpack_exports__["a"] = (reportDefinition);

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function convertSettings(resData) {

    var model = {};

    model.general_setting = {
        site_logo: ''
    };

    for (var i = 0; i < resData.length; i++) {
        var data = resData[i];
        if (typeof model[data.code] === 'undefined') {
            model[data.code] = {};
        }
        if (data.origin_id == null) {
            model[data.code][data.setting_key] = data.setting;
        }
    }

    return model;
}

/* harmony default export */ __webpack_exports__["a"] = (convertSettings);

/***/ }),
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(295),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(296),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(438)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(530),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(541),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */,
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Admin__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Admin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Admin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ChartProgress_vue__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ChartProgress_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ChartProgress_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_fields_Boolean_vue__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_fields_Boolean_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_fields_Boolean_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_fields_CategoryHierarchySelect_vue__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_fields_CategoryHierarchySelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_fields_CategoryHierarchySelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_fields_CategoryMultiSelect_vue__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_fields_CategoryMultiSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_fields_CategoryMultiSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_fields_CustomDateRangePicker_vue__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_fields_CustomDateRangePicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_fields_CustomDateRangePicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_fields_Image_vue__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_fields_Image_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_fields_Image_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_fields_ImageUpload_vue__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_fields_ImageUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_fields_ImageUpload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_fields_MailPreview_vue__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_fields_MailPreview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_fields_MailPreview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_fields_MetaData_vue__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_fields_MetaData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_fields_MetaData_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_fields_Radio_vue__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_fields_Radio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_fields_Radio_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_fields_RemoteSelect_vue__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_fields_RemoteSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_fields_RemoteSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_fields_Select_vue__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_fields_Select_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_fields_Select_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_fields_Translations_vue__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_fields_Translations_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_fields_Translations_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_LoggedOut__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_LoggedOut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_LoggedOut__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Messages_vue__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Messages_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Messages_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Order_vue__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Order_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Order_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Payment_vue__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Payment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Payment_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Shipping_vue__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Shipping_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Shipping_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_VueCrudTable_vue__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_VueCrudTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_VueCrudTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Automation_vue__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Automation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Automation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_General_vue__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_General_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_General_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_PreviewImage_vue__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_PreviewImage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_PreviewImage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_resource__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_router__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_wysiwyg__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_wysiwyg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vue_wysiwyg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__libs_currency__ = __webpack_require__(56);





























__WEBPACK_IMPORTED_MODULE_23_vue__["default"].component('v-crud-radio', __WEBPACK_IMPORTED_MODULE_10__components_fields_Radio_vue___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].component('v-crud-select', __WEBPACK_IMPORTED_MODULE_12__components_fields_Select_vue___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].component('v-crud-boolean', __WEBPACK_IMPORTED_MODULE_2__components_fields_Boolean_vue___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].component('v-crud-remote-select', __WEBPACK_IMPORTED_MODULE_11__components_fields_RemoteSelect_vue___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].component('v-crud-category-hierarchy-select', __WEBPACK_IMPORTED_MODULE_3__components_fields_CategoryHierarchySelect_vue___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].component('v-crud-category-multi-select', __WEBPACK_IMPORTED_MODULE_4__components_fields_CategoryMultiSelect_vue___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].component('v-crud-image-upload', __WEBPACK_IMPORTED_MODULE_7__components_fields_ImageUpload_vue___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].component('v-crud-mail-preview', __WEBPACK_IMPORTED_MODULE_8__components_fields_MailPreview_vue___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].component('v-crud-image', __WEBPACK_IMPORTED_MODULE_6__components_fields_Image_vue___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].component('v-crud-translations', __WEBPACK_IMPORTED_MODULE_13__components_fields_Translations_vue___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].component('v-crud-table', __WEBPACK_IMPORTED_MODULE_19__components_VueCrudTable_vue___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].component('v-crud-meta-data', __WEBPACK_IMPORTED_MODULE_9__components_fields_MetaData_vue___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].component('order', __WEBPACK_IMPORTED_MODULE_16__components_Order_vue___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].component('messages', __WEBPACK_IMPORTED_MODULE_15__components_Messages_vue___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].component('payment', __WEBPACK_IMPORTED_MODULE_17__components_Payment_vue___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].component('shipping', __WEBPACK_IMPORTED_MODULE_18__components_Shipping_vue___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].component('automation', __WEBPACK_IMPORTED_MODULE_20__components_Automation_vue___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].component('general', __WEBPACK_IMPORTED_MODULE_21__components_General_vue___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].component('preview-image', __WEBPACK_IMPORTED_MODULE_22__components_PreviewImage_vue___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].component('chart-progress', __WEBPACK_IMPORTED_MODULE_1__components_ChartProgress_vue___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].component('v-custom-date-range-picker', __WEBPACK_IMPORTED_MODULE_5__components_fields_CustomDateRangePicker_vue___default.a);

__WEBPACK_IMPORTED_MODULE_23_vue__["default"].filter('humanize', function (value) {
    if (typeof value === 'undefined') {
        return 'undefined';
    }
    var humanized = value.toString().toLowerCase().replace(/[_-]/g, ' ').replace(/(?:^|\s)\S/g, function (a) {
        return a.toUpperCase();
    });

    return humanized;
});

__WEBPACK_IMPORTED_MODULE_23_vue__["default"].filter('datetime', function (date) {
    if (typeof date === 'undefined' || date === null) {
        return '';
    }

    var dateObj = new Date(date);
    return dateObj.toLocaleDateString() + ' ' + dateObj.toLocaleTimeString();
});

__WEBPACK_IMPORTED_MODULE_23_vue__["default"].filter('currency', __WEBPACK_IMPORTED_MODULE_27__libs_currency__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_23_vue__["default"].filter('date', function (date, format) {
    if (typeof date === 'undefined') {
        return '';
    }

    var dateObj = new Date(date);
    return dateObj.toLocaleDateString();
});

__WEBPACK_IMPORTED_MODULE_23_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_23_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_26_vue_wysiwyg___default.a, {
    hideModules: {
        image: true,
        table: true
    }
});

var routerInstance = new __WEBPACK_IMPORTED_MODULE_25_vue_router__["a" /* default */]({
    routes: [{
        path: '/logged_out',
        name: 'logged_out',
        component: __WEBPACK_IMPORTED_MODULE_14__components_LoggedOut___default.a
    }, {
        path: '/',
        name: 'home',
        component: __WEBPACK_IMPORTED_MODULE_0__components_Admin___default.a
    }, {
        path: '/admin/:model/:id/:action',
        name: 'admin',
        component: __WEBPACK_IMPORTED_MODULE_0__components_Admin___default.a,
        props: true
    }, {
        path: '/settings',
        name: 'settings',
        component: __WEBPACK_IMPORTED_MODULE_0__components_Admin___default.a,
        props: { model: 'settings', id: 'all', action: 'index' }
    }]
});

__WEBPACK_IMPORTED_MODULE_23_vue__["default"].http.options.headers = {
    Authorization: null
};

/* harmony default export */ __webpack_exports__["a"] = (routerInstance);

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(433)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(518),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__element_variables_scss__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__element_variables_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__element_variables_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_main_scss__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_main_scss__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app'
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_encryptStorage__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_params__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__libs_settings__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__schema__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CustomerRegistrations__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CustomerRegistrations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__CustomerRegistrations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Dashboard__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Install__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Install___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Install__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ReportDetail__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ReportDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ReportDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Reports__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Reports___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__Reports__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Settings__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__VueCrud__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__VueCrud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__VueCrud__);



















var domainToApiMap = {
    'wh.admin.commerce.netural.com': 'wh.api.commerce.netural.com',
    'silhouette.admin.commerce.netural.com': 'silhouette.api.commerce.netural.com',

    'qa-wh.admin.commerce.netural.com': 'qa.wh.api.commerce.netural.com',
    'qa-silhouette.admin.commerce.netural.com': 'qa.silhouette.api.commerce.netural.com',
    'qa.admin.commerce.netural.com': 'qa.api.commerce.netural.com',
    'test-wh.admin.commerce.netural.com': 'qa.wh.api.commerce.netural.com',
    'test-silhouette.admin.commerce.netural.com': 'qa.silhouette.api.commerce.netural.com',

    'localhost:8443': 'qa.silhouette.api.commerce.netural.com' };
var currentHost = window.location.host;
var apiHost = domainToApiMap[currentHost];
var apiEndpoint = apiHost ? 'https://' + apiHost + '/v1' : undefined;
var isQaApiEndpoint = apiHost && apiHost.startsWith('qa.');

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'admin',

    props: ['id', 'model', 'action'],

    data: function data() {
        return {
            login: {
                site_id: localStorage.getItem('site_id'),
                email: '',
                password: ''
            },
            loading: true,
            config: {
                component: 'v-admin',
                endPoint: apiEndpoint,
                headers: {},
                body: []
            },
            customerSettings: {
                tabs: null
            },
            firstRedirect: true,
            fullMode: false,
            loggedIn: false,
            isPrintMode: false,
            permittedSitesConfig: {
                'wh-atde': 42683,
                'wh-fr': 42718,
                'wh-bg': 42710,
                'wh-au': 42699,
                'wh-ca': 42639,
                'wh-in': 42730,
                'wh-pl': 42737,
                'wh-tr': 42738,
                'wh-ib': 42781,
                'wh-dk': 42839,
                'wh-se': 42840
            },
            userRole: __WEBPACK_IMPORTED_MODULE_5__libs_encryptStorage__["a" /* default */].getItem('ur'),
            userPermission: {
                Storefront: [],
                Api: [],
                SuperMana: [],
                SuperManage: [],
                Superadmin: [],
                Admin: [],
                BRAdmin: [],
                UKAdmin: [],
                USAdmin: [],
                CustomerSup: ['configuration', 'general', 'settings', 'canned_messages', 'site_countries', 'site_country_zones', 'customer_groups', 'prices', 'pricelists', 'tax_categories', 'tax_rates', 'origins', 'users', 'dashboard', 'contents', 'coupons', 'discounts', 'checkouts', 'newsletter_subscribers', 'categories', 'properties', 'testimonials', 'assets', 'checkouts', 'sales', 'catalogue'],
                Manager: [],
                Warehouse: ['configuration', 'general', 'settings', 'canned_messages', 'site_countries', 'site_country_zones', 'customer_groups', 'prices', 'pricelists', 'tax_categories', 'tax_rates', 'origins', 'users', 'dashboard', 'contents', 'coupons', 'discounts', 'checkouts', 'newsletter_subscribers', 'categories', 'properties', 'testimonials', 'assets'],
                Orders: ['configuration', 'general', 'settings', 'canned_messages', 'site_countries', 'site_country_zones', 'customer_groups', 'prices', 'pricelists', 'tax_categories', 'tax_rates', 'origins', 'users', 'dashboard', 'contents', 'catalogue', 'products', 'categories', 'properties', 'testimonials', 'assets', 'checkouts'],
                Reports: ['configuration', 'general', 'settings', 'canned_messages', 'site_countries', 'site_country_zones', 'customer_groups', 'prices', 'pricelists', 'tax_categories', 'tax_rates', 'origins', 'users', 'dashboard', 'contents', 'coupons', 'discounts', 'checkouts', 'newsletter_subscribers', 'products', 'categories', 'properties', 'assets']
            },
            restrictedRoutes: __WEBPACK_IMPORTED_MODULE_5__libs_encryptStorage__["a" /* default */].getItem('rr')
        };
    },


    watch: {
        $route: function $route(routeTo) {
            this.isPrintMode = routeTo.params.action === 'print';
        }
    },

    computed: {
        activeConfig: function activeConfig() {
            var _this = this;

            if (this.isRestricted(this.model)) {
                return;
            }
            if (!Object.hasOwn(this.userPermission, this.userRole)) {
                return;
            }
            if (!this.hasUserRolePermission(this.model) && typeof this.model !== 'undefined') {
                return;
            }
            if (this.model === 'users' || this.model === 'newsletter_subscribers' || this.model === 'report' || this.model === 'customer_registrations' || typeof this.model === 'undefined') {
                var site_id = this.login.site_id;

                if (Object.hasOwn(this.permittedSitesConfig, site_id)) {
                    site_id = this.permittedSitesConfig['' + site_id];
                }

                var isPermittedSite = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(this.permittedSitesConfig).includes(Number(site_id));

                if (!isPermittedSite) {
                    return;
                }

                if (this.model === 'customer_registrations') {
                    return { component: 'customer-registrations' };
                }

                if (this.model === 'report' || typeof this.model === 'undefined') {
                    if (this.id) {
                        return { component: 'report', id: this.id };
                    }
                    return {
                        component: 'reports',
                        name: 'Reports',
                        route: 'reports'
                    };
                }
            }

            var model = this.config.body.filter(function (e) {
                return e.route === _this.model;
            });

            if (model.length > 0) {
                return model[0];
            }

            return null;
        },
        isVisible: function isVisible() {
            var site_id = this.login.site_id;

            if (Object.hasOwn(this.permittedSitesConfig, site_id)) {
                site_id = this.permittedSitesConfig['' + site_id];
            }

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(this.permittedSitesConfig).includes(Number(site_id));
        }
    },

    created: function created() {
        if (this.config.endPoint) {
            this.loadCustomerSettings();

            var group = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__libs_params__["a" /* default */])('group');
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__libs_params__["a" /* default */])('_storyblok')) {
                this.loadConfig();

                if (isQaApiEndpoint) {
                    this.registerStoryblok();
                }
            } else {
                if (sessionStorage.getItem('sbc-token') !== null) {
                    this.loggedIn = true;
                    this.$router.push('/');
                }

                if (window.location !== window.parent.location) {
                    this.config.body = __WEBPACK_IMPORTED_MODULE_8__schema__["a" /* default */][group] || __WEBPACK_IMPORTED_MODULE_8__schema__["a" /* default */].default;
                    this.initRoute();
                    this.firstRedirect = false;
                } else {
                    this.loading = false;
                    this.fullMode = true;
                }
            }
        }
    },
    mounted: function mounted() {
        var sessionExpired = sessionStorage.getItem('session-expired');
        if (sessionExpired) {
            sessionStorage.removeItem('session-expired');
            this.$notify({
                title: 'Your session has expired.',
                message: 'Please log in.',
                duration: 10000
            });
            this.$router.push('/');
        }
    },


    components: {
        'v-crud': __WEBPACK_IMPORTED_MODULE_15__VueCrud___default.a,
        'customer-registrations': __WEBPACK_IMPORTED_MODULE_9__CustomerRegistrations___default.a,
        settings: __WEBPACK_IMPORTED_MODULE_14__Settings___default.a,
        install: __WEBPACK_IMPORTED_MODULE_11__Install___default.a,
        dashboard: __WEBPACK_IMPORTED_MODULE_10__Dashboard___default.a,
        reports: __WEBPACK_IMPORTED_MODULE_13__Reports___default.a,
        report: __WEBPACK_IMPORTED_MODULE_12__ReportDetail___default.a
    },

    methods: {
        isRestricted: function isRestricted(route) {
            if (!this.restrictedRoutes) {
                return false;
            }
            var restrictedRoutes = this.restrictedRoutes.split(',');
            if ((route === 'report' || route === 'customer_registrations' || typeof this.model === 'undefined') && restrictedRoutes.includes('show_sales')) {
                return true;
            }
            if ((route === 'coupons' || route === 'discounts' || route === 'newsletter_subscribers') && restrictedRoutes.includes('marketing')) {
                return true;
            }
            if (route === 'settings' && restrictedRoutes.includes('edit_advanced_layout')) {
                return true;
            }
            return false;
        },
        hasUserRolePermission: function hasUserRolePermission(route) {
            if (!Object.hasOwn(this.userPermission, this.userRole)) {
                return false;
            }
            return !this.userPermission['' + this.userRole].includes(route);
        },
        sidebarClick: function sidebarClick(route) {
            this.firstRedirect = true;
            this.loadConfig(route);
        },
        sidebarContentsClick: function sidebarContentsClick() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var settings;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.getSettings();

                            case 2:
                                settings = _context.sent;

                                if (settings && settings.general_setting && settings.general_setting.storyblok_url) {
                                    window.open(settings.general_setting.storyblok_url, '_blank');
                                }

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        navigateToReports: function navigateToReports() {
            this.config.body = [];
            this.$router.push({ name: 'home' });
        },
        navigateToStatistics: function navigateToStatistics() {
            this.config.body = [];
            this.$router.push({
                name: 'admin',
                params: { model: 'report', id: 'order_details', action: 'all' }
            });
        },
        navigateToCustomerRegistrations: function navigateToCustomerRegistrations() {
            this.config.body = [];
            this.$router.push({
                name: 'admin',
                params: { model: 'customer_registrations', id: 'all', action: 'index' }
            });
        },
        onLogout: function onLogout() {
            var _this3 = this;

            var sessionApi = this.$resource(this.config.endPoint + '/user_sessions/me');
            sessionApi.delete().then(function () {
                __WEBPACK_IMPORTED_MODULE_5__libs_encryptStorage__["a" /* default */].removeItem('ur');
                __WEBPACK_IMPORTED_MODULE_5__libs_encryptStorage__["a" /* default */].removeItem('rr');
                sessionStorage.removeItem('sbc-token');
                sessionStorage.removeItem('tableFilter');
                _this3.$router.push('/');
                _this3.loggedIn = false;
            }).catch(__WEBPACK_IMPORTED_MODULE_4__libs_api__["a" /* default */].errorHandler);
        },
        submitForm: function submitForm() {
            var _this4 = this;

            var site_id = this.login.site_id;

            if (Object.hasOwn(this.permittedSitesConfig, site_id)) {
                site_id = this.permittedSitesConfig['' + site_id];
            }

            var login = {
                site_id: site_id,
                email: this.login.email,
                password: this.login.password
            };

            var sessionApi = this.$resource(this.config.endPoint + '/user_sessions');

            sessionApi.save(login).then(function (res) {
                _this4.userRole = res.body.access;
                __WEBPACK_IMPORTED_MODULE_5__libs_encryptStorage__["a" /* default */].setItem('ur', res.body.access);
                _this4.restrictedRoutes = res.body.disallow;
                __WEBPACK_IMPORTED_MODULE_5__libs_encryptStorage__["a" /* default */].setItem('rr', _this4.restrictedRoutes);
                localStorage.setItem('site_id', _this4.login.site_id);
                sessionStorage.setItem('sbc-token', res.headers.map.token[0]);
                _this4.config.headers['Authorization'] = sessionStorage.getItem('sbc-token');
                _this4.$router.push('/');
                _this4.loggedIn = true;
            }).catch(__WEBPACK_IMPORTED_MODULE_4__libs_api__["a" /* default */].errorHandler);
        },
        getVisibleTabItems: function getVisibleTabItems(items) {
            var _this5 = this;

            var site_id = this.login.site_id;

            if (Object.hasOwn(this.permittedSitesConfig, site_id)) {
                site_id = this.permittedSitesConfig['' + site_id];
            }

            var filteredItemsByCustomerSettings = items.filter(function (item) {
                var tabSetting = _this5.customerSettings.tabs.find(function (tab) {
                    return tab.route === item.route;
                });

                if (tabSetting) {
                    return tabSetting.isVisibleFor.includes(site_id.toString());
                }

                return true;
            });

            return filteredItemsByCustomerSettings;
        },
        loadCustomerSettings: function loadCustomerSettings() {
            var _this6 = this;

            var stories = this.$resource('https://api.storyblok.com/v2/cdn/stories/customer-settings');
            var version = 'published';

            if (isQaApiEndpoint) {
                version = 'draft';
            }

            stories.get({
                id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__libs_params__["a" /* default */])('_storyblok'),
                token: '7aJS9owJrpRWCa8d3iofRQtt',
                version: version,
                cv: Date.now()
            }).then(function (res) {
                _this6.customerSettings = res.body.story.content;
            });
        },
        loadConfig: function loadConfig(id) {
            var _this7 = this;

            var stories = this.$resource('https://api.storyblok.com/v2/cdn/stories/{id}');
            var version = 'published';

            if (isQaApiEndpoint) {
                version = 'draft';
            }

            stories.get({
                id: id || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__libs_params__["a" /* default */])('_storyblok'),
                token: '7aJS9owJrpRWCa8d3iofRQtt',
                version: version,
                cv: Date.now()
            }).then(function (res) {
                _this7.config.body = res.body.story.content.body;
                _this7.initRoute();
                _this7.firstRedirect = false;
            });
        },
        registerStoryblok: function registerStoryblok() {
            var _this8 = this;

            window.storyblok.init();

            window.storyblok.on('change', function () {
                _this8.loadConfig();
            });

            window.storyblok.on('published', function () {
                _this8.loadConfig();
            });

            window.storyblok.pingEditor(function () {
                if (window.storyblok.inEditor) {
                    window.storyblok.enterEditmode();
                }
            });
        },
        initRoute: function initRoute() {
            var _this9 = this;

            var first = this.config.body[0];
            if (this.firstRedirect && !this.isCustomerSupport()) {
                this.$router.push({
                    name: 'admin',
                    params: { model: first.route, id: 'all', action: 'index' }
                });
            } else if (this.firstRedirect && this.isCustomerSupport()) {
                this.$router.push({
                    name: 'admin',
                    params: { model: first.route, id: 'all', action: 'new' }
                });
            }

            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__libs_params__["a" /* default */])('storeblok')) {
                var url = 'https://' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__libs_params__["a" /* default */])('storeblok') + '/admin/users/get_api_provision';
                var api = this.$resource(url, {}, {}, { credentials: true });

                api.get().then(function (res) {
                    _this9.userRole = res.body.access;
                    __WEBPACK_IMPORTED_MODULE_5__libs_encryptStorage__["a" /* default */].setItem('ur', res.body.access);
                    sessionStorage.setItem('sbc-token', res.body.access_token);
                    _this9.config.headers['Authorization'] = res.body.access_token;

                    _this9.loading = false;
                    _this9.stripeRedirect();
                });
            } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__libs_params__["a" /* default */])('_storyblok')) {
                window.storyblok.getSession(function (data) {
                    sessionStorage.setItem('sbc-token', data.session.access_token);
                    _this9.config.headers['Authorization'] = data.session.access_token;
                    _this9.loading = false;
                    _this9.stripeRedirect();
                });
            } else {
                this.loading = false;
                this.stripeRedirect();
            }
        },
        stripeRedirect: function stripeRedirect() {
            if (window.location.search.indexOf('?stripe_connected=1') > -1) {
                this.$router.push({
                    name: 'admin',
                    params: { model: 'settings', id: 'all', action: 'index' }
                });
            }
        },
        handleSelect: function handleSelect(index) {
            this.$router.push({
                name: 'admin',
                params: { model: index, id: 'all', action: 'index' }
            });
        },
        getSettings: function getSettings() {
            var _this10 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                                    var api = _this10.$resource(_this10.config.endPoint + '/bulk_settings/{id}', {}, {}, { headers: _this10.config.headers });

                                    api.get({ id: 'mine' }).then(function (res) {
                                        _this10.loading = false;
                                        resolve(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__libs_settings__["a" /* default */])(res.data));
                                    });
                                }));

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this10);
            }))();
        },
        isCustomerSupport: function isCustomerSupport() {
            return this.userRole === 'CustomerSup';
        }
    }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['model', 'modelOrigin', 'settings', 'rootConfig', 'api'],

    data: function data() {
        return {
            origins: [],
            loading: true
        };
    },
    created: function created() {
        var _this = this;

        this.$resource(this.rootConfig.endPoint + '/origins', {}, {}, { headers: this.rootConfig.headers }).get().then(function (res) {
            _this.loading = false;
            _this.origins = res.data;
        });
    },


    methods: {
        isValidOrigin: function isValidOrigin(origin_id) {
            return this.origins.find(function (origin) {
                return origin.id === origin_id;
            });
        },
        getOriginName: function getOriginName(origin_id) {
            return this.origins.find(function (origin) {
                return origin.id === origin_id;
            }).name;
        },
        onSubmitOriginSetting: function onSubmitOriginSetting(id, setting) {
            var _this2 = this;

            var data = { id: id, setting: setting };
            this.$resource(this.rootConfig.endPoint + '/settings/{id}', {}, {}, { headers: this.rootConfig.headers }).update({ id: id }, data).then(function () {
                _this2.$message('Updated successfully');
            });
        }
    }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['value']
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_chartColors_definition_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_currency_js__ = __webpack_require__(56);





/* harmony default export */ __webpack_exports__["default"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bar"],
    props: ['data'],

    mounted: function mounted() {
        this.renderBarChart();
    },


    computed: {
        chartData: function chartData() {
            return this.data;
        }
    },

    watch: {
        data: function data() {
            if (this._chart) {
                this._chart.destroy();
            }
            this.renderBarChart();
        }
    },

    methods: {
        renderBarChart: function renderBarChart() {
            var _this = this;

            if (!this.data || this.data.types === undefined) {
                return;
            }

            var self = this;
            var datasets = this.data.types.map(function (type, i) {
                switch (type) {
                    case 'line':
                        return {
                            type: 'line',
                            label: _this.data.valueLabels[i] || [],
                            data: _this.data.values[i] || [],
                            cubicInterpolationMode: 'monotone',
                            tension: 0.4,
                            borderColor: '#000',
                            fill: false,
                            pointStyle: 'circle',
                            pointRadius: 5,
                            pointHoverRadius: 7,
                            backgroundColor: '000'
                        };
                    default:
                        return {
                            type: 'bar',
                            label: _this.data.valueLabels[i] || [],
                            data: _this.data.values[i] || [],
                            color: '#fff',
                            backgroundColor: __WEBPACK_IMPORTED_MODULE_1__libs_chartColors_definition_js__["a" /* default */][_this.data.showAverage ? i - 1 : i]
                        };
                }
            });

            this.renderChart({
                labels: this.data.labels || [],
                datasets: datasets
            }, {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        gridLines: {
                            display: true
                        },
                        stacked: true
                    }],
                    xAxes: [{
                        ticks: {
                            display: true
                        },
                        stacked: true
                    }]
                },
                legend: {
                    display: true
                },
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    callbacks: {
                        label: function label(tooltipItem, data) {
                            var datasetIndex = tooltipItem.datasetIndex;
                            var dataIndex = tooltipItem.index;
                            var tooltipData = data.datasets[datasetIndex];
                            var label = tooltipData.label;
                            var value = tooltipData.data[dataIndex];
                            switch (self.data.format) {
                                case 'CURRENCY':
                                    value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__libs_currency_js__["a" /* default */])(value, self.data.currency);
                                    break;
                            }
                            return label + ': ' + value;
                        }
                    },
                    backgroundColor: '#FFF',
                    titleFontColor: '#09b3af',
                    bodyFontColor: '#000',
                    borderColor: '#09b3af',
                    borderWidth: 1,
                    displayColors: false
                }
            });
        }
    }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chartjs_plugin_datalabels__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chartjs_plugin_datalabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chartjs_plugin_datalabels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_chartColors_definition_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_currency_js__ = __webpack_require__(56);






/* harmony default export */ __webpack_exports__["default"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Pie"],
    props: ['data'],

    mounted: function mounted() {
        this.renderPieChart();
    },


    computed: {
        chartData: function chartData() {
            return this.data;
        }
    },

    watch: {
        data: function data() {
            this._chart.destroy();
            this.renderPieChart();
        }
    },

    methods: {
        backgroundColor: function backgroundColor() {
            var _this = this;

            if (!this.data) {
                return '#09b3af';
            }

            if (this.data.isBestseller) {
                return this.data.values.map(function (e, i, data) {
                    if (i >= _this.data.isBestseller) {
                        return '#9ce0df';
                    }
                    return '#09b3af';
                });
            }

            return this.data.values.length <= __WEBPACK_IMPORTED_MODULE_2__libs_chartColors_definition_js__["a" /* default */].length ? __WEBPACK_IMPORTED_MODULE_2__libs_chartColors_definition_js__["a" /* default */] : '#09b3af';
        },
        renderPieChart: function renderPieChart() {
            var self = this;

            this.addPlugin(__WEBPACK_IMPORTED_MODULE_1_chartjs_plugin_datalabels___default.a);
            this.renderChart({
                labels: this.data && this.data.labels || [],
                datasets: [{
                    borderWidth: 1,
                    color: '#fff',
                    backgroundColor: this.backgroundColor(),
                    data: this.data && this.data.values || []
                }]
            }, {
                legend: {
                    display: false
                },
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    callbacks: {
                        title: function title(tooltipItem, data) {
                            return data['labels'][tooltipItem[0]['index']];
                        },
                        label: function label(tooltipItem, data) {
                            var value = data['datasets'][0]['data'][tooltipItem['index']];
                            var datapoints = self.data.values;
                            function totalSum(total, datapoint) {
                                return total + datapoint;
                            }
                            var totalValue = datapoints.reduce(totalSum, 0);
                            var percentageValue = value / totalValue * 100;
                            switch (self.data.format) {
                                case 'CURRENCY':
                                    value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__libs_currency_js__["a" /* default */])(value, self.data.currency);
                                    break;
                            }
                            return value + ' (' + percentageValue.toFixed(1) + '%)';
                        }
                    },
                    backgroundColor: '#FFF',
                    titleFontColor: '#09b3af',
                    bodyFontColor: '#000',
                    borderColor: '#09b3af',
                    borderWidth: 1,
                    displayColors: false
                },
                plugins: {
                    datalabels: {
                        formatter: function formatter(value, context) {
                            var datapoints = context.chart.data.datasets[0].data;
                            function totalSum(total, datapoint) {
                                return total + datapoint;
                            }
                            var totalValue = datapoints.reduce(totalSum, 0);
                            var percentageValue = value / totalValue * 100;
                            return percentageValue === 0 ? '' : percentageValue.toFixed(1) + '%';
                        },
                        color: 'white',
                        textAlign: 'center',
                        display: 'auto'
                    }
                }
            });
        }
    }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['value1', 'value2', 'description1', 'description2'],
    computed: {
        getPercentage1: function getPercentage1() {
            if (this.value1 === 0 && this.value2 === 0) {
                return 50 + '%';
            }
            return (this.value1 * 100 / (this.value1 + this.value2)).toFixed(1) + '%';
        },
        getPercentage2: function getPercentage2() {
            if (this.value1 === 0 && this.value2 === 0) {
                return 50 + '%';
            }
            return (this.value2 * 100 / (this.value1 + this.value2)).toFixed(1) + '%';
        }
    }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['value']
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'customer-registrations',
    props: ['config', 'rootConfig'],

    data: function data() {
        return {
            statisticsData: {},
            loading: false,
            dateRange: []
        };
    },


    watch: {
        dateRange: function dateRange() {
            if (this.dateRange && this.dateRange.length === 2) {
                this.loadStatistics();
            }
        }
    },

    methods: {
        loadStatistics: function loadStatistics() {
            var _this = this;

            this.loading = true;
            var startDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.dateRange[0]).toISOString(true);
            var endDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.dateRange[1]).toISOString(true);

            var apiResource = this.$resource(this.rootConfig.endPoint + '/reports/get_customer_registrations_count', {}, {}, {
                headers: this.rootConfig.headers,
                params: { start_date: startDate, end_date: endDate }
            });

            apiResource.get().then(function (res) {
                _this.statisticsData = res.body;
                _this.loading = false;
            }).catch(function () {
                _this.loading = false;
                __WEBPACK_IMPORTED_MODULE_0__libs_api__["a" /* default */].errorHandler;
            });
        }
    }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_api__ = __webpack_require__(5);




/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['config', 'rootConfig'],

    data: function data() {
        return {
            apiKeyData: [],
            loading: false,
            siteId: 0
        };
    },
    mounted: function mounted() {
        this.setApiKeys();
        this.loadApiKeys();
    },


    computed: {
        apiKeyResource: function apiKeyResource() {
            return this.$resource(this.rootConfig.endPoint + '/api_keys', {}, {}, { headers: this.rootConfig.headers });
        }
    },

    methods: {
        setApiKeys: function setApiKeys() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__libs_api__["a" /* default */].init = function (resource) {
                return _this.$resource(_this.rootConfig.endPoint + '/api_keys', {}, {}, { headers: _this.rootConfig.headers });
            };

            __WEBPACK_IMPORTED_MODULE_0__libs_api__["a" /* default */].res = __WEBPACK_IMPORTED_MODULE_0__libs_api__["a" /* default */].init(this.config.resource);
        },
        loadApiKeys: function loadApiKeys() {
            this.loading = true;
            this.apiKeyResource.get().then(this.setApiKeyData).catch(__WEBPACK_IMPORTED_MODULE_0__libs_api__["a" /* default */].errorHandler);
        },
        getHeader: function getHeader(res, header) {
            if (res.headers.map[header]) {
                return parseInt(res.headers.map[header][0]);
            }
            var lowerHeader = header.toLowerCase();
            if (res.headers.map[lowerHeader]) {
                return parseInt(res.headers.map[lowerHeader][0]);
            }
            return 0;
        },
        setApiKeyData: function setApiKeyData(res) {
            if (this.config.rootObject) {
                this.apiKeyData = res.body[this.config.rootObject];
            } else {
                this.apiKeyData = res.body;
            }

            this.siteId = this.apiKeyData[0].site_id;

            this.loading = false;
        }
    }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['value']
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['model', 'modelOrigin', 'rootConfig'],

    data: function data() {
        return {
            origins: [],
            loading: true
        };
    },
    created: function created() {
        var _this = this;

        this.$resource(this.rootConfig.endPoint + '/origins', {}, {}, { headers: this.rootConfig.headers }).get().then(function (res) {
            _this.loading = false;
            _this.origins = res.data;
        });
    },


    methods: {
        isValidOrigin: function isValidOrigin(origin_id) {
            return this.origins.find(function (origin) {
                return origin.id === origin_id;
            });
        },
        getOriginName: function getOriginName(origin_id) {
            return this.origins.find(function (origin) {
                return origin.id === origin_id;
            }).name;
        },
        onSubmitOriginSetting: function onSubmitOriginSetting(id, setting) {
            var _this2 = this;

            var data = { id: id, setting: setting };
            this.$resource(this.rootConfig.endPoint + '/settings/{id}', {}, {}, { headers: this.rootConfig.headers }).update({ id: id }, data).then(function () {
                _this2.$message('Updated successfully');
            });
        }
    }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['rootConfig'],

    data: function data() {
        return {
            api_keys: []
        };
    },


    computed: {
        public: function _public() {
            return this.api_keys.filter(function (key) {
                return key.access === 'public';
            })[0];
        },
        private: function _private() {
            return this.api_keys.filter(function (key) {
                return key.access === 'private';
            })[0];
        }
    },

    created: function created() {
        var _this = this;

        var api = this.$resource(this.rootConfig.endPoint + '/api_keys/{id}', {}, {}, { headers: this.rootConfig.headers });
        api.get().then(function (res) {
            _this.api_keys = res.body;
        });
    }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_api__ = __webpack_require__(5);




/* harmony default export */ __webpack_exports__["default"] = ({
    computed: {
        api: function api() {
            return this.$resource(this.rootConfig.endPoint + '/canned_messages/{id}', {}, {}, { headers: this.rootConfig.headers });
        },
        apiTranslated: function apiTranslated() {
            return this.$resource(this.rootConfig.endPoint + '/translations?per_page=500', {}, {}, { headers: this.rootConfig.headers });
        }
    },
    data: function data() {
        return {
            cannedMessages: [],
            loading: false,
            message: {
                subject: '',
                content: '',
                order_id: '',
                email: '',
                language: ''
            }
        };
    },

    watch: {
        model: function model() {
            this.message.email = this.model.email;
            this.message.order_id = this.model.id;
        }
    },
    props: ['model', 'config', 'rootConfig'],
    created: function created() {
        var _this = this;

        this.api.get().then(function (res) {
            _this.cannedMessages = res.data;

            _this.apiTranslated.get().then(function (res) {
                var translatedMessages = res.data;

                if (translatedMessages) {
                    var content = translatedMessages.filter(function (tm) {
                        return tm.key === 'content';
                    });
                    var subjectMessages = translatedMessages.filter(function (tm) {
                        return tm.key === 'subject';
                    });

                    var data = content.filter(function (co) {
                        return subjectMessages.filter(function (sm) {
                            if (sm.foreign_id === co.foreign_id && sm.language === co.language) {
                                co.subject = sm.body;
                                var message = _this.cannedMessages.filter(function (cm) {
                                    return cm.id === co.foreign_id;
                                });
                                co.name = message.length > 0 ? co.language.toUpperCase() + ': ' + message[0].name : co.id;
                            }
                        });
                    });

                    data.forEach(function (element) {
                        _this.cannedMessages.push({
                            content: element.body,
                            name: element.name,
                            subject: element.subject,
                            id: element.id,
                            language: element.language
                        });
                    });
                }
            });
        });
    },

    methods: {
        send: function send() {
            var _this2 = this;

            var mailApi = this.$resource(this.rootConfig.endPoint + '/mails/{id}', {}, {}, { headers: this.rootConfig.headers });

            this.loading = true;

            mailApi.save(this.message).then(function (res) {
                _this2.$message('Message sent successfully');
                _this2.loading = false;
            }).catch(function (res) {
                __WEBPACK_IMPORTED_MODULE_0__libs_api__["a" /* default */].errorHandler(res);
                _this2.loading = false;
            });
        },
        updateCannedMsg: function updateCannedMsg(val) {
            var msgs = this.cannedMessages.filter(function (item) {
                return item.id === val;
            });

            if (msgs.length > 0) {
                this.message.content = msgs[0].content;
                this.message.subject = msgs[0].subject;
                this.message.language = msgs[0].language;
            }
        }
    }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fields_Select_vue__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fields_Select_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fields_Select_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_download__ = __webpack_require__(43);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'order_detail',
    props: ['model', 'rootConfig', 'siteId', 'permittedSitesConfig'],

    data: function data() {
        return {
            statuses: [{ value: 'Open', label: 'Open' }, { value: 'Pending', label: 'Pending' }, { value: 'Processing', label: 'Processing' }, { value: 'Shipped', label: 'Shipped' }, { value: 'On Hold', label: 'On Hold' }, { value: 'Cancelled', label: 'Cancelled' }, { value: 'Not Payed', label: 'Not Payed' }, { value: 'Returned', label: 'Returned' }, { value: 'Delivered', label: 'Delivered' }],
            customer_id: null,
            showInvoice: false,
            invoiceCustomer: '',
            invoiceToken: '',
            invoiceLoading: false,
            sendInvoiceLoading: false,
            invoiceEmailEndpoint: undefined
        };
    },


    components: {
        'v-crud-select': __WEBPACK_IMPORTED_MODULE_4__fields_Select_vue___default.a
    },

    computed: {
        isVisible: function isVisible() {
            var site_id = this.siteId;

            if (Object.hasOwn(this.permittedSitesConfig, site_id)) {
                site_id = this.permittedSitesConfig['' + site_id];
            }

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(this.permittedSitesConfig).includes(Number(site_id));
        },
        hasSku: function hasSku() {
            if (this.model && this.model.order_items && this.model.order_items[0].sku !== null) {
                return true;
            }
            return false;
        },
        apiResource: function apiResource() {
            return this.$resource(this.rootConfig.endPoint + '/customers', {}, {}, { headers: this.rootConfig.headers });
        }
    },

    created: function created() {
        var _this = this;

        var apiResource = this.$resource(this.rootConfig.endPoint + '/settings?per_page=500', {}, {}, { headers: this.rootConfig.headers });

        apiResource.get().then(function (res) {
            res.data.forEach(function (setting) {
                if (setting.code === 'general_setting' && setting.setting_key === 'order_invoice' && setting.setting === '1') {
                    _this.showInvoice = true;
                }

                if (setting.code === 'general_setting' && setting.setting_key === 'order_invoice_customer') {
                    _this.invoiceCustomer = setting.setting;
                }

                if (setting.code === 'general_setting' && setting.setting_key === 'order_invoice_token') {
                    _this.invoiceToken = setting.setting;
                }

                if (setting.code === 'general_setting' && setting.setting_key === 'invoice_email_endpoint') {
                    _this.invoiceEmailEndpoint = setting.setting;
                }
            });
        }).catch(__WEBPACK_IMPORTED_MODULE_5__libs_api__["a" /* default */].errorHandler);
    },


    methods: {
        onChangeInput: function onChangeInput(value) {
            this.model.status = value;
            this.save();
            var tabMessages = document.getElementById('tab-1');
            if (tabMessages) {
                setTimeout(function () {
                    return tabMessages.click();
                }, 500);
            }
        },
        isDynamicPackage: function isDynamicPackage(properties) {
            return properties.filter(function (property) {
                return property.slug === 'dynamicPackage';
            }).length > 0;
        },
        isDynamicPricePackage: function isDynamicPricePackage(properties) {
            return properties.filter(function (property) {
                return property.slug === 'dynamicPricePackage';
            }).length > 0;
        },
        goToCustomer: function goToCustomer() {
            this.$router.push({
                name: 'admin',
                params: {
                    id: this.model.customer_id,
                    action: 'edit',
                    model: 'customers'
                }
            });
        },
        save: function save() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_5__libs_api__["a" /* default */].res.update({ id: this.model.id }, this.model).then(function () {
                _this2.$message('Updated successfully');
            }).catch(__WEBPACK_IMPORTED_MODULE_5__libs_api__["a" /* default */].errorHandler);
        },
        getInvoicePdf: function getInvoicePdf() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var url, taxRates, data;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this3.invoiceLoading = true;
                                url = 'https://pdf-service.netural.com/render/' + _this3.model.language + '/' + _this3.invoiceCustomer + '/invoice?token=' + _this3.invoiceToken;
                                _context.next = 4;
                                return _this3.getTaxRates();

                            case 4:
                                taxRates = _context.sent;
                                data = {
                                    order: _this3.model,
                                    tax_rates: taxRates
                                };


                                _this3.$http.post(url, data, { responseType: 'blob' }).then(function (res) {
                                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__libs_download__["a" /* default */])(res.data, _this3.invoiceCustomer + '-invoice-' + _this3.model.order_number + '.pdf', 'application/pdf');
                                    _this3.invoiceLoading = false;
                                    console.log(res);
                                }, function (err) {
                                    _this3.invoiceLoading = false;
                                    console.log(err);
                                    __WEBPACK_IMPORTED_MODULE_5__libs_api__["a" /* default */].errorHandler.call(_this3, err);
                                });

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            }))();
        },
        sendInvoicePdf: function sendInvoicePdf() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var taxRates, postData;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!_this4.invoiceEmailEndpoint) {
                                    _context2.next = 7;
                                    break;
                                }

                                _context2.next = 3;
                                return _this4.getTaxRates();

                            case 3:
                                taxRates = _context2.sent;


                                _this4.sendInvoiceLoading = true;

                                postData = {
                                    order: _this4.model,
                                    tax_rates: taxRates
                                };


                                _this4.$http.post(_this4.invoiceEmailEndpoint, postData, {
                                    headers: _this4.rootConfig.headers
                                }).then(function (res) {
                                    _this4.$message({
                                        message: 'Message sent successfully',
                                        type: 'success'
                                    });
                                    _this4.sendInvoiceLoading = false;
                                }).catch(function (error) {
                                    _this4.sendInvoiceLoading = false;
                                    _this4.$message({
                                        message: 'Oh no! Sending the invoice failed.',
                                        type: 'error'
                                    });
                                    console.log(error);
                                });

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this4);
            }))();
        },
        getTaxRates: function getTaxRates() {
            var _this5 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                var apiResource = _this5.$resource(_this5.rootConfig.endPoint + '/tax_rates', {}, {}, { headers: _this5.rootConfig.headers });

                apiResource.get().then(function (res) {
                    resolve(res.data);
                }).catch(__WEBPACK_IMPORTED_MODULE_5__libs_api__["a" /* default */].errorHandler);
            });
        }
    }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['model', 'settings', 'api', 'rootConfig'],

    data: function data() {
        return {
            loading: false,
            gotUrl: false,
            url: ''
        };
    },


    computed: {
        userIsConnected: function userIsConnected() {
            var settings = this.settings.filter(function (item) {
                return item.code === 'stripe' && item.setting_key === 'user' && item.setting;
            });

            return settings.length > 0;
        }
    },

    methods: {
        install: function install(method, _initial) {
            var _this = this;

            var data = {};
            var initial = { enabled: '0' };
            data[method] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _initial, initial);
            data.payment_modules = {};
            data.payment_modules[method] = '0';

            this.api.update({ id: 'mine' }, data).then(function (res) {
                _this.$emit('updated', res.data);
                _this.$message('Updated successfully');
            });
        },
        disconnect: function disconnect() {
            window.open(this.rootConfig.endPoint.replace('/v1', '') + '/connect/deauthorize', '_blank', 'toolbar=0,location=0,menubar=0');
        },
        connectStripe: function connectStripe() {
            var _this2 = this;

            var authApi = this.$resource(this.rootConfig.endPoint.replace('/v1', '') + '/connect/{action}', {}, {}, { credentials: true, headers: this.rootConfig.headers });

            this.gotUrl = false;
            this.loading = true;

            authApi.get({ action: 'oauth' }).then(function (res) {
                _this2.loading = false;
                _this2.gotUrl = true;
                _this2.url = res.data.url;
            }).catch(function (res) {
                _this2.$message('Something went wrong. Please try again.');
            });
        }
    }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['value']
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_download__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChartBarAndLine__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChartBarAndLine___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ChartBarAndLine__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_chartColors_definition_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_chartData_helper_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ChartPie__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ChartPie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ChartPie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_report_definition_js__ = __webpack_require__(91);












/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'reports',
    props: ['config', 'rootConfig'],
    components: { ChartBarAndLine: __WEBPACK_IMPORTED_MODULE_3__ChartBarAndLine___default.a, ChartPie: __WEBPACK_IMPORTED_MODULE_6__ChartPie___default.a },

    data: function data() {
        return {
            reportData: [],
            loading: false,
            exporting: false,
            dateRange: [],
            title: '',
            definition: null,
            options: [],
            selectedReport: '',
            reportFilterOptions: [],
            selectedFilter: '',
            chartData: {},
            chartColors: [],
            groupBy: 'day',
            filterOptions: {
                products: [],
                categories: [],
                origin: [],
                customerGroup: [],
                gender: [{ label: 'All', value: 'All' }, { label: 'Male', value: false }, { label: 'Female', value: true }],
                status: [],
                payment: [],
                coupon: [{ label: 'All', value: 'All' }, { label: 'With coupon', value: true }, { label: 'Without coupon', value: false }]
            },
            filterOptionsDefinition: [{ name: 'categories', endpoint: 'get_categories_filter' }, {
                name: 'origin',
                endpoint: 'get_filter_origin_list'
            }, {
                name: 'customerGroup',
                endpoint: 'get_customer_groups_filter'
            }, { name: 'status', endpoint: 'get_statuses_filter' }, { name: 'payment', endpoint: 'get_payments_filter' }],
            filterResults: {
                products: [],
                categories: [],
                origin: 'All',
                customerGroup: 'All',
                gender: 'All',
                status: [],
                payment: [],
                coupon: 'All'
            },
            defaultCurrency: null
        };
    },
    mounted: function mounted() {
        this.chartColors = __WEBPACK_IMPORTED_MODULE_4__libs_chartColors_definition_js__["a" /* default */];
        this.loadFilterOptions();
        this.getDefaultCurrency();
        this.init();
    },


    watch: {
        dateRange: function dateRange() {
            this.startLoading();
        },
        groupBy: function groupBy() {
            this.startLoading();
        },


        filterResults: {
            handler: function handler() {
                this.startLoading();
            },

            deep: true
        }
    },

    methods: {
        getDefaultCurrency: function getDefaultCurrency() {
            var _this = this;

            this.loading = true;
            var apiResource = this.$resource(this.rootConfig.endPoint + '/settings', {}, {}, {
                headers: this.rootConfig.headers
            });
            apiResource.get({
                code: 'general_setting',
                setting_key: 'default_currency'
            }).then(function (res) {
                if (res.body.length > 0) {
                    _this.defaultCurrency = res.body[0].setting;
                }
                _this.loading = false;
            }).catch(function () {
                _this.loading = false;
                __WEBPACK_IMPORTED_MODULE_1__libs_api__["a" /* default */].errorHandler;
            });
        },
        init: function init() {
            this.selectedReport = this.config.id;
            this.definition = __WEBPACK_IMPORTED_MODULE_8__libs_report_definition_js__["a" /* default */][this.selectedReport];

            if (this.definition) {
                this.title = this.definition.title || 'Detail';
                this.reportFilterOptions = this.definition.table.filter(function (e) {
                    return e.filterable;
                }).map(function (e) {
                    return { value: e.key, label: e.label };
                });
                this.selectedFilter = this.definition.filterPreselect || this.reportFilterOptions[0].value;

                if (this.dateRange && this.dateRange.length === 2) {
                    this.reportData = [];
                    this.loadOverview();
                }
            }

            this.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__libs_report_definition_js__["a" /* default */]).map(function (key) {
                return { value: key, label: __WEBPACK_IMPORTED_MODULE_8__libs_report_definition_js__["a" /* default */][key].title };
            });
        },
        loadOverview: function loadOverview() {
            var _this2 = this;

            this.loading = true;
            var startDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.dateRange[0]).toISOString(true);
            var endDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.dateRange[1]).toISOString(true);

            var apiResource = this.$resource(this.rootConfig.endPoint + '/reports/' + this.definition.api, {}, {}, {
                headers: this.rootConfig.headers,
                params: {
                    start_date: startDate,
                    end_date: endDate,
                    group_by: this.groupBy,
                    filter_products: this.filterResults.products,
                    filter_categories: this.filterResults.categories,
                    filter_origin: this.filterResults.origin,
                    filter_group: this.filterResults.customerGroup,
                    filter_gender: this.filterResults.gender,
                    filter_status: this.filterResults.status,
                    filter_payment: this.filterResults.payment,
                    filter_coupons: this.filterResults.coupon
                }
            });

            apiResource.get().then(this.setReportData).catch(function () {
                _this2.loading = false;
                __WEBPACK_IMPORTED_MODULE_1__libs_api__["a" /* default */].errorHandler;
            });
        },
        setReportData: function setReportData(res) {
            var _this3 = this;

            var reportData = res.body;
            reportData = reportData.map(function (e) {
                if (e.date && _this3.groupBy) {
                    switch (_this3.groupBy) {
                        case 'month':
                            e.date = __WEBPACK_IMPORTED_MODULE_7_moment___default()(String(e.date)).format('M.YYYY');
                            break;
                        case 'year':
                            e.date = __WEBPACK_IMPORTED_MODULE_7_moment___default()(String(e.date)).format('YYYY');
                            break;
                        default:
                            e.date = __WEBPACK_IMPORTED_MODULE_7_moment___default()(String(e.date)).format('D.M.YYYY');
                    }
                }
                return e;
            });
            this.reportData = reportData;
            this.filterReport(this.selectedFilter);
            this.loading = false;
        },
        onBack: function onBack() {
            this.$router.push({ name: 'home' });
        },
        onExport: function onExport() {
            var _this4 = this;

            this.exporting = true;

            var startDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.dateRange[0]).toISOString(true);
            var endDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.dateRange[1]).toISOString(true);

            var apiResource = this.$resource(this.rootConfig.endPoint + '/reports/' + this.definition.api, {}, {}, {
                headers: this.rootConfig.headers,
                responseType: 'blob',
                params: {
                    start_date: startDate,
                    end_date: endDate,
                    group_by: this.groupBy,
                    filter_products: this.filterResults.products,
                    filter_categories: this.filterResults.categories,
                    filter_origin: this.filterResults.origin,
                    filter_group: this.filterResults.customerGroup,
                    filter_gender: this.filterResults.gender,
                    filter_status: this.filterResults.status,
                    filter_payment: this.filterResults.payment,
                    filter_coupons: this.filterResults.coupon,
                    as_excel: true
                }
            });

            apiResource.get().then(function (res) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__libs_download__["a" /* default */])(res.data, 'statistics.xls', 'application/vnd.ms-excel');
                _this4.exporting = false;
            }).catch(function () {
                _this4.exporting = false;
                __WEBPACK_IMPORTED_MODULE_1__libs_api__["a" /* default */].errorHandler;
            });
        },
        navigateTo: function navigateTo(id) {
            this.config.id = id;
            this.$router.push({
                name: 'admin',
                params: { model: 'report', id: id, action: 'all' }
            });
            this.init();
        },
        filterReport: function filterReport(type) {
            var data = this.reportData;
            if (this.selectedReport === 'best_seller') {
                data = this.reportData.sort(function (a, b) {
                    if (a.sku && a.sku === '000000') {
                        return 1;
                    }
                    return b[type] - a[type];
                });
            }
            this.chartData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__libs_chartData_helper_js__["a" /* default */])(type, data, this.definition, this.selectedReport, this.reportData[0].currency ? this.reportData[0].currency : this.defaultCurrency);
        },
        startLoading: function startLoading() {
            if (this.definition.api) {
                if (this.dateRange && this.dateRange.length === 2) {
                    this.loadOverview();
                }
            } else {
                this.loading = false;
            }
        },
        getProductsBySearch: function getProductsBySearch(query) {
            var _this5 = this;

            var apiResource = this.$resource(this.rootConfig.endPoint + '/products', {}, {}, {
                headers: this.rootConfig.headers
            });

            if (query && query.length > 2) {
                this.loading = true;
                apiResource.get({ term: query }).then(function (res) {
                    _this5.loading = false;
                    var mappedData = [];
                    res.data.forEach(function (entry) {
                        mappedData.push({
                            label: entry.name,
                            value: entry.sku
                        });
                    });
                    _this5.filterOptions.products = mappedData;
                }).catch(function () {
                    _this5.loading = false;
                    __WEBPACK_IMPORTED_MODULE_1__libs_api__["a" /* default */].errorHandler;
                });
            } else {
                this.filterOptions.products = [];
            }
        },
        loadFilterOptions: function loadFilterOptions() {
            var _this6 = this;

            this.loading = true;

            this.filterOptionsDefinition.forEach(function (filterOption) {
                var apiResource = _this6.$resource(_this6.rootConfig.endPoint + '/reports/' + filterOption.endpoint, {}, {}, { headers: _this6.rootConfig.headers });

                apiResource.get().then(function (res) {
                    var mappedData = [];
                    if (filterOption.name === 'customerGroup' || filterOption.name === 'origin') {
                        mappedData.push({ label: 'All', value: 'All' });
                    }
                    res.data.forEach(function (entry) {
                        if (filterOption.name !== 'categories') {
                            mappedData.push({
                                label: entry ? entry[0].toUpperCase() + entry.slice(1).toLowerCase() : 'Undefined',
                                value: entry
                            });
                        } else {
                            mappedData.push({
                                label: entry.name,
                                value: entry.id
                            });
                        }
                    });
                    _this6.filterOptions['' + filterOption.name] = mappedData;
                    _this6.loading = false;
                }).catch(function () {
                    _this6.loading = false;
                    __WEBPACK_IMPORTED_MODULE_1__libs_api__["a" /* default */].errorHandler;
                });
            });
        }
    }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChartBarAndLine__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChartBarAndLine___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ChartBarAndLine__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_chartData_helper_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChartPie__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChartPie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ChartPie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_report_definition_js__ = __webpack_require__(91);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'reports',
    props: ['config', 'rootConfig'],
    components: { ChartBarAndLine: __WEBPACK_IMPORTED_MODULE_1__ChartBarAndLine___default.a, ChartPie: __WEBPACK_IMPORTED_MODULE_3__ChartPie___default.a },

    data: function data() {
        return {
            reportData: {},
            loading: false,
            dateRange: []
        };
    },


    watch: {
        dateRange: function dateRange() {
            if (this.dateRange && this.dateRange.length === 2) {
                this.loadOverview();
            }
        }
    },

    computed: {
        getBestsellerData: function getBestsellerData() {
            var values = this.reportData.best_sellers.map(function (e) {
                return e.quantity;
            });
            var labels = this.reportData.best_sellers.map(function (e) {
                return e.sku + ' - ' + e.name;
            });
            return { labels: labels, values: values, isBestseller: 5 };
        },
        getOrderDetailsData: function getOrderDetailsData() {
            var data = this.reportData.order_details.map(function (e) {
                if (e.date) {
                    e.date = __WEBPACK_IMPORTED_MODULE_4_moment___default()(String(e.date)).format('D.M.YYYY');
                }
                return e;
            });
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__libs_chartData_helper_js__["a" /* default */])('total', data, __WEBPACK_IMPORTED_MODULE_5__libs_report_definition_js__["a" /* default */]['order_details'], null, this.reportData.order_details[0].currency);
        }
    },

    methods: {
        loadOverview: function loadOverview() {
            var _this = this;

            this.loading = true;
            var startDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.dateRange[0]).toISOString(true);
            var endDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.dateRange[1]).toISOString(true);

            var apiResource = this.$resource(this.rootConfig.endPoint + '/reports/get_overview', {}, {}, {
                headers: this.rootConfig.headers,
                params: { start_date: startDate, end_date: endDate }
            });

            apiResource.get().then(this.setReportData).catch(function () {
                _this.loading = false;
                __WEBPACK_IMPORTED_MODULE_0__libs_api__["a" /* default */].errorHandler;
            });
        },
        setReportData: function setReportData(res) {
            this.reportData = res.body;
            this.loading = false;
        },
        navigateToDetail: function navigateToDetail(id) {
            this.$router.push({
                name: 'admin',
                params: { model: 'report', id: id, action: 'all' }
            });
        },
        showDetailChart: function showDetailChart() {
            var detailData = this.getOrderDetailsData;
            return detailData && detailData.values && detailData.values.length > 0 && detailData.values[0].length > 0 && !detailData.values.every(function (e) {
                return e.every(function (d) {
                    return d === 0;
                });
            });
        }
    }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_settings__ = __webpack_require__(92);





/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['config', 'rootConfig'],

    data: function data() {
        return {
            activeTab: '0',
            api: null,
            loading: true,
            model: {},
            settingValues: {},
            settings: [],
            modelOrigin: {}
        };
    },


    computed: {
        hideSave: function hideSave() {
            return this.config.formFields[this.activeTab].hideSave;
        }
    },

    created: function created() {
        var _this = this;

        this.api = this.$resource(this.rootConfig.endPoint + '/bulk_settings/{id}', {}, {}, { headers: this.rootConfig.headers });

        this.api.get({ id: 'mine' }).then(function (res) {
            _this.loading = false;
            _this.assignSettings(res.data);
        });
    },


    methods: {
        assignSettings: function assignSettings(resData) {
            this.settings = resData;
            this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_settings__["a" /* default */])(resData));
            this.modelOrigin = resData.filter(function (data) {
                return typeof data.origin_id == 'number';
            }).sort(function (a, b) {
                return a.origin_id - b.origin_id;
            });
        },
        onSubmit: function onSubmit() {
            var _this2 = this;

            this.api.update({ id: 'mine' }, this.model).then(function (res) {
                _this2.$message('Updated successfully');
            });
        }
    }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__libs_api__ = __webpack_require__(5);








var _methods;



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['model', 'settings', 'api', 'rootConfig'],

    data: function data() {
        return {
            activeRateGroup: '-1',
            activeDiscount: '-1',
            shiprules: [],
            tablerates: [],
            countries: [],
            zones: [],
            fetchedZones: [],
            isFetchingZones: false
        };
    },
    created: function created() {
        this.loadCountries();
        this.setShipRules();
        this.setTableRates();
    },


    watch: {
        settings: function settings() {
            this.loadCountries();
            this.setShipRules();
            this.setTableRates();
        }
    },
    computed: {
        mappedZones: function mappedZones() {
            if (!this.zones.length) {
                return {};
            }

            var mappedZones = {};

            this.zones.forEach(function (zone) {
                if (mappedZones.hasOwnProperty(zone.country_id)) {
                    mappedZones[zone.country_id].push(zone);
                } else {
                    mappedZones[zone.country_id] = [];
                    mappedZones[zone.country_id].push(zone);
                }
            });
            return mappedZones;
        }
    },
    methods: (_methods = {
        loadCountries: function loadCountries() {
            var _this = this;

            var countries = this.$resource(this.rootConfig.endPoint + '/countries/{id}', {}, {}, { headers: this.rootConfig.headers });

            countries.get().then(function (res) {
                _this.countries = res.data;
            }).catch(__WEBPACK_IMPORTED_MODULE_7__libs_api__["a" /* default */].errorHandler);
        },
        initZones: function initZones() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, shipRule, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, loc;

                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context.prev = 3;
                                _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(_this2.shiprules);

                            case 5:
                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                    _context.next = 36;
                                    break;
                                }

                                shipRule = _step.value;
                                _iteratorNormalCompletion2 = true;
                                _didIteratorError2 = false;
                                _iteratorError2 = undefined;
                                _context.prev = 10;
                                _iterator2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(shipRule.location);

                            case 12:
                                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                                    _context.next = 19;
                                    break;
                                }

                                loc = _step2.value;
                                _context.next = 16;
                                return _this2.fetchZones(loc.country);

                            case 16:
                                _iteratorNormalCompletion2 = true;
                                _context.next = 12;
                                break;

                            case 19:
                                _context.next = 25;
                                break;

                            case 21:
                                _context.prev = 21;
                                _context.t0 = _context['catch'](10);
                                _didIteratorError2 = true;
                                _iteratorError2 = _context.t0;

                            case 25:
                                _context.prev = 25;
                                _context.prev = 26;

                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }

                            case 28:
                                _context.prev = 28;

                                if (!_didIteratorError2) {
                                    _context.next = 31;
                                    break;
                                }

                                throw _iteratorError2;

                            case 31:
                                return _context.finish(28);

                            case 32:
                                return _context.finish(25);

                            case 33:
                                _iteratorNormalCompletion = true;
                                _context.next = 5;
                                break;

                            case 36:
                                _context.next = 42;
                                break;

                            case 38:
                                _context.prev = 38;
                                _context.t1 = _context['catch'](3);
                                _didIteratorError = true;
                                _iteratorError = _context.t1;

                            case 42:
                                _context.prev = 42;
                                _context.prev = 43;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 45:
                                _context.prev = 45;

                                if (!_didIteratorError) {
                                    _context.next = 48;
                                    break;
                                }

                                throw _iteratorError;

                            case 48:
                                return _context.finish(45);

                            case 49:
                                return _context.finish(42);

                            case 50:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2, [[3, 38, 42, 50], [10, 21, 25, 33], [26,, 28, 32], [43,, 45, 49]]);
            }))();
        },
        getZonesOnSelectChange: function getZonesOnSelectChange(event) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this3.isFetchingZones = true;
                                _context2.prev = 1;
                                _context2.next = 4;
                                return _this3.fetchZones(event.target.value);

                            case 4:
                                _context2.prev = 4;

                                _this3.isFetchingZones = false;
                                return _context2.finish(4);

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3, [[1,, 4, 7]]);
            }))();
        }
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getZonesOnSelectChange', function getZonesOnSelectChange(event) {
        this.fetchZones(event.target.value);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'fetchZones', function fetchZones(country_id) {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var zones, res;
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            if (_this4.fetchedZones.includes(country_id)) {
                                _context3.next = 17;
                                break;
                            }

                            _this4.isFetchingZones = true;
                            zones = _this4.$resource(_this4.rootConfig.endPoint + ('/country_zones?country_id=' + country_id), {}, {}, { headers: _this4.rootConfig.headers });
                            _context3.prev = 3;
                            _context3.next = 6;
                            return zones.get();

                        case 6:
                            res = _context3.sent;

                            _this4.fetchedZones.push(country_id);
                            _this4.zones = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(_this4.zones), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(res.data));
                            _context3.next = 14;
                            break;

                        case 11:
                            _context3.prev = 11;
                            _context3.t0 = _context3['catch'](3);

                            __WEBPACK_IMPORTED_MODULE_7__libs_api__["a" /* default */].errorHandler(_context3.t0);

                        case 14:
                            _context3.prev = 14;

                            _this4.isFetchingZones = false;
                            return _context3.finish(14);

                        case 17:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this4, [[3, 11, 14, 17]]);
        }))();
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'setTableRates', function setTableRates() {
        var settings = this.settings.filter(function (item) {
            return item.code === 'table_rate' && item.setting_key === 'rates';
        });

        if (settings.length) {
            this.tablerates = JSON.parse(settings[0].setting);
        } else {
            this.tablerates = [];
        }
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'setShipRules', function setShipRules() {
        var settings = this.settings.filter(function (item) {
            return item.code === 'shiprules';
        });

        if (settings.length) {
            this.shiprules = JSON.parse(settings[0].setting);
        } else {
            this.shiprules = [];
        }

        this.initZones();
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'removeLocation', function removeLocation(ruleIndex, index) {
        this.shiprules[ruleIndex].location.splice(index, 1);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'removeShipDiscount', function removeShipDiscount(index) {
        this.shiprules.splice(index, 1);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'addLocation', function addLocation(ruleIndex) {
        this.shiprules[ruleIndex].location.push({
            country: '',
            zone: '',
            city: '',
            bairro: ''
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'addRateGroup', function addRateGroup() {
        this.tablerates.unshift({
            name: 'Shipping method name',
            country: '',
            max_weight: '',
            time: '',
            method: 'weight',
            rates: [{ from: '0', rate: '0' }]
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'removeRateGroup', function removeRateGroup(index) {
        this.tablerates.splice(index, 1);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'removeRate', function removeRate(rateIndex, item) {
        var index = this.tablerates[rateIndex].rates.indexOf(item);
        if (index !== -1) {
            this.tablerates[rateIndex].rates.splice(index, 1);
        }
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'addRate', function addRate(rateIndex) {
        this.tablerates[rateIndex].rates.push({
            from: '0',
            rate: '0'
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'addDiscount', function addDiscount() {
        this.shiprules.unshift({
            name: 'Rulename',
            discounted_shipping: '0',
            free_shipping: '0',
            location: []
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'save', function save(data) {
        var _this5 = this;

        this.api.update({ id: 'mine' }, data).then(function (res) {
            _this5.$emit('updated', res.data);
            _this5.$message('Updated successfully');
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'saveTableRate', function saveTableRate() {
        var data = {
            shipping_modules: { table_rate: '0' },
            table_rate: {
                enabled: this.model.table_rate.enabled,
                rates: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.tablerates)
            }
        };
        this.save(data);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'saveFlatRate', function saveFlatRate() {
        var data = {
            shipping_modules: { flatrate: '0' },
            flatrate: {
                enabled: this.model.flatrate.enabled
            }
        };
        this.save(data);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'saveFedex', function saveFedex() {
        var data = {
            shipping_modules: { fedex: '0' },
            fedex: {
                enabled: this.model.fedex.enabled
            }
        };
        this.save(data);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'saveDiscounts', function saveDiscounts() {
        var data = {
            shiprules: { rates: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.shiprules) }
        };
        this.save(data);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'shippingModuleIsInstalled', function shippingModuleIsInstalled(shippingModule) {
        if (this.model.shipping_modules && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.model.shipping_modules).includes(shippingModule)) {
            return true;
        }
        return false;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'savePropertyRelatedFreeShipping', function savePropertyRelatedFreeShipping() {
        var data = {
            shipping_discounts: { property: this.model.shipping_discounts.property }
        };
        this.save(data);
    }), _methods)
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['value']
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VueCrudIndex_vue__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VueCrudIndex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__VueCrudIndex_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VueCrudEdit_vue__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VueCrudEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__VueCrudEdit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VueCrudNew_vue__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VueCrudNew_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__VueCrudNew_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VueCrudPrint_vue__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VueCrudPrint_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__VueCrudPrint_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_wysiwyg_dist_vueWysiwyg_css__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_wysiwyg_dist_vueWysiwyg_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_wysiwyg_dist_vueWysiwyg_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_en__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_en__);












__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_en___default.a });

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'v-crud',

    props: ['model', 'config', 'rootConfig', 'action', 'id', 'siteId', 'permittedSitesConfig'],

    data: function data() {
        return {
            activeComponent: 'v-crud-index',
            params: {}
        };
    },


    components: {
        'v-crud-index': __WEBPACK_IMPORTED_MODULE_2__VueCrudIndex_vue___default.a,
        'v-crud-new': __WEBPACK_IMPORTED_MODULE_4__VueCrudNew_vue___default.a,
        'v-crud-edit': __WEBPACK_IMPORTED_MODULE_3__VueCrudEdit_vue___default.a,
        'v-crud-print': __WEBPACK_IMPORTED_MODULE_5__VueCrudPrint_vue___default.a
    },

    watch: {
        action: function action() {
            this.activeComponent = 'v-crud-' + this.action;
        },
        model: function model() {
            this.setApi();
        }
    },

    created: function created() {
        this.setApi();
        this.activeComponent = 'v-crud-' + this.action;
    },


    methods: {
        setApi: function setApi() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_6__libs_api__["a" /* default */].init = function (resource) {
                return _this.$resource(_this.rootConfig.endPoint + '/' + resource, {}, {}, { headers: _this.rootConfig.headers });
            };

            __WEBPACK_IMPORTED_MODULE_6__libs_api__["a" /* default */].res = __WEBPACK_IMPORTED_MODULE_6__libs_api__["a" /* default */].init(this.config.resource);
        }
    }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_download__ = __webpack_require__(43);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'v-crud-edit',

    props: ['config', 'rootConfig', 'params', 'id', 'siteId', 'permittedSitesConfig'],

    data: function data() {
        return {
            model: {},
            activeTab: '0',
            loading: false
        };
    },


    watch: {
        '$route.params.model': function $routeParamsModel() {
            this.loadData();
        }
    },

    mounted: function mounted() {
        this.loadData();
    },


    methods: {
        loadData: function loadData() {
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__libs_api__["a" /* default */].res.get({ id: this.id }).then(this.setModelData).catch(__WEBPACK_IMPORTED_MODULE_0__libs_api__["a" /* default */].errorHandler);
        },
        onSubmit: function onSubmit() {
            var _this = this;

            var params = {};

            if (this.config.singleRootObject) {
                params[this.config.singleRootObject] = this.model;
            } else {
                params = this.model;
            }

            params = this.handleAttachments(params);

            __WEBPACK_IMPORTED_MODULE_0__libs_api__["a" /* default */].res.update({ id: this.id }, params).then(function () {
                _this.$router.push({
                    name: 'admin',
                    params: { id: 'all', action: 'index' }
                });
            }).catch(__WEBPACK_IMPORTED_MODULE_0__libs_api__["a" /* default */].errorHandler);
        },
        handleAttachments: function handleAttachments(params) {
            if (params.hasOwnProperty('attachments')) {
                if (params.attachments.length > 0) {
                    params.attachments = params.attachments.split('\n');
                } else {
                    params.attachments = [];
                }
            }

            return params;
        },
        setModelData: function setModelData(res) {
            if (this.config.singleRootObject) {
                this.model = res.body[this.config.singleRootObject];
            } else {
                if (res.body.hasOwnProperty('attachments')) {
                    res.body.attachments = res.body.attachments.join('\n');
                }
                this.model = res.body;
            }
            this.loading = false;
            this.activeTab = '0';
        },
        onBack: function onBack() {
            this.$router.back();
        },
        isOrderDetail: function isOrderDetail() {
            return this.$route.params.model === 'orders';
        },
        onPrint: function onPrint() {

            this.$router.push({
                name: 'admin',
                params: {
                    action: 'print'
                }
            });
        },
        onDownloadExcel: function onDownloadExcel() {
            var _this2 = this;

            var url = this.rootConfig.endPoint + '/orders/' + this.id + '?as_excel=true';
            this.$http.get(url, { responseType: 'blob' }).then(function (res) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_download__["a" /* default */])(res.data, 'order.xls', 'application/vnd.ms-excel');
            }, function (err) {
                console.error(err);
                __WEBPACK_IMPORTED_MODULE_0__libs_api__["a" /* default */].errorHandler.call(_this2, err);
            });
        }
    }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_slicedToArray__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_entries__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_values__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_nestable__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_nestable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_nestable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__libs_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__libs_download__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__libs_encryptStorage__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__libs_storage__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Boolean_vue__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Boolean_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__Boolean_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Currency_vue__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Currency_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__Currency_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__DateTime_vue__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__DateTime_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__DateTime_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__SimpleText_vue__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__SimpleText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__SimpleText_vue__);


























/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'v-crud-index',

    props: ['config', 'rootConfig', 'api', 'siteId', 'permittedSitesConfig'],

    components: {
        SimpleText: __WEBPACK_IMPORTED_MODULE_22__SimpleText_vue___default.a,
        Currency: __WEBPACK_IMPORTED_MODULE_20__Currency_vue___default.a,
        Boolean: __WEBPACK_IMPORTED_MODULE_19__Boolean_vue___default.a,
        DateTime: __WEBPACK_IMPORTED_MODULE_21__DateTime_vue___default.a,
        VueNestable: __WEBPACK_IMPORTED_MODULE_14_vue_nestable__["VueNestable"],
        VueNestableHandle: __WEBPACK_IMPORTED_MODULE_14_vue_nestable__["VueNestableHandle"]
    },

    data: function data() {
        return {
            tableData: [],
            nestedTableData: [],
            multipleSelection: [],
            pageSize: 0,
            numFound: 0,
            page: 1,
            loading: false,
            term: '',
            sortProp: '',
            sort: '',
            showClearBtn: false,
            throttleCount: 0,
            throttleCountOrderDetail: 0,
            uploading: false,
            exporting: false,
            tableFilter: {
                country_id: '',
                status: '',
                ordersFrom: '',
                ordersTo: '',
                origin_id: ''
            },
            tableFilterVisible: false,
            showFilterOrderDates: false,
            showFilterStatus: false,
            statusOptions: ['all', 'open', 'cancelled', 'delivered', 'processing', 'shipped', 'pending'],
            selectedVisibleColumns: [],
            activeCountries: [],
            origins: [],
            translations: null,
            showSortCategories: false,
            userRole: __WEBPACK_IMPORTED_MODULE_17__libs_encryptStorage__["a" /* default */].getItem('ur'),
            customerSupportCoupon: ''
        };
    },
    mounted: function mounted() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!_this.isCustomerSupport()) {
                                _context.next = 4;
                                break;
                            }

                            _this.loadCustomerSupportData();
                            _context.next = 13;
                            break;

                        case 4:
                            _this.loadTranslations();
                            _this.setFiltersOptions();
                            _this.handleCurrentPage(_this.$route.query);
                            _this.setVisibleColumns();

                            _context.next = 10;
                            return _this.getActiveCountriesData();

                        case 10:
                            _context.next = 12;
                            return _this.getOriginsData();

                        case 12:
                            _this.loadData();

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },


    watch: {
        config: function config() {
            this.setVisibleColumns();
            this.loadData();

            if (typeof this.$refs.upload !== 'undefined') {
                this.clearImport();
            }
        },
        $route: function $route(to, from) {
            this.handleCurrentPage(to.query);
            var filters = __WEBPACK_IMPORTED_MODULE_18__libs_storage__["a" /* default */].getItem(__WEBPACK_IMPORTED_MODULE_18__libs_storage__["a" /* default */].keys.TABLE_FILTER);
            if (to.path !== from.path && filters) {
                this.resetForm('tableFilter');
            }
        },
        term: function term() {
            this.loadData();
        }
    },

    computed: {
        shopIsPlusCity: function shopIsPlusCity() {
            return this.siteId === '1' || this.siteId === '50';
        },
        isVisible: function isVisible() {
            var site_id = this.siteId;

            if (!this.permittedSitesConfig) {
                return false;
            }

            if (Object.hasOwn(this.permittedSitesConfig, site_id)) {
                site_id = this.permittedSitesConfig['' + site_id];
            }

            return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_values___default()(this.permittedSitesConfig).includes(Number(site_id));
        },
        importEndpoint: function importEndpoint() {
            return this.rootConfig.endPoint + '/' + this.config.import;
        },
        getActiveCountries: function getActiveCountries() {
            return this.$resource(this.rootConfig.endPoint + '/site_countries', {}, {}, { headers: this.rootConfig.headers });
        },
        getOrigins: function getOrigins() {
            return this.$resource(this.rootConfig.endPoint + '/origins', {}, {}, { headers: this.rootConfig.headers });
        },
        filter: function filter() {
            if (typeof this.config.filter !== 'undefined' && this.config.filter.length > 0) {
                return this.config.filter + this.$route.params.id;
            }
            return '';
        },
        apiResource: function apiResource() {
            return this.$resource(this.rootConfig.endPoint + '/' + this.config.resource + this.filter, {}, {}, { headers: this.rootConfig.headers });
        },
        showTableFilter: function showTableFilter() {
            return this.showFilterOrderDates !== false || this.showFilterStatus !== false || this.isCustomersRoute() && this.origins.length && this.isVisible;
        },
        showRefreshButton: function showRefreshButton() {
            return this.config.route === 'orders';
        },
        cntFiltersOptions: function cntFiltersOptions() {
            return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_values___default()(this.tableFilter).filter(function (value) {
                return !!value;
            }).length;
        },
        getActiveFilters: function getActiveFilters() {
            return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_entries___default()(this.tableFilter).filter(function (_ref) {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                    key = _ref2[0],
                    value = _ref2[1];

                return !!value;
            });
        },
        getVisibleColumns: function getVisibleColumns() {
            this.selectedVisibleColumns;
            if (typeof this.config.columns !== 'undefined' && this.config.columns.length > 0) {
                var route = this.config.route;
                var visibleColumns = this.getStoredVisibleColumns();

                if (visibleColumns[route]) {
                    return this.config.columns.filter(function (column) {
                        return visibleColumns[route].indexOf(column.property) >= 0;
                    });
                }

                return this.config.columns;
            }
            return [];
        }
    },

    methods: {
        loadCustomerSupportData: function loadCustomerSupportData() {
            this.customerSupportCoupon = __WEBPACK_IMPORTED_MODULE_17__libs_encryptStorage__["a" /* default */].getItem('customer_support_coupon'), __WEBPACK_IMPORTED_MODULE_17__libs_encryptStorage__["a" /* default */].removeItem('customer_support_coupon');
        },
        isSortable: function isSortable(property) {
            if (this.config.route !== 'categories') {
                return property === 'primary_image' ? false : 'custom';
            } else {
                return false;
            }
        },
        onToggleSortCategories: function onToggleSortCategories() {
            this.showSortCategories = !this.showSortCategories;
        },
        onCancelSortCategories: function onCancelSortCategories() {
            this.onToggleSortCategories();
            this.loadData();
        },
        onSortCategories: function onSortCategories(categories, parentId) {
            var _this2 = this;

            var index = 0;
            (categories || []).forEach(function (category) {
                category.parent_id = parentId;
                category.sequence = index;
                index = index + 1;
                _this2.onSortCategories(category.children, category.id);
            });
        },
        onFlattenCategories: function onFlattenCategories(categories) {
            var _this3 = this;

            var result = [];
            categories.forEach(function (category) {
                var id = category.id,
                    parent_id = category.parent_id,
                    sequence = category.sequence,
                    children = category.children;

                result.push({ id: id, parent_id: parent_id, sequence: sequence });
                if (children) result.push.apply(result, __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(_this3.onFlattenCategories(children)));
            });
            return result;
        },
        onSaveSortCategories: function onSaveSortCategories() {
            var _this4 = this;

            this.onToggleSortCategories();
            this.onSortCategories(this.nestedTableData, 0);
            var sortedCategories = this.onFlattenCategories(this.nestedTableData);
            var apiResource = this.$resource(this.rootConfig.endPoint + '/categories/bulk_update', {}, {}, { headers: this.rootConfig.headers });
            apiResource.update({ changed_categories: sortedCategories }).then(function () {
                _this4.loadData();
            }).catch(__WEBPACK_IMPORTED_MODULE_15__libs_api__["a" /* default */].errorHandler);
        },
        isCustomersRoute: function isCustomersRoute() {
            return this.$route.params.model === 'customers';
        },
        isOrdersRoute: function isOrdersRoute() {
            return this.$route.params.model === 'orders';
        },
        isCategoriesRoute: function isCategoriesRoute() {
            return this.$route.params.model === 'categories';
        },
        isSearchVisible: function isSearchVisible() {
            return this.$route.params.model !== 'categories';
        },
        loadTranslations: function loadTranslations() {
            var _this5 = this;

            var datasource = this.$resource('https://api.storyblok.com/v2/cdn/datasource_entries?datasource=translations');

            datasource.get({
                token: '7aJS9owJrpRWCa8d3iofRQtt',
                cv: Date.now()
            }).then(function (res) {
                _this5.translations = res.body.datasource_entries;
            });
        },
        getColumnClasses: function getColumnClasses(property, value) {
            var classes = [];

            if (property === 'status') {
                classes.push('label');
                classes.push(this.getStatusColorClasses(value));
            }

            if ((property === 'customer_name' || property === 'email') && this.isOrdersRoute() && this.isVisible) {
                classes.push('el-button--text cursor-pointer');
            }

            return classes;
        },
        getStatusColorClasses: function getStatusColorClasses(status) {
            var classes = [];

            switch (status) {
                case 'Processing':
                    classes.push('label--warning');
                    break;
                case 'Shipped':
                case 'Delivered':
                    classes.push('label--success');
                    break;
                case 'On Hold':
                    classes.push('label--info');
                    break;
                case 'Cancelled':
                case 'Failed':
                case 'Payment refunded':
                case 'Not Payed':
                case 'Returned':
                    classes.push('label--danger');
                    break;
                default:
                    classes.push('label--default');
            }

            return classes;
        },
        getTranslation: function getTranslation(key) {
            if (!this.translations) {
                return key;
            }

            var translation = this.translations.find(function (t) {
                return t.name === key;
            });

            return translation ? translation.value : key;
        },
        getActiveCountriesData: function getActiveCountriesData() {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var res;
                return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this6.getActiveCountries.get();

                            case 2:
                                res = _context2.sent;

                                _this6.activeCountries = res.body;

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this6);
            }))();
        },
        getOriginsData: function getOriginsData() {
            var _this7 = this;

            return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var res;
                return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _this7.getOrigins.get();

                            case 2:
                                res = _context3.sent;

                                _this7.origins = res.body;

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this7);
            }))();
        },
        saveVisibleColumns: function saveVisibleColumns() {
            this.selectedVisibleColumns = [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(this.selectedVisibleColumns));

            var route = this.config.route;
            var storedVisibleColumns = this.getStoredVisibleColumns();
            var routeVisibleColumns = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()(storedVisibleColumns, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()({}, route, this.selectedVisibleColumns));

            __WEBPACK_IMPORTED_MODULE_18__libs_storage__["a" /* default */].setItem(__WEBPACK_IMPORTED_MODULE_18__libs_storage__["a" /* default */].keys.VISIBLE_COLUMNS, routeVisibleColumns);
        },
        resetFormVisibleColumns: function resetFormVisibleColumns() {
            var route = this.config.route;
            var storedVisibleColumns = this.getStoredVisibleColumns();
            delete storedVisibleColumns[route];

            __WEBPACK_IMPORTED_MODULE_18__libs_storage__["a" /* default */].setItem(__WEBPACK_IMPORTED_MODULE_18__libs_storage__["a" /* default */].keys.VISIBLE_COLUMNS, storedVisibleColumns);
            this.selectedVisibleColumns = this.getColumnsProperties();
        },
        getColumnsProperties: function getColumnsProperties() {
            return this.config.columns.map(function (column) {
                return column.property;
            });
        },
        setVisibleColumns: function setVisibleColumns() {
            var route = this.config.route;
            var storedVisibleColumns = this.getStoredVisibleColumns();

            this.selectedVisibleColumns = storedVisibleColumns[route] || this.getColumnsProperties();
        },
        getStoredVisibleColumns: function getStoredVisibleColumns() {
            return __WEBPACK_IMPORTED_MODULE_18__libs_storage__["a" /* default */].getItem(__WEBPACK_IMPORTED_MODULE_18__libs_storage__["a" /* default */].keys.VISIBLE_COLUMNS) || {};
        },
        sortChange: function sortChange(sortProps) {
            switch (sortProps.order) {
                case 'ascending':
                    this.sortProp = sortProps.prop;
                    this.sort = 'asc';
                    this.loadData();
                    break;
                case 'descending':
                    this.sortProp = sortProps.prop;
                    this.sort = 'desc';
                    this.loadData();
                    break;
                default:
                    this.sort = '';
                    this.sortProp = '';
                    this.loadData();
                    break;
            }
        },
        setShippedStatus: function setShippedStatus() {
            var _this8 = this;

            this.multipleSelection.forEach(function (item, index) {
                setTimeout(function () {
                    var apiResource = _this8.$resource(_this8.rootConfig.endPoint + '/orders/' + item.id, {}, {}, { headers: _this8.rootConfig.headers });

                    if (item.status.toLowerCase() === 'processing') {
                        apiResource.update({ status: 'Shipped' }).then(function () {
                            _this8.loadData();
                        }).catch(__WEBPACK_IMPORTED_MODULE_15__libs_api__["a" /* default */].errorHandler);
                    } else {
                        _this8.loadData();
                    }
                }, 200 * index);
            });
        },
        doExport: function doExport() {
            var _this9 = this;

            this.exporting = true;

            if (this.config.route === 'orders') {
                this.doOrdersExport();
            } else {
                var filters = __WEBPACK_IMPORTED_MODULE_18__libs_storage__["a" /* default */].getItem(__WEBPACK_IMPORTED_MODULE_18__libs_storage__["a" /* default */].keys.TABLE_FILTER);
                var origin = filters && filters.origin_id ? filters.origin_id : null;

                var apiParams = {
                    term: this.term,
                    per_page: 2000,
                    as_csv: true
                };

                if (origin) {
                    apiParams.filter_origin = origin;
                }

                this.apiResource.get(apiParams).then(function (res) {
                    _this9.exporting = false;

                    if (res.data.xlsx) {
                        window.open(res.data.xlsx);
                    } else {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__libs_download__["a" /* default */])(res.data.csv, 'entries.csv', 'text/csv');
                    }
                }).catch(function () {
                    _this9.exporting = false;
                });
            }
        },
        doOrdersExport: function doOrdersExport() {
            var _this10 = this;

            return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.mark(function _callee5() {
                var mainOrders, promises, orders, taxCategories, csvString, columns, orderitemscountIndex, columnIndex, flattenColumns;
                return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return _this10.loadMainOrders();

                            case 2:
                                mainOrders = _context5.sent;
                                promises = [];


                                mainOrders.forEach(function () {
                                    var _ref3 = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.mark(function _callee4(mainOrder) {
                                        return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                                            while (1) {
                                                switch (_context4.prev = _context4.next) {
                                                    case 0:
                                                        promises.push(_this10.loadOrderDetail(mainOrder.id));

                                                    case 1:
                                                    case 'end':
                                                        return _context4.stop();
                                                }
                                            }
                                        }, _callee4, _this10);
                                    }));

                                    return function (_x) {
                                        return _ref3.apply(this, arguments);
                                    };
                                }());

                                _context5.next = 7;
                                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.all(promises);

                            case 7:
                                orders = _context5.sent;

                                _this10.throttleCountOrderDetail = 0;

                                _context5.next = 11;
                                return _this10.getTaxCategoriesMapped();

                            case 11:
                                taxCategories = _context5.sent;
                                csvString = '';
                                columns = ['order_number', 'customer_name', 'ordered_on', 'shipped_on', 'status', 'tax', 'payment_method', 'total', 'subtotal', 'orderitemscount', 'coupon_discount', 'shipping', 'shipping_notes', 'shipping_method_name', 'currency', 'notes', 'customer_id', 'email', 'tracking_number', 'ship_address', 'bill_address', 'language'];


                                if (_this10.shopIsPlusCity) {
                                    orderitemscountIndex = columns.indexOf('orderitemscount');

                                    if (orderitemscountIndex !== -1) {
                                        columns.splice(orderitemscountIndex + 1, 0, '10euro_count', '50euro_count', 'envelope_count');
                                    } else {
                                        columns.push('10euro_count', '50euro_count', 'envelope_count');
                                    }
                                }

                                columnIndex = columns.indexOf('tax') + 1;


                                __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(taxCategories).forEach(function (taxCategoryId) {
                                    var newTaxColumnName = 'tax_' + taxCategories[taxCategoryId];

                                    if (columns.indexOf(newTaxColumnName) < 0) {
                                        columns.splice(columnIndex, 0, newTaxColumnName);
                                        columnIndex = columns.indexOf(newTaxColumnName) + 1;
                                    }

                                    var newNettoColumnName = 'netto_' + taxCategories[taxCategoryId];

                                    if (columns.indexOf(newNettoColumnName) < 0) {
                                        columns.splice(columnIndex, 0, newNettoColumnName);
                                        columnIndex = columns.indexOf(newNettoColumnName) + 1;
                                    }
                                });

                                orders.forEach(function (order) {
                                    var taxValues = {};
                                    var nettoValues = {};
                                    if (_this10.shopIsPlusCity) {
                                        order['10euro_count'] = order.order_items.filter(function (item) {
                                            return item.sku === 'gutschein-10';
                                        }).reduce(function (sum, item) {
                                            return sum + item.quantity;
                                        }, 0);
                                        order['50euro_count'] = order.order_items.filter(function (item) {
                                            return item.sku === 'gutschein-50';
                                        }).reduce(function (sum, item) {
                                            return sum + item.quantity;
                                        }, 0);
                                        order['envelope_count'] = order.order_items.filter(function (item) {
                                            return item.sku === 'kuvert';
                                        }).reduce(function (sum, item) {
                                            return sum + item.quantity;
                                        }, 0);
                                    }

                                    order.order_items.forEach(function (orderItem) {
                                        if (orderItem.meta_data) {
                                            var taxCategoryId = orderItem.meta_data.tax_category_id;

                                            if (taxCategoryId !== null) {
                                                if (!taxValues[taxCategoryId]) {
                                                    taxValues[taxCategoryId] = 0;
                                                }

                                                taxValues[taxCategoryId] += orderItem['total_value'];

                                                if (!nettoValues[taxCategoryId]) {
                                                    nettoValues[taxCategoryId] = 0;
                                                }

                                                var taxRate = taxCategories[taxCategoryId];
                                                var factor = 1 + taxRate / 100;
                                                nettoValues[taxCategoryId] = _this10.roundDecimalNumber(nettoValues[taxCategoryId] + orderItem['total_value'] / factor);
                                            }
                                        }
                                    });

                                    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(taxValues).forEach(function (taxCategoryId) {
                                        var taxRate = taxCategories[taxCategoryId];
                                        var factor = 1 + taxRate / 100;
                                        var netto = _this10.roundDecimalNumber(taxValues[taxCategoryId] / factor);

                                        order['tax_' + taxRate] = _this10.roundDecimalNumber(taxValues[taxCategoryId] - netto);
                                        order['netto_' + taxRate] = nettoValues[taxCategoryId];
                                    });

                                    var orderItemsCount = 0;

                                    order.order_items.forEach(function (orderItem) {
                                        orderItemsCount += orderItem.quantity;
                                    });

                                    order['orderitemscount'] = orderItemsCount;

                                    var shippingNetto = order.shipping / 1.2;
                                    var shippingTax = order.shipping - shippingNetto;
                                    order.tax = _this10.roundDecimalNumber(order.tax + shippingTax);

                                    if (order.tax_20) {
                                        order.tax_20 = _this10.roundDecimalNumber(order.tax_20 + shippingTax);
                                    } else {
                                        order.tax_20 = _this10.roundDecimalNumber(shippingTax);
                                    }
                                });

                                flattenColumns = ['shipping_notes', 'bill_address', 'ship_address'];


                                orders.forEach(function (order) {
                                    flattenColumns.forEach(function (column) {
                                        var columnIndex = columns.indexOf(column) + 1;

                                        if (order[column] !== null && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(order[column]) === 'object') {
                                            var keys = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(order[column]);

                                            keys.forEach(function (key) {
                                                var newColumnName = column + '_' + key;
                                                order[newColumnName] = order[column][key];

                                                if (columns.indexOf(newColumnName) < 0) {
                                                    columns.splice(columnIndex, 0, newColumnName);
                                                    columnIndex = columns.indexOf(newColumnName) + 1;
                                                }
                                            });
                                        }
                                    });
                                });

                                flattenColumns.forEach(function (column) {
                                    columns.splice(columns.indexOf(column), 1);
                                });

                                columns.forEach(function (column) {
                                    csvString += '"' + column + '";';
                                });

                                csvString += '\r\n';

                                orders.forEach(function (order) {
                                    columns.forEach(function (column) {
                                        if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(order).indexOf(column) >= 0 && order[column] !== null) {
                                            if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(order[column]) === 'object') {
                                                var escaped = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(order[column]).replace(/"/g, '""');

                                                csvString += '"' + escaped + '"';
                                            } else {
                                                csvString += '"' + order[column] + '"';
                                            }
                                        }

                                        csvString += ';';
                                    });

                                    csvString += '\r\n';
                                });

                                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__libs_download__["a" /* default */])(csvString, 'entries.csv', 'text/csv');

                                _this10.exporting = false;

                            case 26:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this10);
            }))();
        },
        roundDecimalNumber: function roundDecimalNumber(number) {
            return Math.round(number * 100) / 100;
        },
        getTaxCategoriesMapped: function getTaxCategoriesMapped() {
            var _this11 = this;

            return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
                var taxCategoriesMapped = {};

                var apiResource = _this11.$resource(_this11.rootConfig.endPoint + '/tax_rates', {}, {}, { headers: _this11.rootConfig.headers });

                apiResource.get().then(function (res) {
                    var taxRates = res.data;

                    taxRates.forEach(function (taxRate) {
                        if (!taxCategoriesMapped[taxRate['tax_category_id']]) {
                            taxCategoriesMapped[taxRate['tax_category_id']] = taxRate['tax'];
                        }
                    });

                    resolve(taxCategoriesMapped);
                }).catch(__WEBPACK_IMPORTED_MODULE_15__libs_api__["a" /* default */].errorHandler);
            });
        },
        loadOrderDetail: function loadOrderDetail(orderId) {
            var _this12 = this;

            return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
                var apiResource = _this12.$resource(_this12.rootConfig.endPoint + '/orders/' + orderId, {}, {}, { headers: _this12.rootConfig.headers });

                setTimeout(function () {
                    apiResource.get().then(function (res) {
                        resolve(res.data);
                    }).catch(__WEBPACK_IMPORTED_MODULE_15__libs_api__["a" /* default */].errorHandler);
                }, _this12.throttleCountOrderDetail * 150);

                _this12.throttleCountOrderDetail = _this12.throttleCountOrderDetail + 1;
            });
        },
        loadMainOrders: function loadMainOrders() {
            var _this13 = this;

            return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.mark(function _callee6() {
                var orders, page, perPage, total, options, res;
                return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                orders = [];
                                page = 0;
                                perPage = 500;
                                total = 0;

                            case 4:
                                if (!(page === 0 || page * perPage < total)) {
                                    _context6.next = 15;
                                    break;
                                }

                                page++;

                                options = { page: page, per_page: perPage };

                                options = _this13.addFilterOptions(options);

                                _context6.next = 10;
                                return _this13.loadOrder(options);

                            case 10:
                                res = _context6.sent;


                                res.data.forEach(function (order) {
                                    orders.push(order);
                                });

                                total = _this13.getHeader(res, 'Total');
                                _context6.next = 4;
                                break;

                            case 15:
                                return _context6.abrupt('return', orders);

                            case 16:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this13);
            }))();
        },
        loadOrder: function loadOrder(options) {
            var _this14 = this;

            return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
                _this14.apiResource.get(options).then(resolve).catch(__WEBPACK_IMPORTED_MODULE_15__libs_api__["a" /* default */].errorHandler);
            });
        },
        beforeUpload: function beforeUpload() {
            var _this15 = this;

            this.uploading = true;

            return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
                setTimeout(resolve, _this15.throttleCount * 100);
                _this15.throttleCount = _this15.throttleCount + 1;
            });
        },
        pageChange: function pageChange(page) {
            this.page = page;
            this.$router.push({ query: { page: page } });
        },
        onPageChange: function onPageChange(page) {
            this.pageChange(page);
            this.loadData();
        },
        handleUploadSuccess: function handleUploadSuccess() {
            this.loadData();
            this.showClearBtn = true;
            this.uploading = false;

            if (window.location.host === 'wh.admin.commerce.netural.com') {
                this.clearCacheProdWH();
            } else if (window.location.host === 'qa-wh.admin.commerce.netural.com') {
                this.clearCacheQaWH();
            }
        },
        clearCacheProdWH: function clearCacheProdWH() {
            var prodDomainsWH = {
                '42683': 'https://shop-de.wh.com',
                '42718': 'https://shop-fr.wh.com',
                '42710': 'https://shop-bg.wh.com',
                '42699': 'https://shop-au.wh.com',
                '42639': 'https://shop-ca.wh.com',
                '42730': 'https://shop-in.wh.com',
                '42737': 'https://shop-pl.wh.com',
                '42738': 'https://shop-tr.wh.com',
                '42781': 'https://shop-iberica.wh.com',
                '42839': 'https://shop-dk.wh.com',
                '42840': 'https://shop-se.wh.com'
            };

            var domain = prodDomainsWH[this.siteId];

            if (domain) {
                this.sendCacheClearRequest(domain);
            }
        },
        clearCacheQaWH: function clearCacheQaWH() {
            var qaDomainsWH = {
                '42683': 'https://wh-shop-b2c-de-at.dev.netural.com',
                '42718': 'https://wh-shop-b2c-france.dev.netural.com',
                '42710': 'https://wh-shop-b2c-bulgaria.dev.netural.com',
                '42699': 'https://wh-shop-b2c-australia.dev.netural.com',
                '42639': 'https://wh-shop-b2c-impex.dev.netural.com',
                '42730': 'https://wh-shop-b2c-india.dev.netural.com',
                '42737': 'https://wh-shop-b2c-poland.dev.netural.com',
                '42738': 'https://wh-shop-b2c-turkiye.dev.netural.com',
                '42781': 'https://wh-shop-b2c-iberica.dev.netural.com',
                '42839': 'https://wh-shop-b2c-denmark.dev.netural.com',
                '42840': 'https://wh-shop-b2c-sweden.dev.netural.com'
            };

            var domain = qaDomainsWH[this.siteId];

            if (domain) {
                this.sendCacheClearRequest(domain);
            }
        },
        sendCacheClearRequest: function sendCacheClearRequest(domain) {
            fetch(domain + '/clear_cache', { mode: 'no-cors' }).then(function () {
                return console.log('Cache clear request sent to ' + domain);
            }).catch(function (err) {
                return console.error('Error clearing cache for ' + domain, err);
            });
        },
        handleUploadError: function handleUploadError(res) {
            this.handleUploadSuccess();
            var response = void 0;

            if (JSON.parse(res.message).errors) {
                response = {
                    body: JSON.parse(res.message)
                };
            } else {
                response = {
                    status: res.status,
                    body: JSON.parse(res.message.substr(4))
                };
            }
            __WEBPACK_IMPORTED_MODULE_15__libs_api__["a" /* default */].errorHandler.call(this, response);
        },
        clearImport: function clearImport() {
            this.$refs.upload.clearFiles();
            this.showClearBtn = false;
            this.throttleCount = 0;
        },
        loadData: function loadData() {
            var options = { page: this.page, term: this.term };
            options = this.addFilterOptions(options);

            this.loading = true;
            this.apiResource.get(options).then(this.setTableData).catch(__WEBPACK_IMPORTED_MODULE_15__libs_api__["a" /* default */].errorHandler);
        },
        removeTableFilter: function removeTableFilter(key) {
            this.tableFilter = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()(this.tableFilter, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()({}, key, ''));

            __WEBPACK_IMPORTED_MODULE_18__libs_storage__["a" /* default */].setItem(__WEBPACK_IMPORTED_MODULE_18__libs_storage__["a" /* default */].keys.TABLE_FILTER, this.tableFilter);
            this.loadData();
        },
        setFiltersOptions: function setFiltersOptions() {
            var filters = __WEBPACK_IMPORTED_MODULE_18__libs_storage__["a" /* default */].getItem(__WEBPACK_IMPORTED_MODULE_18__libs_storage__["a" /* default */].keys.TABLE_FILTER);
            this.tableFilter = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, this.tableFilter, filters);
        },
        addFilterOptions: function addFilterOptions(options) {
            var availableSortProps = this.config.columns.map(function (c) {
                return c.property;
            });
            if (this.sortProp !== '' && availableSortProps.includes(this.sortProp)) {
                options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, options, {
                    sort_by: this.sortProp + ':' + this.sort
                });
            }

            if (this.tableFilter.origin_id !== '') {
                var originId = this.tableFilter.origin_id;
                options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, options, { filter_origin: originId });
            }

            if (this.tableFilter.country_id !== '') {
                var countryId = this.tableFilter.country_id;
                options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, options, { country_id: countryId });
            }

            if (this.isUsUser()) {
                var usCountry = this.activeCountries.find(function (c) {
                    return c.name === 'United States';
                });
                options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, options, { country_id: usCountry.country_id });
            } else if (this.isBrUser()) {
                var brCountry = this.activeCountries.find(function (c) {
                    return c.name === 'Brazil';
                });
                options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, options, { country_id: brCountry.country_id });
            } else if (this.isUkUser()) {
                var ukCountry = this.activeCountries.find(function (c) {
                    return c.name === 'United Kingdom';
                });
                options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, options, { country_id: ukCountry.country_id });
            }

            if (this.tableFilter.status !== '') {
                var status = this.tableFilter.status === 'all' ? '' : this.tableFilter.status;
                options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, options, { status: status });
            }

            if (this.tableFilter.ordersFrom !== '') {
                options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, options, {
                    ordered_on_gte: this.tableFilter.ordersFrom + '+00%3A00%3A00&'
                });
            }

            if (this.tableFilter.ordersTo !== '') {
                options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, options, {
                    ordered_on_lte: this.tableFilter.ordersTo + '+00%3A00%3A00&'
                });
            }

            return options;
        },
        handleCurrentPage: function handleCurrentPage(query) {
            if (query && query.page) {
                this.page = parseInt(query.page);
            } else {
                this.page = 1;
            }
        },
        resetFilterOptions: function resetFilterOptions() {
            this.showFilterOrderDates = false;
            this.showFilterStatus = false;
        },
        showFilterOptions: function showFilterOptions() {
            var _this16 = this;

            this.resetFilterOptions();

            if (this.config.showColumnFilter) {
                this.config.showColumnFilter.forEach(function (filter) {
                    switch (filter) {
                        case 'ordered_on':
                            _this16.showFilterOrderDates = _this16.showFilterOrderDates === false ? '' : _this16.showFilterOrderDates;
                            break;
                        case 'status':
                            _this16.showFilterStatus = _this16.tableFilter.status;
                            break;
                        default:
                            break;
                    }
                });
            }
        },
        onStatusChange: function onStatusChange(eventStatus) {
            this.showFilterStatus = eventStatus === 'all' ? '' : eventStatus;
        },
        resetForm: function resetForm(formName) {
            this.$refs['tableFilter'].resetFields();

            this.tableFilter = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()(this.tableFilter, {
                country_id: '',
                status: '',
                ordersFrom: '',
                ordersTo: '',
                origin_id: ''
            });

            this.tableFilterVisible = false;
            __WEBPACK_IMPORTED_MODULE_18__libs_storage__["a" /* default */].removeItem(__WEBPACK_IMPORTED_MODULE_18__libs_storage__["a" /* default */].keys.TABLE_FILTER);

            this.showFilterOptions();
            this.loadData();
        },
        filterSearch: function filterSearch() {
            this.pageChange(1);

            this.tableFilterVisible = false;
            __WEBPACK_IMPORTED_MODULE_18__libs_storage__["a" /* default */].setItem(__WEBPACK_IMPORTED_MODULE_18__libs_storage__["a" /* default */].keys.TABLE_FILTER, this.tableFilter);

            this.loadData();
        },
        getHeader: function getHeader(res, header) {
            if (res.headers.map[header]) {
                return parseInt(res.headers.map[header][0]);
            }
            var lowerHeader = header.toLowerCase();
            if (res.headers.map[lowerHeader]) {
                return parseInt(res.headers.map[lowerHeader][0]);
            }
            return 0;
        },
        setTableData: function setTableData(res) {
            this.pageSize = this.getHeader(res, 'Per-Page');
            this.numFound = this.getHeader(res, 'Total');

            if (this.config.rootObject) {
                this.tableData = res.body[this.config.rootObject];
            } else {
                this.tableData = res.body;
            }

            if (this.config.route === 'categories') {
                this.nestCategoriesHierarchy();
                this.mapCategoriesHierarchy();
            }

            this.loading = false;

            this.showFilterOptions();
        },
        nestCategoriesHierarchy: function nestCategoriesHierarchy() {
            var result = [];
            if (this.tableData.length) {
                this.tableData.forEach(function (category) {
                    category.children = [];
                });
                var root = {};
                var map = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a(this.tableData.map(function (o) {
                    return [o.id, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, o)];
                }));
                map.forEach(function (o) {
                    return function (p) {
                        return p.children = (p.children || []).concat(o);
                    }(map.get(o.parent_id) || root);
                });
                result = root.children;
            }
            this.nestedTableData = result;
        },
        mapCategoriesHierarchy: function mapCategoriesHierarchy() {
            this.tableData = this.recursiveCategory(-1, [], 0);
        },
        recursiveCategory: function recursiveCategory(i, data, parentId) {
            var _this17 = this;

            var childData = this.tableData.filter(function (e) {
                return e.parent_id === parentId;
            });
            if (childData) {
                i++;
                childData.forEach(function (e) {
                    if (i > 0) {
                        var element = ['', '→', '»', '◦'];
                        e.name = Array(4 * i).fill('\xa0').join('') + (element[i] || '→') + ' ' + e.name;
                    }
                    data.push(e);
                    data = _this17.recursiveCategory(i, data, e.id);
                });
            }
            return data;
        },
        handleRowClick: function handleRowClick(row, column, event) {
            var currentTextSelection = window.getSelection().toString();
            if (event.type === 'click' && currentTextSelection.length === 0) {
                if ((column.property === 'customer_name' || column.property === 'email') && this.isOrdersRoute() && this.isVisible) {
                    this.$router.push({
                        name: 'admin',
                        params: {
                            id: row.customer_id,
                            action: 'edit',
                            model: 'customers'
                        }
                    });
                    return;
                }
                this.$router.push({
                    name: 'admin',
                    params: {
                        id: row.id || row.uuid,
                        action: 'edit',
                        model: this.config.route
                    }
                });
            }
        },
        handleSelectionChange: function handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        massDeletion: function massDeletion() {
            var _this18 = this;

            this.multipleSelection.forEach(function (item, index) {
                setTimeout(function () {
                    _this18.apiResource.delete({ id: item.id }, null).then(function () {
                        _this18.loadData();
                    }).catch(__WEBPACK_IMPORTED_MODULE_15__libs_api__["a" /* default */].errorHandler);
                }, 200 * index);
            });
        },
        getFilterLabel: function getFilterLabel(key) {
            switch (key) {
                case 'status':
                    return 'Filter status';
                case 'ordersFrom':
                    return 'Orders From';
                case 'ordersTo':
                    return 'Orders To';
                case 'country_id':
                    return 'Filter country';
                case 'origin_id':
                    return 'Filter origin';
            }
        },
        getFilterCountryName: function getFilterCountryName(value) {
            if (this.activeCountries.length) {
                var country = this.activeCountries.filter(function (ac) {
                    return ac.country_id === value;
                });
                return country[0].name;
            }
        },
        getFilterOriginName: function getFilterOriginName(value) {
            if (this.origins.length) {
                var origin = this.origins.filter(function (o) {
                    return o.id === value;
                });
                return origin[0].name;
            }
        },
        refresh: function refresh() {
            this.loadData();
        },
        isBrUser: function isBrUser() {
            return this.userRole === 'BRAdmin';
        },
        isUkUser: function isUkUser() {
            return this.userRole === 'UKAdmin';
        },
        isUsUser: function isUsUser() {
            return this.userRole === 'USAdmin';
        },
        isCustomerSupport: function isCustomerSupport() {
            return this.userRole === 'CustomerSup';
        }
    }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_encryptStorage__ = __webpack_require__(42);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'v-crud-new',

    props: ['config', 'rootConfig', 'siteId', 'params', 'id'],

    data: function data() {
        return {
            model: {},
            userRole: __WEBPACK_IMPORTED_MODULE_2__libs_encryptStorage__["a" /* default */].getItem('ur')
        };
    },

    methods: {
        isVisibleInCurrentShop: function isVisibleInCurrentShop(field) {
            if (field.show_for_shop_ids && field.show_for_shop_ids.length > 0) {
                return field.show_for_shop_ids.includes(this.siteId);
            }
            return true;
        },
        setModel: function setModel() {
            if (typeof this.model[name] === 'undefined') {
                this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.model);
            }
        },
        onSubmit: function onSubmit() {
            var _this = this;

            var params = {};

            if (this.config.singleRootObject) {
                params[this.config.singleRootObject] = this.model;
            } else {
                params = this.model;
            }

            __WEBPACK_IMPORTED_MODULE_1__libs_api__["a" /* default */].res.save(params).then(function (res) {
                if (_this.isCustomerSupport()) {
                    __WEBPACK_IMPORTED_MODULE_2__libs_encryptStorage__["a" /* default */].setItem('customer_support_coupon', res.data.name);
                    _this.$router.push({
                        name: 'admin',
                        params: { id: 'all', action: 'index' }
                    });
                } else {
                    _this.$router.push({
                        name: 'admin',
                        params: { id: 'all', action: 'index' }
                    });
                }
            }).catch(__WEBPACK_IMPORTED_MODULE_1__libs_api__["a" /* default */].errorHandler);
        },
        isCustomerSupport: function isCustomerSupport() {
            return this.userRole === 'CustomerSup';
        }
    }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_api__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'v-crud-print',

    props: ['config', 'rootConfig', 'params', 'id'],

    data: function data() {
        return {
            model: {},
            loading: false
        };
    },
    mounted: function mounted() {
        this.loadData();
    },


    watch: {
        '$route.params.model': function $routeParamsModel() {
            this.loadData();
        }
    },

    methods: {
        loadData: function loadData() {
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__libs_api__["a" /* default */].res.get({ id: this.id }).then(this.setModelData).catch(__WEBPACK_IMPORTED_MODULE_1__libs_api__["a" /* default */].errorHandler);
        },
        setModelData: function setModelData(res) {
            if (this.config.singleRootObject) {
                this.model = res.body[this.config.singleRootObject];
            } else {
                if (res.body.hasOwnProperty('attachments')) {
                    res.body.attachments = res.body.attachments.join('\n');
                }
                this.model = res.body;
            }
            this.loading = false;
            this.activeTab = '0';

            setTimeout(function () {
                window.print();
            }, 1000);
        },
        formatNoteObjectKey: function formatNoteObjectKey(key) {
            return key.replaceAll('_', ' ');
        },
        isEmpty: function isEmpty(obj) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj).length === 0;
        },
        isDynamicPricePackage: function isDynamicPricePackage(properties) {
            return properties.filter(function (property) {
                return property.slug === 'dynamicPricePackage';
            }).length > 0;
        }
    }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueCrudIndex_vue__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueCrudIndex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__VueCrudIndex_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'v-crud-table',

    props: ['config', 'rootConfig', 'model'],

    components: {
        'v-crud-index': __WEBPACK_IMPORTED_MODULE_0__VueCrudIndex_vue___default.a
    },

    data: function data() {
        return {};
    },
    mounted: function mounted() {}
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['value', 'label'],
    methods: {
        updateValue: function updateValue(v) {
            this.$emit('input', v);
        }
    }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            remoteValues: [],
            loading: false,
            parentID: null,
            categoryID: null
        };
    },

    name: 'v-crud-category-hierarchy-select',
    props: ['options', 'placeholder', 'value', 'rootConfig'],
    methods: {
        updateValue: function updateValue(v) {
            this.parentID = v;
            this.$emit('input', v);
        },
        getSortedCategories: function getSortedCategories() {
            var _this = this;

            this.loading = true;
            this.api.get({ per_page: 1000 }).then(function (res) {
                if (res.data) {
                    _this.remoteValues = res.data;
                    _this.remoteValues = _this.recursiveCategory(-1, [], 0);
                    var emptyOption = [{ id: 0, name: 'No parent (Top level)' }];
                    _this.remoteValues = emptyOption.concat(_this.remoteValues);
                    _this.setCurrentParentID();
                    _this.loading = false;
                }
            }).catch(function (res) {
                _this.loading = false;
                console.error(res);
                _this.$message('Something went wrong. Please try again.');
            });
        },
        setCurrentParentID: function setCurrentParentID() {
            var _this2 = this;

            var currentCategory = this.remoteValues.find(function (cat) {
                return cat.id === _this2.$route.params.id;
            });
            if (typeof currentCategory !== 'undefined') {
                this.parentID = currentCategory.parent_id;
            } else {
                this.updateValue(0);
            }
        },
        recursiveCategory: function recursiveCategory(i, data, parentId) {
            var _this3 = this;

            var childData = this.remoteValues.filter(function (e) {
                return e.parent_id === parentId;
            });
            if (childData) {
                i++;
                childData.forEach(function (e) {
                    if (i > 0) {
                        var element = ['', '→', '»', '◦'];
                        e.name = Array(4 * i).fill('\xa0').join('') + (element[i] || '→') + ' ' + e.name;
                    }
                    data.push(e);
                    data = _this3.recursiveCategory(i, data, e.id);
                });
            }
            return data;
        }
    },
    mounted: function mounted() {
        this.getSortedCategories();
    },

    computed: {
        api: function api() {
            return this.$resource([this.rootConfig.endPoint, 'categories', this.categoryID].join('/'), {}, {}, { headers: this.rootConfig.headers });
        }
    }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            remoteValues: [],
            loading: false,
            categoryID: null
        };
    },

    name: 'v-crud-category-multi-select',
    props: ['options', 'placeholder', 'value', 'rootConfig'],
    methods: {
        updateValue: function updateValue(v) {
            this.$emit('input', v.toString());
        },
        getSortedCategories: function getSortedCategories() {
            var _this = this;

            this.loading = true;
            this.api.get({ per_page: 1000 }).then(function (res) {
                if (res.data) {
                    _this.remoteValues = res.data;
                    _this.remoteValues = _this.recursiveCategory(-1, [], 0);
                    _this.loading = false;
                }
            }).catch(function (res) {
                _this.loading = false;
                console.error(res);
                _this.$message('Something went wrong. Please try again.');
            });
        },
        recursiveCategory: function recursiveCategory(i, data, parentId) {
            var _this2 = this;

            var childData = this.remoteValues.filter(function (e) {
                return e.parent_id === parentId;
            });
            if (childData) {
                i++;
                childData.forEach(function (e) {
                    if (i > 0) {
                        var element = ['', '→', '»', '◦'];
                        e.name = Array(4 * i).fill('\xa0').join('') + (element[i] || '→') + ' ' + e.name;
                    }
                    data.push(e);
                    data = _this2.recursiveCategory(i, data, e.id);
                });
            }
            return data;
        }
    },
    mounted: function mounted() {
        this.getSortedCategories();
    },

    computed: {
        api: function api() {
            return this.$resource([this.rootConfig.endPoint, 'categories', this.categoryID].join('/'), {}, {}, { headers: this.rootConfig.headers });
        }
    }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'v-custom-date-range-picker',

    data: function data() {
        return {
            dateRange: [],
            dateRangePicker: [],
            dateRangeFilterVisible: false,
            dateRangeActive: '',
            datePickerOptions: {
                disabledDate: function disabledDate(date) {
                    return date > new Date() || date < new Date(Date.now() - 20 * 365 * 24 * 60 * 60 * 1000);
                }
            }
        };
    },
    mounted: function mounted() {
        this.selectDateRange('LAST_30_DAYS');
    },


    watch: {
        dateRange: function dateRange() {
            this.$emit('dateRange', this.dateRange);
        },
        dateRangePicker: function dateRangePicker() {
            if (this.dateRangePicker) {
                this.dateRange = this.dateRangePicker;
                this.dateRangeActive = null;
                this.dateRangeFilterVisible = false;
            }
        }
    },

    methods: {
        selectDateRange: function selectDateRange(type) {
            var date = new Date(Date.now() - 24 * 60 * 60 * 1000);
            this.dateRangeActive = type;

            switch (type) {
                case 'YESTERDAY':
                    this.dateRange = [date, date];
                    break;

                case 'LAST_SEVEN_DAYS':
                    date = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
                    this.dateRange = [date, new Date()];
                    break;

                case 'LAST_30_DAYS':
                    date = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);
                    this.dateRange = [date, new Date()];
                    break;

                case 'LAST_MONTH':
                    var startDate = new Date();
                    startDate.setDate(1);
                    startDate.setMonth(startDate.getMonth() - 1);
                    var endDate = new Date();
                    endDate.setDate(0);
                    endDate.setMonth(endDate.getMonth());
                    this.dateRange = [startDate, endDate];
                    break;
            }

            this.dateRangeFilterVisible = false;
        }
    }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['value'],

    computed: {
        src: function src() {
            return this.value ? '//img3.storyblok.com/' + this.value : null;
        }
    }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_api__ = __webpack_require__(5);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'v-crud-image-upload',
    props: ['placeholder', 'value', 'rootModel', 'rootConfig'],
    methods: {
        updateValue: function updateValue(v) {
            v.forEach(function (file) {
                file.filename = file.filename.replace('http://assets.storeblok.com/', '');
            });

            if (this.isSingle) {
                this.$emit('input', v[0].filename);
            } else {
                this.$emit('input', v);
            }
        },
        handleRemove: function handleRemove(file) {},
        beforeUpload: function beforeUpload() {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                setTimeout(resolve, _this.throttleCount * 100);
                _this.throttleCount = _this.throttleCount + 1;
            });
        },
        handleUploadSuccess: function handleUploadSuccess(res) {
            if (this.isSingle) {
                this.fileList = [{ filename: res.filename, primary: 0 }];
            } else {
                this.fileList.push({ filename: res.filename, primary: 0 });
            }
            this.updateValue(this.fileList);
        },
        handleUploadError: function handleUploadError() {},
        handleDelete: function handleDelete(file) {
            if (this.isSingle) {
                this.$emit('input', '');
                this.fileList = [];
            } else {
                this.fileList = this.fileList.filter(function (fileListItem) {
                    return file.filename !== fileListItem.filename;
                });
                this.updateValue(this.fileList);
            }
        },
        handleChange: function handleChange(file, fileList) {
            console.log(fileList);
        },
        doUpload: function doUpload(xhr) {
            var _this2 = this;

            this.saveBase64(xhr.file, function (base64file) {
                __WEBPACK_IMPORTED_MODULE_2__libs_api__["a" /* default */].init('assets').save({ file: base64file }).then(_this2.handleSuccess).catch(__WEBPACK_IMPORTED_MODULE_2__libs_api__["a" /* default */].errorHandler);
            });
        },
        setFilelist: function setFilelist() {
            if (this.value) {
                if (this.isSingle) {
                    this.fileList = [{
                        filename: this.value.replace(new RegExp('http://assets.storeblok.com/', 'g'), '')
                    }];
                } else {
                    var value = this.value;

                    if (typeof this.value !== 'undefined' && this.value.constructor !== Array) {
                        value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.value);
                    }
                    var fileList = [];

                    value.forEach(function (file) {
                        file.filename = file.filename.replace(new RegExp('http://assets.storeblok.com/', 'g'), '');
                        fileList.push(file);
                    });

                    this.fileList = fileList;
                }
            }
        }
    },

    computed: {
        importEndpoint: function importEndpoint() {
            return this.rootConfig.endPoint + '/assets';
        },
        isSingle: function isSingle() {
            return typeof this.value !== 'undefined' && this.value.constructor === String;
        }
    },

    data: function data() {
        return {
            imgService: '',
            fileList: []
        };
    },
    created: function created() {
        this.setFilelist();
    },


    watch: {
        value: function value() {
            this.setFilelist();
        }
    }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'v-crud-mail-preview',
    props: ['root-config', 'value'],
    computed: {
        api: function api() {
            return this.$resource([this.rootConfig.endPoint, 'mail_previews/me'].join('/'), {}, {}, { headers: this.rootConfig.headers });
        }
    },
    watch: {
        value: function value() {
            var _this = this;

            if (this.value && this.value.length > 0) {
                this.api.get({ trigger: this.value }).then(function (res) {
                    document.querySelector('.preview').innerHTML = res.data;
                }).catch(function (res) {
                    console.error(res);
                    _this.$message('Something went wrong. Please try again.');
                });
            }
        }
    }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['value', 'label'],
    computed: {
        isEmpty: function isEmpty() {
            return !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.metaData).length;
        },
        metaData: function metaData() {
            if (!this.value) {
                return {};
            }
            return this.value;
        }
    },
    methods: {
        updateValue: function updateValue() {
            this.$emit('input', this.metaData);
        }
    }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'v-crud-radio',
    props: ['options', 'placeholder', 'value'],
    methods: {
        updateValue: function updateValue(v) {
            this.$emit('input', v);
        }
    }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            results: [],
            list: [],
            valueList: [],
            loading: false,
            states: [],
            proxyValue: ''
        };
    },

    computed: {
        api: function api() {
            return this.$resource([this.rootConfig.endPoint, this.options[0].resource].join('/'), {}, {}, { headers: this.rootConfig.headers });
        },
        searchKey: function searchKey() {
            return this.options[0].searchKey || 'names';
        },
        shopIsSilhouette: function shopIsSilhouette() {
            return window.location.host === 'qa-silhouette.admin.commerce.netural.com' || window.location.host === 'silhouette.admin.commerce.netural.com';
        }
    },
    props: ['options', 'placeholder', 'value', 'rootConfig'],
    mounted: function mounted() {},

    watch: {
        value: function value() {
            var _this = this;

            if (this.value && this.value !== '0' && (!this.options[0].asArray || this.value.constructor === Array && this.value.length > 0) && (!this.options[0].multiple || this.value.constructor === Array && this.value.length > 0)) {
                this.api.get({ id: this.value, per_page: 1000 }).then(function (res) {
                    _this.setProxyValue(res.data);
                }).catch(function (res) {
                    console.error(res);
                    _this.$message('Something went wrong. Please try again.');
                });
            }
        }
    },
    methods: {
        setProxyValue: function setProxyValue(value) {
            if (this.options[0].multiple) {
                var validatedIds = value.map(function (item) {
                    return item.id;
                });

                if (validatedIds.length !== this.value.length) {
                    this.$emit('input', validatedIds);
                    return;
                }

                this.proxyValue = '';
                this.valueList = value;
            } else if (this.options[0].asArray) {
                this.proxyValue = value[0][this.searchKey];
            } else {
                this.proxyValue = value[this.searchKey] + (value.parent_id == 0 && this.shopIsSilhouette ? ' (Group)' : '');
            }
        },
        removeValue: function removeValue(id) {
            var results = this.value.filter(function (item) {
                return item !== id;
            });

            this.$emit('input', results);

            if (this.options[0].multiple) {
                this.valueList = results;
            }
        },
        updateValue: function updateValue(v) {
            if (v === '') {
                this.proxyValue = '';

                if (this.options[0].asArray) {
                    this.$emit('input', []);
                    return;
                }

                this.$emit('input', '');
                return;
            }

            var results = this.results.filter(function (item) {
                return item.id === v;
            });

            if (results && results.length > 0) {
                var value = results[0][this.searchKey];

                if (this.options[0].multiple) {
                    this.proxyValue = '';

                    var newValue = v;
                    v = this.value;

                    if (typeof v === 'undefined') {
                        v = [];
                    }

                    v.push(newValue);
                } else if (this.options[0].asArray) {
                    v = [v];
                    this.proxyValue = value;
                } else {
                    this.proxyValue = value;
                }
            }

            this.$emit('input', v);
        },
        remoteMethod: function remoteMethod(query) {
            var _this2 = this;

            if (query !== '') {
                this.loading = true;
                this.api.get({ term: query }).then(function (res) {
                    _this2.loading = false;
                    _this2.results = res.data;
                }).catch(function (res) {
                    _this2.loading = false;
                    console.error(res);
                    _this2.$message('Something went wrong. Please try again.');
                });
            } else {
                this.results = [];
            }
        }
    }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'v-crud-select',
    props: ['options', 'placeholder', 'value'],
    methods: {
        updateValue: function updateValue(v) {
            this.$emit('input', v);
        }
    }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_each__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_isoLanguages__ = __webpack_require__(332);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'v-crud-translations',
    data: function data() {
        return {
            loading: false,
            locales: [],
            translations: {}
        };
    },

    computed: {
        settingApi: function settingApi() {
            return this.$resource(this.rootConfig.endPoint + '/settings/{id}', {}, {}, { headers: this.rootConfig.headers });
        },
        api: function api() {
            return this.$resource(this.rootConfig.endPoint + '/translations/{id}', {}, {}, { headers: this.rootConfig.headers });
        },
        tableName: function tableName() {
            return this.$route.params.model;
        }
    },
    props: ['formConfig', 'options', 'placeholder', 'rootConfig', 'model', 'value', 'type', 'fieldName'],
    watch: {
        '$route.params.id': function $routeParamsId() {
            this.loadTranslations();
        },
        '$route.params.model': function $routeParamsModel() {
            this.loadTranslations();
        }
    },
    created: function created() {
        var _this = this;

        setTimeout(function () {
            _this.loadTranslations();
        }, 100);
    },

    methods: {
        loadTranslations: function loadTranslations() {
            var _this2 = this;

            this.settingApi.get({
                code: 'general_setting',
                setting_key: 'aditional_languages'
            }).then(function (res) {
                if (res.body.length > 0) {
                    var languages = JSON.parse(res.body[0].setting);

                    languages.forEach(function (item) {
                        _this2.locales.push({
                            name: __WEBPACK_IMPORTED_MODULE_3__libs_isoLanguages__["a" /* default */][item] || item,
                            id: item
                        });
                        _this2.translations[item] = {};
                    });
                }

                _this2.api.get({
                    with_table_name: _this2.tableName,
                    with_foreign_id: _this2.$route.params.id
                }).then(function (res) {
                    res.data.forEach(function (item) {
                        if (typeof _this2.translations[item.language] !== 'undefined') {
                            _this2.translations[item.language][item.key] = item.body;
                        }
                    });

                    _this2.translations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.translations);
                }).catch(__WEBPACK_IMPORTED_MODULE_2__libs_api__["a" /* default */].errorHandler);
            }).catch(__WEBPACK_IMPORTED_MODULE_2__libs_api__["a" /* default */].errorHandler);
        },
        onSubmit: function onSubmit() {
            var _this3 = this;

            var translations = [];

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_each__["a" /* default */])(this.translations, function (translation, language) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_each__["a" /* default */])(translation, function (body, key) {
                    translations.push({
                        table_name: _this3.tableName,
                        foreign_id: _this3.$route.params.id,
                        language: language,
                        key: key,
                        body: body
                    });
                });
            });

            this.loading = true;

            this.api.save({ translations: translations }).then(function (res) {
                _this3.loading = false;
            }).catch(__WEBPACK_IMPORTED_MODULE_2__libs_api__["a" /* default */].errorHandler);
        }
    }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'ab': 'Abkhaz',
  'aa': 'Afar',
  'af': 'Afrikaans',
  'ak': 'Akan',
  'sq': 'Albanian',
  'am': 'Amharic',
  'ar': 'Arabic',
  'an': 'Aragonese',
  'hy': 'Armenian',
  'as': 'Assamese',
  'av': 'Avaric',
  'ae': 'Avestan',
  'ay': 'Aymara',
  'az': 'Azerbaijani',
  'bm': 'Bambara',
  'ba': 'Bashkir',
  'eu': 'Basque',
  'be': 'Belarusian',
  'bn': 'Bengali; Bangla',
  'bh': 'Bihari',
  'bi': 'Bislama',
  'bs': 'Bosnian',
  'br': 'Breton',
  'bg': 'Bulgarian',
  'my': 'Burmese',
  'ca': 'Catalan; Valencian',
  'ch': 'Chamorro',
  'ce': 'Chechen',
  'ny': 'Chichewa; Chewa; Nyanja',
  'zh': 'Chinese',
  'cv': 'Chuvash',
  'kw': 'Cornish',
  'co': 'Corsican',
  'cr': 'Cree',
  'hr': 'Croatian',
  'cs': 'Czech',
  'da': 'Danish',
  'dv': 'Divehi; Dhivehi; Maldivian;',
  'nl': 'Dutch',
  'dz': 'Dzongkha',
  'en': 'English',
  'eo': 'Esperanto',
  'et': 'Estonian',
  'ee': 'Ewe',
  'fo': 'Faroese',
  'fj': 'Fijian',
  'fi': 'Finnish',
  'fr': 'French',
  'ff': 'Fula; Fulah; Pulaar; Pular',
  'gl': 'Galician',
  'ka': 'Georgian',
  'de': 'German',
  'el': 'Greek, Modern',
  'gn': 'GuaranÃ­',
  'gu': 'Gujarati',
  'ht': 'Haitian; Haitian Creole',
  'ha': 'Hausa',
  'he': 'Hebrew (modern)',
  'hz': 'Herero',
  'hi': 'Hindi',
  'ho': 'Hiri Motu',
  'hu': 'Hungarian',
  'ia': 'Interlingua',
  'id': 'Indonesian',
  'ie': 'Interlingue',
  'ga': 'Irish',
  'ig': 'Igbo',
  'ik': 'Inupiaq',
  'io': 'Ido',
  'is': 'Icelandic',
  'it': 'Italian',
  'iu': 'Inuktitut',
  'ja': 'Japanese',
  'jv': 'Javanese',
  'kl': 'Kalaallisut, Greenlandic',
  'kn': 'Kannada',
  'kr': 'Kanuri',
  'ks': 'Kashmiri',
  'kk': 'Kazakh',
  'km': 'Khmer',
  'ki': 'Kikuyu, Gikuyu',
  'rw': 'Kinyarwanda',
  'ky': 'Kyrgyz',
  'kv': 'Komi',
  'kg': 'Kongo',
  'ko': 'Korean',
  'ku': 'Kurdish',
  'kj': 'Kwanyama, Kuanyama',
  'la': 'Latin',
  'lb': 'Luxembourgish, Letzeburgesch',
  'lg': 'Ganda',
  'li': 'Limburgish, Limburgan, Limburger',
  'ln': 'Lingala',
  'lo': 'Lao',
  'lt': 'Lithuanian',
  'lu': 'Luba-Katanga',
  'lv': 'Latvian',
  'gv': 'Manx',
  'mk': 'Macedonian',
  'mg': 'Malagasy',
  'ms': 'Malay',
  'ml': 'Malayalam',
  'mt': 'Maltese',
  'mi': 'MÄori',
  'mr': 'Marathi (MarÄá¹­hÄ«)',
  'mh': 'Marshallese',
  'mn': 'Mongolian',
  'na': 'Nauru',
  'nv': 'Navajo, Navaho',
  'nb': 'Norwegian BokmÃ¥l',
  'nd': 'North Ndebele',
  'ne': 'Nepali',
  'ng': 'Ndonga',
  'nn': 'Norwegian Nynorsk',
  'no': 'Norwegian',
  'ii': 'Nuosu',
  'nr': 'South Ndebele',
  'oc': 'Occitan',
  'oj': 'Ojibwe, Ojibwa',
  'cu': 'Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic',
  'om': 'Oromo',
  'or': 'Oriya',
  'os': 'Ossetian, Ossetic',
  'pa': 'Panjabi, Punjabi',
  'pi': 'PÄli',
  'fa': 'Persian (Farsi)',
  'pl': 'Polish',
  'ps': 'Pashto, Pushto',
  'pt': 'Portuguese',
  'qu': 'Quechua',
  'rm': 'Romansh',
  'rn': 'Kirundi',
  'ro': 'Romanian, [])',
  'ru': 'Russian',
  'sa': 'Sanskrit (Saá¹ská¹›ta)',
  'sc': 'Sardinian',
  'sd': 'Sindhi',
  'se': 'Northern Sami',
  'sm': 'Samoan',
  'sg': 'Sango',
  'sr': 'Serbian',
  'gd': 'Scottish Gaelic; Gaelic',
  'sn': 'Shona',
  'si': 'Sinhala, Sinhalese',
  'sk': 'Slovak',
  'sl': 'Slovene',
  'so': 'Somali',
  'st': 'Southern Sotho',
  'es': 'Spanish; Castilian',
  'su': 'Sundanese',
  'sw': 'Swahili',
  'ss': 'Swati',
  'sv': 'Swedish',
  'ta': 'Tamil',
  'te': 'Telugu',
  'tg': 'Tajik',
  'th': 'Thai',
  'ti': 'Tigrinya',
  'bo': 'Tibetan Standard, Tibetan, Central',
  'tk': 'Turkmen',
  'tl': 'Tagalog',
  'tn': 'Tswana',
  'to': 'Tonga (Tonga Islands)',
  'tr': 'Turkish',
  'ts': 'Tsonga',
  'tt': 'Tatar',
  'tw': 'Twi',
  'ty': 'Tahitian',
  'ug': 'Uyghur, Uighur',
  'uk': 'Ukrainian',
  'ur': 'Urdu',
  'uz': 'Uzbek',
  've': 'Venda',
  'vi': 'Vietnamese',
  'vo': 'VolapÃ¼k',
  'wa': 'Walloon',
  'cy': 'Welsh',
  'wo': 'Wolof',
  'fy': 'Western Frisian',
  'xh': 'Xhosa',
  'yi': 'Yiddish',
  'yo': 'Yoruba',
  'za': 'Zhuang, Chuang',
  'zu': 'Zulu'
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (val) {
  var result = '';
  var tmp = [];

  location.search.substr(1).split('&').forEach(function (item) {
    tmp = item.split('=');
    if (tmp[0] === val) result = decodeURIComponent(tmp[1]);
  });

  return result;
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
  keys: {
    TABLE_FILTER: { name: 'tableFilter', storage: sessionStorage },
    VISIBLE_COLUMNS: { name: 'visibleColumns', storage: localStorage }
  },

  setItem: function setItem(key, value) {
    try {
      var storage = key.storage,
          name = key.name;

      storage.setItem(name, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
    } catch (e) {}
  },
  updateItem: function updateItem(key, value) {
    try {
      var storage = key.storage,
          name = key.name;

      storage.setItem(name, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
    } catch (e) {}
  },
  getItem: function getItem(key) {
    if (!key) {
      return null;
    }

    try {
      var storage = key.storage,
          name = key.name;

      var value = storage.getItem(name);

      if (!value) {
        return null;
      }

      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    } catch (e) {}
  },
  removeItem: function removeItem(key) {
    try {
      var storage = key.storage,
          name = key.name;

      storage.removeItem(name);
    } catch (e) {}
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_encryptStorage__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(267);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = true;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request) {
    request.headers.set('Authorization', sessionStorage.getItem('sbc-token'));

    return function (res) {
        if (res.status == 401) {
            __WEBPACK_IMPORTED_MODULE_2__libs_encryptStorage__["a" /* default */].removeItem('ur');
            __WEBPACK_IMPORTED_MODULE_2__libs_encryptStorage__["a" /* default */].removeItem('rr');
            sessionStorage.removeItem('sbc-token');
            sessionStorage.removeItem('tableFilter');
            sessionStorage.setItem('session-expired', true);
            location.reload();
        }
    };
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    default: [{
        component: 'install',
        route: 'install',
        name: 'Installation'
    }]
});

/***/ }),
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 436 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 455 */,
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 122,
	"./af.js": 122,
	"./ar": 130,
	"./ar-dz": 123,
	"./ar-dz.js": 123,
	"./ar-kw": 124,
	"./ar-kw.js": 124,
	"./ar-ly": 125,
	"./ar-ly.js": 125,
	"./ar-ma": 126,
	"./ar-ma.js": 126,
	"./ar-ps": 127,
	"./ar-ps.js": 127,
	"./ar-sa": 128,
	"./ar-sa.js": 128,
	"./ar-tn": 129,
	"./ar-tn.js": 129,
	"./ar.js": 130,
	"./az": 131,
	"./az.js": 131,
	"./be": 132,
	"./be.js": 132,
	"./bg": 133,
	"./bg.js": 133,
	"./bm": 134,
	"./bm.js": 134,
	"./bn": 136,
	"./bn-bd": 135,
	"./bn-bd.js": 135,
	"./bn.js": 136,
	"./bo": 137,
	"./bo.js": 137,
	"./br": 138,
	"./br.js": 138,
	"./bs": 139,
	"./bs.js": 139,
	"./ca": 140,
	"./ca.js": 140,
	"./cs": 141,
	"./cs.js": 141,
	"./cv": 142,
	"./cv.js": 142,
	"./cy": 143,
	"./cy.js": 143,
	"./da": 144,
	"./da.js": 144,
	"./de": 147,
	"./de-at": 145,
	"./de-at.js": 145,
	"./de-ch": 146,
	"./de-ch.js": 146,
	"./de.js": 147,
	"./dv": 148,
	"./dv.js": 148,
	"./el": 149,
	"./el.js": 149,
	"./en-au": 150,
	"./en-au.js": 150,
	"./en-ca": 151,
	"./en-ca.js": 151,
	"./en-gb": 152,
	"./en-gb.js": 152,
	"./en-ie": 153,
	"./en-ie.js": 153,
	"./en-il": 154,
	"./en-il.js": 154,
	"./en-in": 155,
	"./en-in.js": 155,
	"./en-nz": 156,
	"./en-nz.js": 156,
	"./en-sg": 157,
	"./en-sg.js": 157,
	"./eo": 158,
	"./eo.js": 158,
	"./es": 162,
	"./es-do": 159,
	"./es-do.js": 159,
	"./es-mx": 160,
	"./es-mx.js": 160,
	"./es-us": 161,
	"./es-us.js": 161,
	"./es.js": 162,
	"./et": 163,
	"./et.js": 163,
	"./eu": 164,
	"./eu.js": 164,
	"./fa": 165,
	"./fa.js": 165,
	"./fi": 166,
	"./fi.js": 166,
	"./fil": 167,
	"./fil.js": 167,
	"./fo": 168,
	"./fo.js": 168,
	"./fr": 171,
	"./fr-ca": 169,
	"./fr-ca.js": 169,
	"./fr-ch": 170,
	"./fr-ch.js": 170,
	"./fr.js": 171,
	"./fy": 172,
	"./fy.js": 172,
	"./ga": 173,
	"./ga.js": 173,
	"./gd": 174,
	"./gd.js": 174,
	"./gl": 175,
	"./gl.js": 175,
	"./gom-deva": 176,
	"./gom-deva.js": 176,
	"./gom-latn": 177,
	"./gom-latn.js": 177,
	"./gu": 178,
	"./gu.js": 178,
	"./he": 179,
	"./he.js": 179,
	"./hi": 180,
	"./hi.js": 180,
	"./hr": 181,
	"./hr.js": 181,
	"./hu": 182,
	"./hu.js": 182,
	"./hy-am": 183,
	"./hy-am.js": 183,
	"./id": 184,
	"./id.js": 184,
	"./is": 185,
	"./is.js": 185,
	"./it": 187,
	"./it-ch": 186,
	"./it-ch.js": 186,
	"./it.js": 187,
	"./ja": 188,
	"./ja.js": 188,
	"./jv": 189,
	"./jv.js": 189,
	"./ka": 190,
	"./ka.js": 190,
	"./kk": 191,
	"./kk.js": 191,
	"./km": 192,
	"./km.js": 192,
	"./kn": 193,
	"./kn.js": 193,
	"./ko": 194,
	"./ko.js": 194,
	"./ku": 196,
	"./ku-kmr": 195,
	"./ku-kmr.js": 195,
	"./ku.js": 196,
	"./ky": 197,
	"./ky.js": 197,
	"./lb": 198,
	"./lb.js": 198,
	"./lo": 199,
	"./lo.js": 199,
	"./lt": 200,
	"./lt.js": 200,
	"./lv": 201,
	"./lv.js": 201,
	"./me": 202,
	"./me.js": 202,
	"./mi": 203,
	"./mi.js": 203,
	"./mk": 204,
	"./mk.js": 204,
	"./ml": 205,
	"./ml.js": 205,
	"./mn": 206,
	"./mn.js": 206,
	"./mr": 207,
	"./mr.js": 207,
	"./ms": 209,
	"./ms-my": 208,
	"./ms-my.js": 208,
	"./ms.js": 209,
	"./mt": 210,
	"./mt.js": 210,
	"./my": 211,
	"./my.js": 211,
	"./nb": 212,
	"./nb.js": 212,
	"./ne": 213,
	"./ne.js": 213,
	"./nl": 215,
	"./nl-be": 214,
	"./nl-be.js": 214,
	"./nl.js": 215,
	"./nn": 216,
	"./nn.js": 216,
	"./oc-lnc": 217,
	"./oc-lnc.js": 217,
	"./pa-in": 218,
	"./pa-in.js": 218,
	"./pl": 219,
	"./pl.js": 219,
	"./pt": 221,
	"./pt-br": 220,
	"./pt-br.js": 220,
	"./pt.js": 221,
	"./ro": 222,
	"./ro.js": 222,
	"./ru": 223,
	"./ru.js": 223,
	"./sd": 224,
	"./sd.js": 224,
	"./se": 225,
	"./se.js": 225,
	"./si": 226,
	"./si.js": 226,
	"./sk": 227,
	"./sk.js": 227,
	"./sl": 228,
	"./sl.js": 228,
	"./sq": 229,
	"./sq.js": 229,
	"./sr": 231,
	"./sr-cyrl": 230,
	"./sr-cyrl.js": 230,
	"./sr.js": 231,
	"./ss": 232,
	"./ss.js": 232,
	"./sv": 233,
	"./sv.js": 233,
	"./sw": 234,
	"./sw.js": 234,
	"./ta": 235,
	"./ta.js": 235,
	"./te": 236,
	"./te.js": 236,
	"./tet": 237,
	"./tet.js": 237,
	"./tg": 238,
	"./tg.js": 238,
	"./th": 239,
	"./th.js": 239,
	"./tk": 240,
	"./tk.js": 240,
	"./tl-ph": 241,
	"./tl-ph.js": 241,
	"./tlh": 242,
	"./tlh.js": 242,
	"./tr": 243,
	"./tr.js": 243,
	"./tzl": 244,
	"./tzl.js": 244,
	"./tzm": 246,
	"./tzm-latn": 245,
	"./tzm-latn.js": 245,
	"./tzm.js": 246,
	"./ug-cn": 247,
	"./ug-cn.js": 247,
	"./uk": 248,
	"./uk.js": 248,
	"./ur": 249,
	"./ur.js": 249,
	"./uz": 251,
	"./uz-latn": 250,
	"./uz-latn.js": 250,
	"./uz.js": 251,
	"./vi": 252,
	"./vi.js": 252,
	"./x-pseudo": 253,
	"./x-pseudo.js": 253,
	"./yo": 254,
	"./yo.js": 254,
	"./zh-cn": 255,
	"./zh-cn.js": 255,
	"./zh-hk": 256,
	"./zh-hk.js": 256,
	"./zh-mo": 257,
	"./zh-mo.js": 257,
	"./zh-tw": 258,
	"./zh-tw.js": 258
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 456;

/***/ }),
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */
/***/ (function(module, exports) {

module.exports = {"name":"vue-chartjs","version":"2.8.7","description":"Vue.js wrapper for chart.js for creating beautiful charts.","author":"Jakub Juszczak <jakub@posteo.de>","homepage":"http://vue-chartjs.org","license":"MIT","contributors":[{"name":"Thorsten Lünborg","web":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","web":"https://github.com/jcalonso"}],"maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","web":"http://www.jakubjuszczak.de"}],"repository":{"type":"git","url":"git+ssh://git@github.com:apertureless/vue-chartjs.git"},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"main":"dist/vue-chartjs.js","unpkg":"dist/vue-chartjs.full.min.js","module":"es/index.js","jsnext:main":"es/index.js","files":["src","dist","es"],"scripts":{"dev":"node build/dev-server.js","build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","unit":"karma start test/unit/karma.conf.js --single-run","e2e":"node test/e2e/runner.js","test":"npm run unit","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","prepublish":"yarn run lint && yarn run test && yarn run build"},"dependencies":{"lodash.merge":"^4.6.0"},"peerDependencies":{"chart.js":"^2.7.0","vue":"^2.4.4"},"devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.4","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]}}

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(450)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(548),
  /* scopeId */
  "data-v-7d400cac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(538),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(524),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(452)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(552),
  /* scopeId */
  "data-v-d38f32f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(531),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(443)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(536),
  /* scopeId */
  "data-v-4f1c0879",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(440)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(533),
  /* scopeId */
  "data-v-4351c21e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(545),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(549),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(434)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(519),
  /* scopeId */
  "data-v-0929abb8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(445)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(542),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(539),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(446)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(543),
  /* scopeId */
  "data-v-649b792b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(528),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(523),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(451)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(550),
  /* scopeId */
  "data-v-8aa18650",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(449)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(547),
  /* scopeId */
  "data-v-7bbf25dc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(448)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(546),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(453)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(553),
  /* scopeId */
  "data-v-e4c9de3e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(517),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(442)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(535),
  /* scopeId */
  "data-v-49b400fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(444)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(540),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(435)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(520),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(432)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(516),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(522),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(537),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(454)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(554),
  /* scopeId */
  "data-v-fe1fa2e0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(437)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(529),
  /* scopeId */
  "data-v-30240814",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(441)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(534),
  /* scopeId */
  "data-v-47b26eee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(526),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(447)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(544),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(527),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(551),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(525),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(439)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(532),
  /* scopeId */
  "data-v-432d50d5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(436)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(521),
  /* scopeId */
  "data-v-1434e7d5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [(!_vm.isEmpty(_vm.model)) ? _c('table', {
    staticClass: "table"
  }, [_c('tr', {
    staticClass: "table__row"
  }, [_c('td', {
    staticClass: "table__data"
  }, [_c('h2', {
    staticClass: "order-number__headline"
  }, [_vm._v("\n                    " + _vm._s(_vm.model.order_number) + "\n                ")])]), _vm._v(" "), _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Delivery to")]), _c('br'), _vm._v(" "), (_vm.model.company) ? _c('span', [_vm._v(_vm._s(_vm.model.company))]) : _vm._e(), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n                    " + _vm._s(_vm.model.ship_address.firstname) + "\n                    " + _vm._s(_vm.model.ship_address.lastname))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.model.ship_address.address1))]), _c('br'), _vm._v(" "), (_vm.model.ship_address.address2) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.model.ship_address.address2) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.model.ship_address.city) + ",\n                    " + _vm._s(_vm.model.ship_address.zip) + " ")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.model.ship_address.country))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.model.email))]), _c('br')])]), _vm._v(" "), _c('tr', {
    staticClass: "table__row"
  }, [_c('td', {
    staticClass: "table__data"
  }, [_c('strong', [_vm._v("Order Date")]), _c('br'), _vm._v("\n                " + _vm._s(_vm._f("datetime")(_vm.model.ordered_on)) + "\n            ")]), _vm._v(" "), _c('td', {
    staticClass: "table__data"
  }, [_c('strong', [_vm._v("Payment Method")]), _c('br'), _vm._v("\n                " + _vm._s(_vm.model.payments[0].payment_type) + " (" + _vm._s(_vm._f("datetime")(_vm.model.payments[0].created_at)) + ")\n            ")]), _vm._v(" "), _c('td', {
    staticClass: "table__data"
  }, [_c('strong', [_vm._v("Delivery Details")]), _c('br'), _vm._v("\n                " + _vm._s(_vm.model.shipping_method_name) + "\n            ")])]), _vm._v(" "), _c('tr', {
    staticClass: "table__row"
  }, [_c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Customer Note")]), _c('br'), _vm._v(" "), _c('ul', _vm._l((_vm.model.shipping_notes), function(note, key) {
    return _c('li', {
      key: key
    }, [_c('strong', [_vm._v(_vm._s(_vm.formatNoteObjectKey(key)) + ":")]), _vm._v("\n                        " + _vm._s(note) + "\n                    ")])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (!_vm.isEmpty(_vm.model)) ? _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.model.order_items), function(product) {
    return _c('tr', {
      key: product.id,
      staticClass: "table__row"
    }, [_c('td', {
      staticClass: "table__data"
    }, [_vm._v("\n                " + _vm._s(product.meta_data.name)), _c('br'), _vm._v("\n                SKU: " + _vm._s(product.meta_data.sku) + "\n            ")]), _vm._v(" "), _c('td', {
      staticClass: "table__data"
    }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(product.value, _vm.model.currency)) + "\n            ")]), _vm._v(" "), _c('td', {
      staticClass: "table__data"
    }, [_vm._v("\n                " + _vm._s(product.quantity) + "\n            ")]), _vm._v(" "), _c('td', {
      staticClass: "table__data"
    }, [(
      product.meta_data &&
      product.meta_data.properties &&
      _vm.isDynamicPricePackage(product.meta_data.properties)
    ) ? _c('div', [(product.total_value && product.discount) ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")((product.total_value -
      Math.abs(product.discount)), _vm.model.currency + ' ')) + "\n                    ")]) : _vm._e(), _vm._v(" "), (product.total_value) ? _c('div', {
      staticClass: "text-zinc-400"
    }, [_c('del', [_vm._v(_vm._s(_vm._f("currency")(product.total_value, _vm.model.currency + ' ')))])]) : _vm._e(), _vm._v(" "), (product.discount) ? _c('div', [_c('strong', [_vm._v("Your savings:")]), _c('br'), _vm._v(_vm._s(_vm._f("currency")(Math.abs(product.discount), _vm.model.currency + ' ')) + "\n                    ")]) : _vm._e()]) : (product.total_value) ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("currency")(product.total_value, _vm.model.currency + ' ')) + "\n                ")]) : _vm._e()])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "table__row"
  }, [_vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(_vm.model.coupon_discount, _vm.model.currency)) + "\n            ")])]), _vm._v(" "), _c('tr', {
    staticClass: "table__row"
  }, [_vm._m(2), _vm._v(" "), _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(_vm.model.subtotal, _vm.model.currency)) + "\n            ")])]), _vm._v(" "), _c('tr', {
    staticClass: "table__row"
  }, [_vm._m(3), _vm._v(" "), _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(_vm.model.shipping, _vm.model.currency)) + "\n            ")])]), _vm._v(" "), _c('tr', {
    staticClass: "table__row"
  }, [_vm._m(4), _vm._v(" "), _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(_vm.model.tax, _vm.model.currency)) + "\n            ")])]), _vm._v(" "), _c('tr', {
    staticClass: "table__row"
  }, [_vm._m(5), _vm._v(" "), _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("currency")(_vm.model.total, _vm.model.currency)))])])])], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "table__row"
  }, [_c('td', {
    staticClass: "table__data"
  }, [_c('strong', [_vm._v("Name")])]), _vm._v(" "), _c('td', {
    staticClass: "table__data"
  }, [_c('strong', [_vm._v("Price")])]), _vm._v(" "), _c('td', {
    staticClass: "table__data"
  }, [_c('strong', [_vm._v("Amount")])]), _vm._v(" "), _c('td', {
    staticClass: "table__data"
  }, [_c('strong', [_vm._v("Total")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Coupon discount")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Subtotal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Versand")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Tax")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Total")])])
}]}

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.value))])
},staticRenderFns: []}

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "installation"
  }, [_c('h1', [_vm._v("Installation")]), _vm._v(" "), _c('div', [_vm._v("\n        You have successfully installed Storyblok Commerce."), _c('br'), _vm._v("\n        To get started please read the setup guide.\n        "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Public API-Key")]), _vm._v("\n        Use this key to get the catalogue data and to manage the cart.\n        "), (_vm.public) ? _c('div', {
    staticClass: "apikey"
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.public.key),
      callback: function($$v) {
        _vm.$set(_vm.public, "key", $$v)
      },
      expression: "public.key"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("Private API-Key")]), _vm._v("\n        Use this key to get full access to orders and the catalogue. "), _c('br'), _vm._v("\n        DON'T share the private token in public!\n        "), (_vm.private) ? _c('div', {
    staticClass: "apikey"
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.private.key),
      callback: function($$v) {
        _vm.$set(_vm.private, "key", $$v)
      },
      expression: "private.key"
    }
  })], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "installation__button"
  }, [_c('a', {
    staticClass: "el-button el-button--primary",
    attrs: {
      "target": "_blank",
      "href": "https://www.storyblok.com/commerce/docs/setup"
    }
  }, [_vm._v("Open setup guide")])])
}]}

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.model,
      "label-width": "200px"
    }
  }, [_c('el-tabs', _vm._l((_vm.config.formFields), function(tab) {
    return _c('el-tab-pane', {
      key: tab.label,
      attrs: {
        "label": tab.label
      }
    }, [_vm._l((tab.body), function(item) {
      return _c(item.component, {
        key: item._uid,
        tag: "div",
        attrs: {
          "model": _vm.model,
          "root-config": _vm.rootConfig,
          "options": item.options
        }
      })
    }), _vm._v(" "), _vm._l((tab.fields), function(field) {
      return (_vm.isVisibleInCurrentShop(field)) ? _c('el-form-item', {
        key: field.name,
        class: {
          'form-field': _vm.isCustomerSupport()
        },
        attrs: {
          "label": field.label
        }
      }, [_c(field.component, {
        tag: "div",
        attrs: {
          "placeholder": field.placeholder,
          "root-config": _vm.rootConfig,
          "options": field.options,
          "type": field.type
        },
        on: {
          "input": function($event) {
            return _vm.setModel(field.name)
          }
        },
        model: {
          value: (_vm.model[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.model, field.name, $$v)
          },
          expression: "model[field.name]"
        }
      })], 1) : _vm._e()
    })], 2)
  }), 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Save")]), _vm._v(" "), (!_vm.isCustomerSupport()) ? _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'admin',
          params: {
            id: 'all',
            action: 'index'
          },
        })
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "body"
  }, [(!_vm.locales.length) ? _c('div', [_vm._v("You have no locales configured yet.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.locales), function(locale) {
    return _c('div', [_c('h4', {
      staticClass: "group__headline"
    }, [_vm._v(_vm._s(locale.name))]), _vm._v(" "), _c('div', [_vm._l((_vm.options), function(field) {
      return _c('el-form-item', {
        key: field.value,
        attrs: {
          "label": field.label
        }
      }, [_c("el-input", {
        tag: "div",
        attrs: {
          "type": "textarea"
        },
        model: {
          value: (_vm.translations[locale.id][field.value]),
          callback: function($$v) {
            _vm.$set(_vm.translations[locale.id], field.value, $$v)
          },
          expression: "translations[locale.id][field.value]"
        }
      }), _vm._v("\n                " + _vm._s(_vm.model[field.value]) + "\n            ")], 1)
    }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.onSubmit(locale.id)
        }
      }
    }, [_vm._v("Save this translations")])], 1)], 2)])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-crud-index', {
    attrs: {
      "model": _vm.model,
      "action": "index",
      "root-config": _vm.rootConfig,
      "config": _vm.config
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-14 h-14"
  }, [_c('img', {
    staticClass: "w-full h-auto",
    attrs: {
      "src": _vm.value
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('el-checkbox', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-radio-group', {
    attrs: {
      "value": _vm.value,
      "placeholder": _vm.placeholder
    },
    on: {
      "input": _vm.updateValue
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('el-radio', {
      key: option.value,
      attrs: {
        "label": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": _vm.src,
      "width": "200"
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n        " + _vm._s(_vm.value) + "\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "preview"
  })])
}]}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u__margin-bottom"
  }, [_c('h4', {
    staticClass: "group__headline"
  }, [_vm._v("Stripe")]), _vm._v(" "), (_vm.model.stripe) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.stripe.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.stripe, "enabled", $$v)
      },
      expression: "model.stripe.enabled"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.stripe.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.stripe, "enabled", $$v)
      },
      expression: "model.stripe.enabled"
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Livemode"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.stripe.livemode),
      callback: function($$v) {
        _vm.$set(_vm.model.stripe, "livemode", $$v)
      },
      expression: "model.stripe.livemode"
    }
  }, [_vm._v("Enabled")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.stripe.livemode),
      callback: function($$v) {
        _vm.$set(_vm.model.stripe, "livemode", $$v)
      },
      expression: "model.stripe.livemode"
    }
  }, [_vm._v("Disabled")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Returning url"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.stripe.returning_url),
      callback: function($$v) {
        _vm.$set(_vm.model.stripe, "returning_url", $$v)
      },
      expression: "model.stripe.returning_url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "SOFORT"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.stripe.enable_sofort),
      callback: function($$v) {
        _vm.$set(_vm.model.stripe, "enable_sofort", $$v)
      },
      expression: "model.stripe.enable_sofort"
    }
  }, [_vm._v("Enabled")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.stripe.enable_sofort),
      callback: function($$v) {
        _vm.$set(_vm.model.stripe, "enable_sofort", $$v)
      },
      expression: "model.stripe.enable_sofort"
    }
  }, [_vm._v("Disabled")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Alipay"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.stripe.enable_alipay),
      callback: function($$v) {
        _vm.$set(_vm.model.stripe, "enable_alipay", $$v)
      },
      expression: "model.stripe.enable_alipay"
    }
  }, [_vm._v("Enabled")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.stripe.enable_alipay),
      callback: function($$v) {
        _vm.$set(_vm.model.stripe, "enable_alipay", $$v)
      },
      expression: "model.stripe.enable_alipay"
    }
  }, [_vm._v("Disabled")])], 1)], 1) : _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.install('stripe', {
          returning_url: 'https://www.storyblok.com',
          livemode: '0',
          enable_sofort: '0',
          enable_alipay: '0',
        })
      }
    }
  }, [_vm._v("Install")])], 1), _vm._v(" "), _c('h4', {
    staticClass: "group__headline mt-20"
  }, [_vm._v("Cash on delivery")]), _vm._v(" "), (_vm.model.cod) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.cod.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.cod, "enabled", $$v)
      },
      expression: "model.cod.enabled"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.cod.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.cod, "enabled", $$v)
      },
      expression: "model.cod.enabled"
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Label"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.cod.method_name),
      callback: function($$v) {
        _vm.$set(_vm.model.cod, "method_name", $$v)
      },
      expression: "model.cod.method_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Description"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.cod.form_description),
      callback: function($$v) {
        _vm.$set(_vm.model.cod, "form_description", $$v)
      },
      expression: "model.cod.form_description"
    }
  })], 1)], 1) : _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.install('cod')
      }
    }
  }, [_vm._v("Install")])], 1), _vm._v(" "), _c('h4', {
    staticClass: "group__headline mt-20"
  }, [_vm._v("Invoice")]), _vm._v(" "), (_vm.model.invoice) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.invoice.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.invoice, "enabled", $$v)
      },
      expression: "model.invoice.enabled"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.invoice.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.invoice, "enabled", $$v)
      },
      expression: "model.invoice.enabled"
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Label"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.invoice.method_name),
      callback: function($$v) {
        _vm.$set(_vm.model.invoice, "method_name", $$v)
      },
      expression: "model.invoice.method_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Description"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.invoice.form_description),
      callback: function($$v) {
        _vm.$set(_vm.model.invoice, "form_description", $$v)
      },
      expression: "model.invoice.form_description"
    }
  })], 1)], 1) : _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.install('invoice', {
          method_name: 'Invoice',
          form_description: 'Bank account details',
        })
      }
    }
  }, [_vm._v("Install")])], 1), _vm._v(" "), _c('h4', {
    staticClass: "group__headline mt-20"
  }, [_vm._v("Paypal")]), _vm._v(" "), (_vm.model.paypal_express) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.paypal_express.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.paypal_express, "enabled", $$v)
      },
      expression: "model.paypal_express.enabled"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.paypal_express.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.paypal_express, "enabled", $$v)
      },
      expression: "model.paypal_express.enabled"
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Username"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.paypal_express.username),
      callback: function($$v) {
        _vm.$set(_vm.model.paypal_express, "username", $$v)
      },
      expression: "model.paypal_express.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.paypal_express.password),
      callback: function($$v) {
        _vm.$set(_vm.model.paypal_express, "password", $$v)
      },
      expression: "model.paypal_express.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Signature"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.paypal_express.signature),
      callback: function($$v) {
        _vm.$set(_vm.model.paypal_express, "signature", $$v)
      },
      expression: "model.paypal_express.signature"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sandbox"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.paypal_express.SANDBOX),
      callback: function($$v) {
        _vm.$set(_vm.model.paypal_express, "SANDBOX", $$v)
      },
      expression: "model.paypal_express.SANDBOX"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.paypal_express.SANDBOX),
      callback: function($$v) {
        _vm.$set(_vm.model.paypal_express, "SANDBOX", $$v)
      },
      expression: "model.paypal_express.SANDBOX"
    }
  }, [_vm._v("No")])], 1)], 1) : _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.install('paypal_express', {
          SANDBOX: '0'
        })
      }
    }
  }, [_vm._v("Install")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-crud-category-multi-select"
  }, [_c('el-select', {
    attrs: {
      "value": _vm.value ? _vm.value.split(',').map(Number) : [],
      "placeholder": "Please select a category",
      "loading": _vm.loading,
      "multiple": ""
    },
    on: {
      "input": _vm.updateValue
    }
  }, _vm._l((_vm.remoteValues), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isCustomerSupport()) ? _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.config.name))]), _vm._v(" "), _c('span', {
    staticClass: "buttons"
  }, [(!_vm.tableFilterVisible && _vm.showTableFilter) ? _c('div', _vm._l((_vm.tableFilter), function(value, key) {
    return (value) ? _c('el-tag', {
      key: key,
      attrs: {
        "closable": "",
        "type": "info"
      },
      on: {
        "close": function($event) {
          return _vm.removeTableFilter(key)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.getFilterLabel(key)) + ":\n                    " + _vm._s(key === 'country_id' ?
      _vm.getFilterCountryName(value) :
      key === 'origin_id' ?
      _vm.getFilterOriginName(value) :
      value) + "\n                ")]) : _vm._e()
  }), 1) : _vm._e(), _vm._v(" "), (_vm.showRefreshButton) ? _c('el-button', {
    on: {
      "click": _vm.refresh
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  })]) : _vm._e(), _vm._v(" "), (
    _vm.config.shippedMultiselect &&
    _vm.multipleSelection.length > 0
  ) ? _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.setShippedStatus()
      }
    }
  }, [_vm._v("\n                Set Shipped Status\n            ")]) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "tableFilter",
    attrs: {
      "model": _vm.tableFilter
    }
  }, [(_vm.showTableFilter) ? _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "250",
      "trigger": "manual"
    },
    model: {
      value: (_vm.tableFilterVisible),
      callback: function($$v) {
        _vm.tableFilterVisible = $$v
      },
      expression: "tableFilterVisible"
    }
  }, [(
    _vm.origins.length &&
    _vm.isCustomersRoute() &&
    _vm.isVisible
  ) ? _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Filter origin"
    },
    model: {
      value: (_vm.tableFilter.origin_id),
      callback: function($$v) {
        _vm.$set(_vm.tableFilter, "origin_id", $$v)
      },
      expression: "tableFilter.origin_id"
    }
  }, _vm._l((_vm.origins), function(origin) {
    return _c('el-option', {
      key: origin.name,
      attrs: {
        "label": origin.name,
        "value": origin.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.activeCountries.length &&
    !_vm.isUsUser() &&
    !_vm.isBrUser() &&
    !_vm.isUkUser() &&
    _vm.isOrdersRoute()
  ) ? _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Filter country"
    },
    model: {
      value: (_vm.tableFilter.country_id),
      callback: function($$v) {
        _vm.$set(_vm.tableFilter, "country_id", $$v)
      },
      expression: "tableFilter.country_id"
    }
  }, _vm._l((_vm.activeCountries), function(country) {
    return _c('el-option', {
      key: country.name,
      attrs: {
        "label": country.name,
        "value": country.country_id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showFilterStatus !== false) ? _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Filter status"
    },
    on: {
      "change": function($event) {
        return _vm.onStatusChange($event)
      }
    },
    model: {
      value: (_vm.tableFilter.status),
      callback: function($$v) {
        _vm.$set(_vm.tableFilter, "status", $$v)
      },
      expression: "tableFilter.status"
    }
  }, _vm._l((_vm.statusOptions), function(status) {
    return _c('el-option', {
      key: status,
      attrs: {
        "label": status,
        "value": status
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showFilterOrderDates !== false) ? _c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Orders From",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.tableFilter.ordersFrom),
      callback: function($$v) {
        _vm.$set(_vm.tableFilter, "ordersFrom", $$v)
      },
      expression: "tableFilter.ordersFrom"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showFilterOrderDates !== false) ? _c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Orders To",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.tableFilter.ordersTo),
      callback: function($$v) {
        _vm.$set(_vm.tableFilter, "ordersTo", $$v)
      },
      expression: "tableFilter.ordersTo"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('tableFilter')
      }
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "reference"
    },
    on: {
      "click": function($event) {
        _vm.tableFilterVisible = !_vm.tableFilterVisible
      }
    },
    slot: "reference"
  }, [_vm._v("Filter\n                        "), (_vm.cntFiltersOptions > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.cntFiltersOptions) + ")")]) : _vm._e()])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isSearchVisible()) ? _c('div', [_c('el-input', {
    attrs: {
      "placeholder": "Search",
      "suffix-icon": "el-icon-search"
    },
    model: {
      value: (_vm.term),
      callback: function($$v) {
        _vm.term = $$v
      },
      expression: "term"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.config.import) ? _c('div', {
    staticClass: "upload-btn"
  }, [_c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.uploading),
      expression: "uploading"
    }],
    ref: "upload",
    attrs: {
      "action": _vm.importEndpoint,
      "headers": _vm.rootConfig.headers,
      "before-upload": _vm.beforeUpload,
      "show-file-list": true,
      "multiple": true,
      "on-success": _vm.handleUploadSuccess,
      "on-error": _vm.handleUploadError
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Import")])], 1), _vm._v(" "), (_vm.showClearBtn) ? _c('el-button', {
    on: {
      "click": _vm.clearImport
    }
  }, [_vm._v("Clear")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.config.exportable) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.exporting),
      expression: "exporting"
    }],
    on: {
      "click": _vm.doExport
    }
  }, [_vm._v("\n                Export\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.config.hideCreate) ? _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'admin',
          params: {
            model: _vm.config.route,
            id: 'all',
            action: 'new',
          },
        })
      }
    }
  }, [_vm._v("\n                New\n            ")]) : _vm._e(), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "250",
      "trigger": "click"
    }
  }, [_c('div', [_c('el-checkbox-group', {
    staticClass: "el-checkbox-group",
    model: {
      value: (_vm.selectedVisibleColumns),
      callback: function($$v) {
        _vm.selectedVisibleColumns = $$v
      },
      expression: "selectedVisibleColumns"
    }
  }, _vm._l((_vm.config.columns), function(column) {
    return _c('div', {
      key: column.property
    }, [_c('el-checkbox', {
      key: column.property,
      attrs: {
        "label": column.property
      }
    }, [_vm._v(_vm._s(column.label))])], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetFormVisibleColumns()
      }
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveVisibleColumns()
      }
    }
  }, [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v("Column Settings")])], 1)], 1)]), _vm._v(" "), (_vm.multipleSelection.length > 0) ? _c('div', {
    staticClass: "selection"
  }, [_c('div', {
    staticClass: "selection__button"
  }, [_c('el-button', {
    on: {
      "click": _vm.massDeletion
    }
  }, [_vm._v("Delete")])], 1), _vm._v(" "), _c('span', {
    staticClass: "selection__text"
  }, [_vm._v(_vm._s(_vm.multipleSelection.length) + " selected")])]) : _vm._e(), _vm._v(" "), (
    _vm.isCategoriesRoute() &&
    _vm.multipleSelection.length === 0 &&
    _vm.isVisible
  ) ? _c('div', {
    staticClass: "mb-8"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.onToggleSortCategories()
      }
    }
  }, [_vm._v("\n            Sort categories\n        ")]), _vm._v(" "), (_vm.showSortCategories) ? _c('div', {
    staticClass: "component-example border border-gray-500 rounded border-solid p-4 mt-4 bg-white"
  }, [_c('vue-nestable', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return _c('vue-nestable-handle', {
          attrs: {
            "item": item
          }
        }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                ")])
      }
    }], null, false, 3614534639),
    model: {
      value: (_vm.nestedTableData),
      callback: function($$v) {
        _vm.nestedTableData = $$v
      },
      expression: "nestedTableData"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-4 flex"
  }, [_c('el-button', {
    staticClass: "el-button--primary mt-4",
    on: {
      "click": function($event) {
        return _vm.onSaveSortCategories()
      }
    }
  }, [_vm._v("\n                    Save\n                ")]), _vm._v(" "), _c('el-button', {
    staticClass: "mt-4",
    on: {
      "click": function($event) {
        return _vm.onCancelSortCategories()
      }
    }
  }, [_vm._v("\n                    Cancel\n                ")])], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "stripe": ""
    },
    on: {
      "sort-change": _vm.sortChange,
      "row-click": _vm.handleRowClick,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _vm._l((_vm.getVisibleColumns), function(column) {
    return _c('el-table-column', {
      key: column.property,
      attrs: {
        "sortable": _vm.isSortable(column.property),
        "label": column.label,
        "prop": column.property,
        "width": column.width
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var row = ref.row;

          return [(column.property === 'total') ? _c(column.component, {
            tag: "span",
            attrs: {
              "value": _vm._f("currency")(row[column.property], row.currency + ' ')
            }
          }) : _c(column.component, {
            tag: "span",
            class: _vm.getColumnClasses(
              column.property,
              row[column.property]
            ),
            attrs: {
              "value": _vm.getTranslation(row[column.property])
            }
          })]
        }
      }], null, true)
    })
  })], 2), _vm._v(" "), (_vm.pageSize > 0) ? _c('div', {
    staticClass: "footer"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.numFound,
      "page-size": _vm.pageSize,
      "current-page": _vm.page
    },
    on: {
      "current-change": _vm.onPageChange
    }
  })], 1) : _vm._e()], 1) : _c('div', [_c('p', [_vm._v("Voucher Code:")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.customerSupportCoupon))])]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'admin',
          params: {
            model: _vm.config.route,
            id: 'all',
            action: 'new',
          },
        })
      }
    }
  }, [_vm._v("\n      Generate new\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.value, '')))])
},staticRenderFns: []}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-crud-remote-select"
  }, [_c('el-select', {
    attrs: {
      "value": _vm.proxyValue,
      "filterable": "",
      "remote": "",
      "clearable": "",
      "placeholder": "Please enter a keyword",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading
    },
    on: {
      "input": _vm.updateValue
    }
  }, _vm._l((_vm.results), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.parent_id === 0 && _vm.shopIsSilhouette ? item[_vm.searchKey] + ' (Group)' : item[_vm.searchKey],
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "taglist"
  }, _vm._l((_vm.valueList), function(val) {
    return _c('span', {
      staticClass: "el-tag el-tag--primary"
    }, [_vm._v("\n            " + _vm._s(val.name) + "\n            "), _c('i', {
      staticClass: "el-tag__close el-icon-close",
      on: {
        "click": function($event) {
          return _vm.removeValue(val.id)
        }
      }
    })])
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("API keys")]), _vm._v(" "), _c('table', {
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.siteId))])]), _vm._v(" "), _vm._l((_vm.apiKeyData), function(dataKey, index) {
    return _c('tr', [_c('td', [_c('b', [_vm._v(_vm._s(dataKey.access) + " key:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dataKey.key))])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Shop-ID:")])])
}]}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": 350,
      "trigger": "click"
    },
    scopedSlots: _vm._u([{
      key: "reference",
      fn: function() {
        return [_c('el-button', [_c('i', {
          staticClass: "el-icon-date"
        }), _vm._v(" " + _vm._s(_vm._f("date")(_vm.dateRange[0])) + " -\n                " + _vm._s(_vm._f("date")(_vm.dateRange[1])))])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.dateRangeFilterVisible),
      callback: function($$v) {
        _vm.dateRangeFilterVisible = $$v
      },
      expression: "dateRangeFilterVisible"
    }
  }, [_vm._v(" "), _c('div', {
    staticClass: "flex flex-column gap"
  }, [_c('el-button', {
    class: {
      'is-active': _vm.dateRangeActive === 'YESTERDAY',
    },
    on: {
      "click": function($event) {
        return _vm.selectDateRange('YESTERDAY')
      }
    }
  }, [_vm._v("Yesterday")]), _vm._v(" "), _c('el-button', {
    class: {
      'is-active': _vm.dateRangeActive === 'LAST_SEVEN_DAYS',
    },
    on: {
      "click": function($event) {
        return _vm.selectDateRange('LAST_SEVEN_DAYS')
      }
    }
  }, [_vm._v("Last 7 days")]), _vm._v(" "), _c('el-button', {
    class: {
      'is-active': _vm.dateRangeActive === 'LAST_30_DAYS',
    },
    on: {
      "click": function($event) {
        return _vm.selectDateRange('LAST_30_DAYS')
      }
    }
  }, [_vm._v("Last 30 days")]), _vm._v(" "), _c('el-button', {
    class: {
      'is-active': _vm.dateRangeActive === 'LAST_MONTH',
    },
    on: {
      "click": function($event) {
        return _vm.selectDateRange('LAST_MONTH')
      }
    }
  }, [_vm._v("Last Month")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "To",
      "start-placeholder": "Start date",
      "end-placeholder": "End date",
      "format": "d.M.yyyy",
      "picker-options": _vm.datePickerOptions
    },
    model: {
      value: (_vm.dateRangePicker),
      callback: function($$v) {
        _vm.dateRangePicker = $$v
      },
      expression: "dateRangePicker"
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c(_vm.activeComponent, {
    tag: "div",
    attrs: {
      "model": _vm.model,
      "action": _vm.action,
      "id": _vm.id,
      "root-config": _vm.rootConfig,
      "config": _vm.config,
      "siteId": _vm.siteId,
      "permitted-sites-config": _vm.permittedSitesConfig
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "customer-registrations"
  }, [_c('el-menu', {
    staticClass: "flex items-center px-30 h-60",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('div', {
    staticClass: "date-picker-right"
  }, [_c('v-custom-date-range-picker', {
    on: {
      "dateRange": function (v) {
        _vm.dateRange = v;
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-30"
  }, [_c('el-row', {
    staticClass: "mb-50",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 8
    }
  }, [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("Customer Registrations")]), _vm._v(" "), _c('el-card', {
    attrs: {
      "shadow": "none"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "text-big"
  }, [_vm._v(_vm._s(_vm.statisticsData.customer_registrations_count || 0))]), _vm._v(" "), _c('div', [_vm._v("New customers in selected period")])])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-checkbox', {
    attrs: {
      "value": _vm.value,
      "label": _vm.label
    },
    on: {
      "change": _vm.updateValue
    }
  })
},staticRenderFns: []}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.model.general_setting) ? _c('div', [_c('h4', {
    staticClass: "group__headline"
  }, [_vm._v("Automatic cancellation")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Automatic cancellation"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.general_setting.auto_cancel_orders),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_cancel_orders", $$v)
      },
      expression: "model.general_setting.auto_cancel_orders"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.general_setting.auto_cancel_orders),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_cancel_orders", $$v)
      },
      expression: "model.general_setting.auto_cancel_orders"
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Days until automatic cancellation"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.auto_cancel_orders_in_days),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_cancel_orders_in_days", $$v)
      },
      expression: "model.general_setting.auto_cancel_orders_in_days"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Automatically fill up stock"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.general_setting.auto_stock_refill),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_stock_refill", $$v)
      },
      expression: "model.general_setting.auto_stock_refill"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.general_setting.auto_stock_refill),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_stock_refill", $$v)
      },
      expression: "model.general_setting.auto_stock_refill"
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), _c('h4', {
    staticClass: "group__headline mt-20"
  }, [_vm._v("Abandonded cart")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Send reminder"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.general_setting.auto_abandonded),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_abandonded", $$v)
      },
      expression: "model.general_setting.auto_abandonded"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.general_setting.auto_abandonded),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_abandonded", $$v)
      },
      expression: "model.general_setting.auto_abandonded"
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "In how many minutes?"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.auto_abandonded_in_minutes),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_abandonded_in_minutes", $$v)
      },
      expression: "model.general_setting.auto_abandonded_in_minutes"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "BCC email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.auto_abandoned_bcc),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_abandoned_bcc", $$v)
      },
      expression: "model.general_setting.auto_abandoned_bcc"
    }
  }), _vm._v(" "), _vm._l((_vm.modelOrigin), function(data, index) {
    return [(
      data.setting_key === 'auto_abandoned_bcc' &&
      _vm.origins.length &&
      _vm.isValidOrigin(data.origin_id)
    ) ? _c('div', {
      staticClass: "mt-4 p-4 border rounded border-gray-500 border-solid w-1/2 ml-auto"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "grow-0 shrink-0 basis-32"
    }, [_vm._v("\n                        Setting for " + _vm._s(_vm.getOriginName(data.origin_id)) + "\n                    ")]), _vm._v(" "), _c('el-input', {
      model: {
        value: (_vm.modelOrigin[index].setting),
        callback: function($$v) {
          _vm.$set(_vm.modelOrigin[index], "setting", $$v)
        },
        expression: "modelOrigin[index].setting"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "flex justify-end mt-4"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.onSubmitOriginSetting(
            data.id,
            _vm.modelOrigin[index].setting
          )
        }
      }
    }, [_vm._v("Save setting for\n                        " + _vm._s(_vm.getOriginName(data.origin_id)))])], 1)]) : _vm._e()]
  })], 2), _vm._v(" "), _c('h4', {
    staticClass: "group__headline mt-20"
  }, [_vm._v("Outstanding payments")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Send reminder"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.general_setting.unpaid_orders_alert_enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "unpaid_orders_alert_enabled", $$v)
      },
      expression: "model.general_setting.unpaid_orders_alert_enabled"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.general_setting.unpaid_orders_alert_enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "unpaid_orders_alert_enabled", $$v)
      },
      expression: "model.general_setting.unpaid_orders_alert_enabled"
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "In how many days?"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.auto_reminder_in_days),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_reminder_in_days", $$v)
      },
      expression: "model.general_setting.auto_reminder_in_days"
    }
  })], 1), _vm._v(" "), _c('h4', {
    staticClass: "group__headline mt-20"
  }, [_vm._v("Automatically mark as delivered")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Automatically mark as delivered"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.general_setting.auto_update_delivered),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_update_delivered", $$v)
      },
      expression: "model.general_setting.auto_update_delivered"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.general_setting.auto_update_delivered),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_update_delivered", $$v)
      },
      expression: "model.general_setting.auto_update_delivered"
    }
  }, [_vm._v("No")])], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "Predefined"
    }
  }, [_c('el-select', {
    attrs: {
      "value": ""
    },
    on: {
      "input": _vm.updateCannedMsg
    }
  }, _vm._l((_vm.cannedMessages), function(option) {
    return _c('el-option', {
      key: option.id,
      attrs: {
        "label": option.name,
        "value": option.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Recipient"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.message.email),
      callback: function($$v) {
        _vm.$set(_vm.message, "email", $$v)
      },
      expression: "message.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Subject"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.message.subject),
      callback: function($$v) {
        _vm.$set(_vm.message, "subject", $$v)
      },
      expression: "message.subject"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Message"
    }
  }, [_c('wysiwyg', {
    model: {
      value: (_vm.message.content),
      callback: function($$v) {
        _vm.$set(_vm.message, "content", $$v)
      },
      expression: "message.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("Send")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "label-position": "left",
      "model": _vm.model,
      "label-width": "242px"
    }
  }, [_c('div', {
    staticClass: "edit__actions"
  }, [_c('el-button', {
    staticClass: "btn-back",
    attrs: {
      "type": "secondary"
    },
    on: {
      "click": _vm.onBack
    }
  }, [_vm._v("Back to overview")]), _vm._v(" "), _c('div', [(_vm.isOrderDetail()) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onDownloadExcel
    }
  }, [_vm._v("Download as XLS")]) : _vm._e(), _vm._v(" "), (_vm.isOrderDetail()) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onPrint
    }
  }, [_vm._v("Print")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.config.formFields), function(tab) {
    return _c('el-tab-pane', {
      key: tab.label,
      attrs: {
        "label": tab.label
      }
    }, [_vm._l((tab.body), function(item) {
      return _c(item.component, {
        key: item._uid,
        tag: "div",
        attrs: {
          "siteId": _vm.siteId,
          "permitted-sites-config": _vm.permittedSitesConfig,
          "model": _vm.model,
          "config": item,
          "root-config": _vm.rootConfig,
          "options": item.options
        }
      })
    }), _vm._v(" "), _vm._l((tab.fields), function(field) {
      return _c('el-form-item', {
        key: field.name,
        attrs: {
          "label": field.label
        }
      }, [_c(field.component, {
        tag: "div",
        attrs: {
          "placeholder": field.placeholder,
          "root-config": _vm.rootConfig,
          "options": field.options,
          "type": field.type,
          "root-model": _vm.model
        },
        model: {
          value: (_vm.model[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.model, field.name, $$v)
          },
          expression: "model[field.name]"
        }
      })], 1)
    })], 2)
  }), 1), _vm._v(" "), (!_vm.config.hideActionBar) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'admin',
          params: {
            id: 'all',
            action: 'index'
          },
        })
      }
    }
  }, [_vm._v("Cancel")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    attrs: {
      "value": _vm.value,
      "placeholder": _vm.placeholder
    },
    on: {
      "input": _vm.updateValue
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('el-option', {
      key: option.value,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centered"
  }, [_vm._v("Your session expired. Please reload the window.")])
},staticRenderFns: []}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("\n        #" + _vm._s(_vm.model.order_number) + "\n        "), _c('small', {
    staticClass: "order__time"
  }, [_vm._v(_vm._s(_vm._f("datetime")(_vm.model.ordered_on)))])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 16
    }
  }, [(_vm.model.order_items) ? _c('div', [(_vm.hasSku) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.model.order_items,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "image",
      "label": "Image"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.image) ? _c('div', [_c('img', {
          attrs: {
            "src": scope.row.image,
            "width": "40"
          }
        })]) : _vm._e()]
      }
    }], null, false, 813630063)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sku",
      "label": "Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row) ? _c('div', [(
          scope.row.meta_data &&
          scope.row.meta_data.name
        ) ? _c('span', [_vm._v(_vm._s(scope.row.meta_data.name)), _c('br')]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "label-lg"
        }, [_vm._v(_vm._s(scope.row.sku))]), _vm._v(" "), (
          scope.row.selected_products &&
          scope.row.meta_data &&
          scope.row.meta_data.properties &&
          _vm.isDynamicPackage(
            scope.row.meta_data.properties
          )
        ) ? _c('div', {
          staticClass: "mt-5"
        }, [_c('strong', [_vm._v("Included products:")]), _vm._v(" "), _vm._l((scope.row.selected_products), function(selectedProduct, index) {
          return _c('div', {
            key: selectedProduct.id + index
          }, [_c('span', [_vm._v(_vm._s(selectedProduct.name))]), _c('br'), _c('span', {
            staticClass: "label-lg"
          }, [_vm._v(_vm._s(selectedProduct.sku))])])
        })], 2) : _vm._e(), _vm._v(" "), (
          scope.row.selected_products &&
          scope.row.meta_data &&
          scope.row.meta_data.properties &&
          _vm.isDynamicPricePackage(
            scope.row.meta_data.properties
          )
        ) ? _c('div', {
          staticClass: "mt-5"
        }, [_c('strong', [_vm._v("Included products:")]), _vm._v(" "), _vm._l((scope.row.selected_products), function(selectedProduct, index) {
          return _c('div', {
            key: selectedProduct.id + index
          }, [_vm._v("\n                                        " + _vm._s(selectedProduct.name) + " (" + _vm._s(_vm._f("currency")(selectedProduct.price,
            selectedProduct.currency +
            ' '
          )) + ")\n                                    ")])
        })], 2) : _vm._e()]) : _vm._e()]
      }
    }], null, false, 996529527)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row && scope.row.value) ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(scope.row.value, _vm.model.currency + ' ')) + "\n                            ")]) : _vm._e()]
      }
    }], null, false, 1536985407)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Quantity",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_price",
      "label": "Total",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row) ? _c('div', [(
          scope.row.meta_data &&
          scope.row.meta_data.properties &&
          _vm.isDynamicPricePackage(
            scope.row.meta_data.properties
          )
        ) ? _c('div', [(
          scope.row.total_value &&
          scope.row.discount
        ) ? _c('div', [_vm._v("\n                                        " + _vm._s(_vm._f("currency")((scope.row.total_value -
            Math.abs(
              scope.row.discount
            )),
          _vm.model.currency + ' '
        )) + "\n                                    ")]) : _vm._e(), _vm._v(" "), (scope.row.total_value) ? _c('div', {
          staticClass: "text-zinc-400"
        }, [_c('del', [_vm._v(_vm._s(_vm._f("currency")(scope.row.total_value,
          _vm.model.currency + ' '
        )))])]) : _vm._e(), _vm._v(" "), (scope.row.discount) ? _c('div', [_c('strong', [_vm._v("Your savings:")]), _c('br'), _vm._v(_vm._s(_vm._f("currency")(Math.abs(scope.row.discount),
          _vm.model.currency + ' '
        )) + "\n                                    ")]) : _vm._e()]) : (scope.row.total_value) ? _c('div', [_vm._v("\n                                    " + _vm._s(_vm._f("currency")(scope.row.total_value, _vm.model.currency + ' ')) + "\n                                ")]) : _vm._e()]) : _vm._e()]
      }
    }], null, false, 1429764037)
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.hasSku) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.model.order_items,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "meta_data",
      "label": "Product Info"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.contents) ? _c('div', [_vm._v("\n                                " + _vm._s(scope.row.contents.sku) + " -\n                                " + _vm._s(scope.row.contents.name) + "\n                            ")]) : _vm._e()]
      }
    }], null, false, 207270700)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Quantity",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_price",
      "label": "Total",
      "width": "180"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "el-table"
  }, [_c('div', {
    staticClass: "el-table__footer-wrapper"
  }, [_c('table', {
    staticClass: "el-table__footer",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "is-leaf"
  }, [_c('div', {
    staticClass: "cell text-right"
  }, [_vm._v("\n                                        Subtotal\n                                    ")])]), _vm._v(" "), _c('td', {
    staticClass: "is-leaf",
    attrs: {
      "width": "180"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("\n                                        " + _vm._s(_vm._f("currency")(_vm.model.subtotal,
    _vm.model.currency + ' '
  )) + "\n                                    ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "is-leaf"
  }, [_c('div', {
    staticClass: "cell text-right"
  }, [_vm._v("\n                                        Shipping\n                                    ")])]), _vm._v(" "), _c('td', {
    staticClass: "is-leaf",
    attrs: {
      "width": "180"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("\n                                        " + _vm._s(_vm._f("currency")(_vm.model.shipping,
    _vm.model.currency + ' '
  )) + "\n                                    ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "is-leaf"
  }, [_c('div', {
    staticClass: "cell text-right"
  }, [_vm._v("\n                                        Discount\n                                    ")])]), _vm._v(" "), _c('td', {
    staticClass: "is-leaf",
    attrs: {
      "width": "180"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("\n                                        " + _vm._s(_vm._f("currency")(_vm.model.coupon_discount,
    _vm.model.currency + ' '
  )) + "\n                                    ")])])]), _vm._v(" "), (
    _vm.model.applied_coupons &&
    _vm.model.applied_coupons.length
  ) ? _c('tr', [_c('td', {
    staticClass: "is-leaf"
  }, [_c('div', {
    staticClass: "cell text-right"
  }, [_vm._v("\n                                        Applied coupons\n                                    ")])]), _vm._v(" "), _c('td', {
    staticClass: "is-leaf",
    attrs: {
      "width": "180"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, _vm._l((_vm.model.applied_coupons), function(coupon) {
    return _c('div', {
      key: coupon.id
    }, [_vm._v("\n                                            " + _vm._s(coupon.name) + " (ID:\n                                            " + _vm._s(coupon.id) + ")\n                                        ")])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "is-leaf"
  }, [_c('div', {
    staticClass: "cell text-right"
  }, [_vm._v("Tax")])]), _vm._v(" "), _c('td', {
    staticClass: "is-leaf",
    attrs: {
      "width": "180"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("\n                                        " + _vm._s(_vm._f("currency")(_vm.model.tax,
    _vm.model.currency + ' '
  )) + "\n                                    ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "is-leaf"
  }, [_c('div', {
    staticClass: "cell text-right"
  }, [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    staticClass: "is-leaf",
    attrs: {
      "width": "180"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("\n                                        " + _vm._s(_vm._f("currency")(_vm.model.total,
    _vm.model.currency + ' '
  )) + "\n                                    ")])])])])])])]), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "order__subhead"
  }, [_vm._v("History")]), _vm._v(" "), (!_vm.model.histories || !_vm.model.histories.length) ? _c('div', [_vm._v("\n                    No history yet\n                ")]) : _vm._e(), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.model.histories
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Date",
      "prop": "created_at"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm._f("datetime")(scope.row.created_at)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "prop": "action"
    }
  })], 1), _vm._v(" "), _c('h4', {
    staticClass: "order__subhead"
  }, [_vm._v("Payments")]), _vm._v(" "), (!_vm.model.payments || !_vm.model.payments.length) ? _c('div', [_vm._v("\n                    No payments yet\n                ")]) : _vm._e(), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.model.payments
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Date",
      "prop": "created_at"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm._f("datetime")(scope.row.created_at)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status",
      "prop": "status"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Module",
      "prop": "module"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8
    }
  }, [_c('dl', {
    staticClass: "dl"
  }, [_c('dt', [_vm._v("Status")]), _vm._v(" "), _c('dd', [_c('v-crud-select', {
    staticClass: "order__full",
    attrs: {
      "options": _vm.statuses,
      "value": _vm.model.status
    },
    on: {
      "input": _vm.onChangeInput
    }
  })], 1), _vm._v(" "), _c('dt', [_vm._v("Shipping method")]), _vm._v(" "), _c('dd', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s(_vm.model.shipping_method_name))]), _vm._v(" "), _c('dt', [_vm._v("Tracking number")]), _vm._v(" "), _c('dd', [_c('el-input', {
    staticClass: "order__full",
    model: {
      value: (_vm.model.tracking_number),
      callback: function($$v) {
        _vm.$set(_vm.model, "tracking_number", $$v)
      },
      expression: "model.tracking_number"
    }
  })], 1), _vm._v(" "), (_vm.isVisible) ? [_c('dt', [_vm._v("Business Partner ID (End User)")]), _vm._v(" "), _c('dd', [_c('el-input', {
    staticClass: "order__full",
    model: {
      value: (_vm.model.ext_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "ext_id", $$v)
      },
      expression: "model.ext_id"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.showInvoice) ? [_c('dt', [_vm._v("Invoice number")]), _vm._v(" "), _c('dd', [_c('el-input', {
    staticClass: "order__full",
    model: {
      value: (_vm.model.notes),
      callback: function($$v) {
        _vm.$set(_vm.model, "notes", $$v)
      },
      expression: "model.notes"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('dd', [_c('el-button', {
    staticClass: "order__full",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1), _vm._v(" "), (_vm.showInvoice) ? [_c('dd', [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.invoiceLoading),
      expression: "invoiceLoading"
    }],
    staticClass: "order__full",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getInvoicePdf
    }
  }, [_vm._v("Download invoice")])], 1)] : _vm._e(), _vm._v(" "), (_vm.showInvoice) ? [_c('dd', [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.sendInvoiceLoading),
      expression: "sendInvoiceLoading"
    }],
    staticClass: "order__full",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendInvoicePdf
    }
  }, [_vm._v("Send invoice via e-mail")])], 1)] : _vm._e(), _vm._v(" "), _c('dt', [_vm._v("Email")]), _vm._v(" "), _c('dd', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s(_vm.model.email))]), _vm._v(" "), _c('dt', [_vm._v("Address")]), _vm._v(" "), (_vm.model.ship_address) ? _c('dd', {
    staticClass: "text-sm"
  }, [_c('span', {
    staticClass: "el-button--text cursor-pointer",
    on: {
      "click": _vm.goToCustomer
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.model.ship_address.firstname) + "\n                        " + _vm._s(_vm.model.ship_address.lastname) + "\n                    ")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.model.ship_address.address1) + "\n                    " + _vm._s(_vm.model.ship_address.address2)), _c('br'), _vm._v("\n                    " + _vm._s(_vm.model.ship_address.zip) + " " + _vm._s(_vm.model.ship_address.city)), _c('br'), _vm._v("\n                    " + _vm._s(_vm.model.ship_address.country) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('dt', [_vm._v("Shipping Notes")]), _vm._v(" "), (_vm.model.shipping_notes) ? _c('dd', {
    staticClass: "text-sm"
  }, [_c('ul', _vm._l((_vm.model.shipping_notes), function(value, key) {
    return _c('li', [_c('em', [_vm._v(_vm._s(key) + ":")]), _vm._v(" " + _vm._s(value) + "\n                        ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('dd', [_c('el-button', {
    staticClass: "order__full",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goToCustomer
    }
  }, [_vm._v("Edit Customer")])], 1)], 2)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "el-upload-list el-upload-list--picture"
  }, _vm._l((_vm.fileList), function(file) {
    return _c('li', {
      staticClass: "el-upload-list__item"
    }, [_c('a', {
      attrs: {
        "href": _vm.imgService + file.filename,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "el-upload-list__item-thumbnail",
      attrs: {
        "src": _vm.imgService + file.filename,
        "alt": ""
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "el-upload-list__item-name"
    }, [_c('el-button', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.handleDelete(file)
        }
      }
    }, [_vm._v("Delete")])], 1)])
  }), 0), _vm._v(" "), _c('el-upload', {
    ref: "imageupload",
    attrs: {
      "action": _vm.importEndpoint,
      "headers": _vm.rootConfig.headers,
      "before-upload": _vm.beforeUpload,
      "show-file-list": false,
      "multiple": true,
      "on-success": _vm.handleUploadSuccess,
      "on-error": _vm.handleUploadError,
      "on-change": _vm.handleChange,
      "list-type": "picture"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("Click to upload")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("\n            jpg/png files with a size less than 5000kb\n        ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm._f("datetime")(_vm.value)))])
},staticRenderFns: []}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.model,
      "modelOrigin": _vm.modelOrigin,
      "label-width": "242px",
      "label-position": "left"
    }
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.config.formFields), function(tab) {
    return _c('el-tab-pane', {
      key: tab.label,
      attrs: {
        "label": tab.label
      }
    }, [_vm._l((tab.body), function(item) {
      return _c(item.component, {
        key: item._uid,
        tag: "div",
        attrs: {
          "model": _vm.model,
          "modelOrigin": _vm.modelOrigin,
          "settings": _vm.settings,
          "root-config": _vm.rootConfig,
          "api": _vm.api,
          "options": item.options
        },
        on: {
          "updated": _vm.assignSettings
        }
      })
    }), _vm._v(" "), _vm._l((tab.fields), function(field) {
      return _c('el-form-item', {
        key: field.name,
        attrs: {
          "label": field.label
        }
      }, [(_vm.model[field.name.split('.')[0]]) ? _c(field.component, {
        tag: "div",
        attrs: {
          "placeholder": field.placeholder,
          "root-config": _vm.rootConfig,
          "options": field.options,
          "type": field.type,
          "root-model": _vm.model
        },
        model: {
          value: (
            _vm.model[field.name.split('.')[0]][
              field.name.split('.')[1]
            ]
          ),
          callback: function($$v) {
            _vm.$set(_vm.model[field.name.split('.')[0]],
              field.name.split('.')[1], $$v)
          },
          expression: "\n                            model[field.name.split('.')[0]][\n                                field.name.split('.')[1]\n                            ]\n                        "
        }
      }) : _vm._e()], 1)
    })], 2)
  }), 1), _vm._v(" "), (!_vm.hideSave) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Save")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "reports"
  }, [_c('el-menu', {
    staticClass: "flex items-center px-30 h-60",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Overview")]), _vm._v(" "), _c('v-custom-date-range-picker', {
    on: {
      "dateRange": function (v) {
        _vm.dateRange = v;
      }
    }
  })], 1), _vm._v(" "), (_vm.reportData) ? _c('div', {
    staticClass: "p-30"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [(_vm.reportData.order_details) ? _c('el-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12
    }
  }, [_c('h3', [_vm._v("Order statistics")])]), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "sm": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin',
        params: {
          model: 'report',
          id: 'order_details',
          action: 'all',
        },
      }
    }
  }, [_vm._v("Detailed statistics »")])], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "cursor-pointer",
    attrs: {
      "shadow": "hover"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.navigateToDetail('order_details')
      }
    }
  }, [(_vm.showDetailChart()) ? _c('chart-bar-and-line', {
    attrs: {
      "data": _vm.getOrderDetailsData
    }
  }) : _c('div', {
    staticClass: "text-gray"
  }, [_vm._v("No data available.")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.subscription_data) ? _c('el-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("General statistics")]), _vm._v(" "), _c('el-card', {
    staticClass: "mb-10",
    attrs: {
      "shadow": "none"
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "sm": 12
    }
  }, [_c('div', {
    staticClass: "text-big"
  }, [_vm._v("\n                                " + _vm._s(_vm.reportData.subscription_data.all_orders) + "\n                            ")]), _vm._v("\n                            Orders\n                        ")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "sm": 12
    }
  }, [_c('div', {
    staticClass: "text-big"
  }, [_vm._v("\n                                " + _vm._s(_vm.reportData.subscription_data
    .products_sold) + "\n                            ")]), _vm._v("\n                            Products\n                        ")])], 1)], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "shadow": "none"
    }
  }, [_c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    staticClass: "text-right text-highlight",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_vm._v(_vm._s(_vm.reportData.subscription_data.status))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_vm._v("Shop status")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    staticClass: "text-right text-highlight",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_vm._v(_vm._s(_vm.reportData.subscription_data.products_count))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_vm._v("Products in total")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    staticClass: "text-right text-highlight",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.reportData.subscription_data.total,
    _vm.reportData.subscription_data
    .currency
  )))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_vm._v("Total orders")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    staticClass: "text-right text-highlight",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.reportData.subscription_data.paid_orders,
    _vm.reportData.subscription_data
    .currency
  )))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_vm._v("Orders paid")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    staticClass: "text-right text-highlight",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_vm._v(_vm._s(_vm._f("currency")((_vm.reportData.subscription_data.tickets || 0),
    _vm.reportData.subscription_data
    .currency
  )) + "\n                        ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_vm._v("Average total")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.reportData.best_sellers) ? _c('div', {
    staticClass: "mb-50"
  }, [_c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12
    }
  }, [_c('h3', [_vm._v("Best selling products")])]), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "sm": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin',
        params: {
          model: 'report',
          id: 'best_seller',
          action: 'all',
        },
      }
    }
  }, [_vm._v("Detailed statistics »")])], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "cursor-pointer",
    attrs: {
      "shadow": "hover"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.navigateToDetail('best_seller')
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [(_vm.getBestsellerData.values.length > 0) ? _c('chart-pie', {
    attrs: {
      "data": _vm.getBestsellerData
    }
  }) : _c('div', {
    staticClass: "text-gray"
  }, [_vm._v("\n                            No data available.\n                        ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [(_vm.reportData.best_sellers.length > 0) ? _c('table', {
    staticClass: "w-full"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left px-12"
  }, [_vm._v("Top 5")]), _vm._v(" "), _c('th', {
    staticClass: "text-right px-12"
  }, [_vm._v("\n                                        Quantity\n                                    ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.reportData.best_sellers), function(bestseller, i) {
    return (i < 5) ? _c('tr', [_c('td', [_vm._v("\n                                        " + _vm._s(bestseller.sku) + " -\n                                        " + _vm._s(bestseller.name) + "\n                                    ")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("\n                                        " + _vm._s(bestseller.quantity) + "\n                                    ")])]) : _vm._e()
  }), 0)]) : _vm._e()])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [(_vm.reportData.new_vs_recurring_orders) ? _c('el-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12
    }
  }, [_c('h3', [_vm._v("New x Existing customers")])]), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "sm": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin',
        params: {
          model: 'report',
          id: 'returning_visitors',
          action: 'all',
        },
      }
    }
  }, [_vm._v("Detailed statistics »")])], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "cursor-pointer",
    attrs: {
      "shadow": "hover"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.navigateToDetail('returning_visitors')
      }
    }
  }, [_c('chart-progress', {
    attrs: {
      "value1": _vm.reportData.new_vs_recurring_orders[1].orders,
      "value2": _vm.reportData.new_vs_recurring_orders[0].orders,
      "description1": _vm.reportData.new_vs_recurring_orders[1].type,
      "description2": _vm.reportData.new_vs_recurring_orders[0].type
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.gender_based_orders) ? _c('el-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12
    }
  }, [_c('h3', [_vm._v("Male x Female")])]), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "sm": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin',
        params: {
          model: 'report',
          id: 'gender',
          action: 'all',
        },
      }
    }
  }, [_vm._v("Detailed statistics »")])], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "cursor-pointer",
    attrs: {
      "shadow": "hover"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.navigateToDetail('gender')
      }
    }
  }, [_c('chart-progress', {
    attrs: {
      "value1": _vm.reportData.gender_based_orders[0]
        .number_of_orders,
      "value2": _vm.reportData.gender_based_orders[1]
        .number_of_orders,
      "description1": _vm.reportData.gender_based_orders[0].gender,
      "description2": _vm.reportData.gender_based_orders[1].gender
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [(_vm.reportData.abandoned_vs_completed) ? _c('el-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12
    }
  }, [_c('h3', [_vm._v("Aborted x Completed")])]), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "sm": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin',
        params: {
          model: 'report',
          id: 'abandoned',
          action: 'all',
        },
      }
    }
  }, [_vm._v("Detailed statistics »")])], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "cursor-pointer",
    attrs: {
      "shadow": "hover"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.navigateToDetail('abandoned')
      }
    }
  }, [_c('chart-progress', {
    attrs: {
      "value1": _vm.reportData.abandoned_vs_completed[1]
        .orders_number,
      "value2": _vm.reportData.abandoned_vs_completed[0]
        .orders_number,
      "description1": _vm.reportData.abandoned_vs_completed[1].type,
      "description2": _vm.reportData.abandoned_vs_completed[0].type
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.get_in_vs_out_of_stock) ? _c('el-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12
    }
  }, [_c('h3', [_vm._v("Orders without stock")])]), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "sm": 12
    }
  })], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "shadow": "none"
    }
  }, [_c('chart-progress', {
    attrs: {
      "value1": _vm.reportData.get_in_vs_out_of_stock[1]
        .number_of_products,
      "value2": _vm.reportData.get_in_vs_out_of_stock[0]
        .number_of_products,
      "description1": _vm.reportData.get_in_vs_out_of_stock[1].type,
      "description2": _vm.reportData.get_in_vs_out_of_stock[0].type
    }
  })], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('div', [(_vm.fullMode) ? _c('div', [(_vm.loggedIn) ? _c('div', [_c('div', [_c('el-container', [(!_vm.isPrintMode) ? _c('el-aside', {
    attrs: {
      "width": "200px"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu--vertical",
    attrs: {
      "background-color": "#545c64",
      "text-color": "#fff",
      "active-text-color": "#09b3af"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    },
    on: {
      "click": function($event) {
        return _vm.navigateToReports()
      }
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/netural_logo.svg"
    }
  })]), _vm._v(" "), (_vm.hasUserRolePermission('sales')) ? _c('el-menu-item', {
    attrs: {
      "index": "2"
    },
    on: {
      "click": function($event) {
        return _vm.sidebarClick(509644)
      }
    }
  }, [_vm._v("\n                                Sales\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.hasUserRolePermission('catalogue')) ? _c('el-menu-item', {
    attrs: {
      "index": "3"
    },
    on: {
      "click": function($event) {
        return _vm.sidebarClick(509643)
      }
    }
  }, [_vm._v("\n                                Catalogue\n                            ")]) : _vm._e(), _vm._v(" "), (
    _vm.isVisible &&
    _vm.hasUserRolePermission('contents')
  ) ? _c('el-menu-item', {
    attrs: {
      "index": "4"
    },
    on: {
      "click": function($event) {
        return _vm.sidebarContentsClick()
      }
    }
  }, [_vm._v("\n                                Contents\n                            ")]) : _vm._e(), _vm._v(" "), (
    _vm.hasUserRolePermission('configuration')
  ) ? _c('el-menu-item', {
    attrs: {
      "index": "5"
    },
    on: {
      "click": function($event) {
        return _vm.sidebarClick(509645)
      }
    }
  }, [_vm._v("\n                                Configuration\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.isVisible && !_vm.isRestricted('report') && !_vm.isRestricted('customer_registrations')) ? _c('el-submenu', {
    attrs: {
      "index": "6"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Statistics")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "6-1"
    },
    on: {
      "click": function($event) {
        return _vm.navigateToStatistics()
      }
    }
  }, [_vm._v("\n                                    Reports\n                                ")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "6-2"
    },
    on: {
      "click": function($event) {
        return _vm.navigateToCustomerRegistrations()
      }
    }
  }, [_vm._v("\n                                    Registrations\n                                ")])], 2) : _vm._e(), _vm._v(" "), (
    _vm.hasUserRolePermission(
      'coupons_customer_support'
    ) && _vm.isCustomerSupport()
  ) ? _c('el-menu-item', {
    attrs: {
      "index": "7"
    },
    on: {
      "click": function($event) {
        return _vm.sidebarClick(523060705)
      }
    }
  }, [_vm._v("\n                                Coupon\n                            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "el-menu__logout"
  }, [_c('el-button', {
    staticClass: "el-menu__logout-button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onLogout()
      }
    }
  }, [_vm._v("Logout")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-main', [(!_vm.isPrintMode) ? _c('el-menu', {
    attrs: {
      "default-active": "1",
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_vm._l((_vm.getVisibleTabItems(
    _vm.config.body
  )), function(nav, index) {
    return [(
      _vm.hasUserRolePermission(
        nav.route.toLowerCase()
      ) &&
      !_vm.isRestricted(
        nav.route.toLowerCase()
      ) &&
      !_vm.isCustomerSupport()
    ) ? _c('el-menu-item', {
      key: index,
      attrs: {
        "index": nav.route
      }
    }, [_c('span', [_vm._v(_vm._s(nav.name))])]) : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.activeConfig != null) ? _c('div', {
    class: {
      container: _vm.config.body.length
    }
  }, [_c(_vm.activeConfig.component, {
    tag: "div",
    attrs: {
      "model": _vm.model,
      "action": _vm.action,
      "id": _vm.id,
      "root-config": _vm.config,
      "config": _vm.activeConfig,
      "site-id": _vm.login.site_id,
      "permitted-sites-config": _vm.permittedSitesConfig
    }
  })], 1) : _vm._e()], 1)], 1)], 1)]) : _c('div', [_c('el-container', [_c('el-main', {
    staticClass: "login__container"
  }, [_c('el-form', {
    ref: "login",
    staticClass: "login",
    attrs: {
      "model": _vm.login,
      "status-icon": "",
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Shop ID",
      "prop": "site_id"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "site_id"
    },
    model: {
      value: (_vm.login.site_id),
      callback: function($$v) {
        _vm.$set(_vm.login, "site_id", $$v)
      },
      expression: "login.site_id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email"
    },
    model: {
      value: (_vm.login.email),
      callback: function($$v) {
        _vm.$set(_vm.login, "email", $$v)
      },
      expression: "login.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.login.password),
      callback: function($$v) {
        _vm.$set(_vm.login, "password", $$v)
      },
      expression: "login.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "native-type": "submit",
      "type": "primary"
    }
  }, [_vm._v("Login")])], 1)], 1)], 1)], 1)], 1)]) : _c('div', [_c('el-menu', {
    attrs: {
      "default-active": "1",
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_vm._l((_vm.getVisibleTabItems(_vm.config.body)), function(nav, index) {
    return [(
      _vm.hasUserRolePermission(nav.route.toLowerCase()) &&
      !_vm.isRestricted(nav.route.toLowerCase())
    ) ? _c('el-menu-item', {
      key: index,
      attrs: {
        "index": nav.route
      }
    }, [_c('span', [_vm._v(_vm._s(nav.name))])]) : _vm._e()]
  })], 2), _vm._v(" "), (_vm.activeConfig != null) ? _c('div', {
    staticClass: "container"
  }, [_c(_vm.activeConfig.component, {
    tag: "div",
    attrs: {
      "model": _vm.model,
      "action": _vm.action,
      "id": _vm.id,
      "root-config": _vm.config,
      "config": _vm.activeConfig
    }
  })], 1) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.model.general_setting) ? _c('div', [_c('h4', {
    staticClass: "group__headline"
  }, [_vm._v("Settings")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Failed products import email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.failed_import_notifier),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "failed_import_notifier", $$v)
      },
      expression: "model.general_setting.failed_import_notifier"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Domain"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.domain),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "domain", $$v)
      },
      expression: "model.general_setting.domain"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Main email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.email),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "email", $$v)
      },
      expression: "model.general_setting.email"
    }
  }), _vm._v(" "), _vm._l((_vm.modelOrigin), function(data, index) {
    return [(
      data.setting_key === 'email' &&
      _vm.origins.length &&
      _vm.isValidOrigin(data.origin_id)
    ) ? _c('div', {
      staticClass: "mt-4 p-4 border rounded border-gray-500 border-solid w-1/2 ml-auto"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "grow-0 shrink-0 basis-32"
    }, [_vm._v("\n                        Setting for " + _vm._s(_vm.getOriginName(data.origin_id)) + "\n                    ")]), _vm._v(" "), _c('el-input', {
      model: {
        value: (_vm.modelOrigin[index].setting),
        callback: function($$v) {
          _vm.$set(_vm.modelOrigin[index], "setting", $$v)
        },
        expression: "modelOrigin[index].setting"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "flex justify-end mt-4"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.onSubmitOriginSetting(
            data.id,
            _vm.modelOrigin[index].setting
          )
        }
      }
    }, [_vm._v("Save setting for\n                        " + _vm._s(_vm.getOriginName(data.origin_id)))])], 1)]) : _vm._e()]
  })], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Contact email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.contact_email),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "contact_email", $$v)
      },
      expression: "model.general_setting.contact_email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "BCC email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.bcc_email),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "bcc_email", $$v)
      },
      expression: "model.general_setting.bcc_email"
    }
  }), _vm._v(" "), _vm._l((_vm.modelOrigin), function(data, index) {
    return [(
      data.setting_key === 'bcc_email' &&
      _vm.origins.length &&
      _vm.isValidOrigin(data.origin_id)
    ) ? _c('div', {
      staticClass: "mt-4 p-4 border rounded border-gray-500 border-solid w-1/2 ml-auto"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "grow-0 shrink-0 basis-32"
    }, [_vm._v("\n                        Setting for " + _vm._s(_vm.getOriginName(data.origin_id)) + "\n                    ")]), _vm._v(" "), _c('el-input', {
      model: {
        value: (_vm.modelOrigin[index].setting),
        callback: function($$v) {
          _vm.$set(_vm.modelOrigin[index], "setting", $$v)
        },
        expression: "modelOrigin[index].setting"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "flex justify-end mt-4"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.onSubmitOriginSetting(
            data.id,
            _vm.modelOrigin[index].setting
          )
        }
      }
    }, [_vm._v("Save setting for\n                        " + _vm._s(_vm.getOriginName(data.origin_id)))])], 1)]) : _vm._e()]
  })], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Stock alert email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.stock_alert_emails),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "stock_alert_emails", $$v)
      },
      expression: "model.general_setting.stock_alert_emails"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Stock alert trigger"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.stock_alert_email_trigger),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "stock_alert_email_trigger", $$v)
      },
      expression: "model.general_setting.stock_alert_email_trigger"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Activate new customers"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.general_setting.new_customer_status),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "new_customer_status", $$v)
      },
      expression: "model.general_setting.new_customer_status"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.general_setting.new_customer_status),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "new_customer_status", $$v)
      },
      expression: "model.general_setting.new_customer_status"
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Logo URL"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.site_logo),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "site_logo", $$v)
      },
      expression: "model.general_setting.site_logo"
    }
  }), _vm._v(" "), _vm._l((_vm.modelOrigin), function(data, index) {
    return [(
      data.setting_key === 'site_logo' &&
      _vm.origins.length &&
      _vm.isValidOrigin(data.origin_id)
    ) ? _c('div', {
      staticClass: "mt-4 p-4 border rounded border-gray-500 border-solid w-1/2 ml-auto"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "grow-0 shrink-0 basis-32"
    }, [_vm._v("\n                        Setting for " + _vm._s(_vm.getOriginName(data.origin_id)) + "\n                    ")]), _vm._v(" "), _c('el-input', {
      model: {
        value: (_vm.modelOrigin[index].setting),
        callback: function($$v) {
          _vm.$set(_vm.modelOrigin[index], "setting", $$v)
        },
        expression: "modelOrigin[index].setting"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "flex justify-end mt-4"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.onSubmitOriginSetting(
            data.id,
            _vm.modelOrigin[index].setting
          )
        }
      }
    }, [_vm._v("Save setting for\n                        " + _vm._s(_vm.getOriginName(data.origin_id)))])], 1)]) : _vm._e()]
  })], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Company name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.company_name),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "company_name", $$v)
      },
      expression: "model.general_setting.company_name"
    }
  }), _vm._v(" "), _vm._l((_vm.modelOrigin), function(data, index) {
    return [(
      data.setting_key === 'company_name' &&
      _vm.origins.length &&
      _vm.isValidOrigin(data.origin_id)
    ) ? _c('div', {
      staticClass: "mt-4 p-4 border rounded border-gray-500 border-solid w-1/2 ml-auto"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "grow-0 shrink-0 basis-32"
    }, [_vm._v("\n                        Setting for " + _vm._s(_vm.getOriginName(data.origin_id)) + "\n                    ")]), _vm._v(" "), _c('el-input', {
      model: {
        value: (_vm.modelOrigin[index].setting),
        callback: function($$v) {
          _vm.$set(_vm.modelOrigin[index], "setting", $$v)
        },
        expression: "modelOrigin[index].setting"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "flex justify-end mt-4"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.onSubmitOriginSetting(
            data.id,
            _vm.modelOrigin[index].setting
          )
        }
      }
    }, [_vm._v("Save setting for\n                        " + _vm._s(_vm.getOriginName(data.origin_id)))])], 1)]) : _vm._e()]
  })], 2)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.definition) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "report"
  }, [_c('el-menu', {
    staticClass: "flex items-center px-30 h-60",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('div', {
    staticClass: "flex gap items-center grow"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "grow"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    on: {
      "change": _vm.navigateTo
    },
    model: {
      value: (_vm.selectedReport),
      callback: function($$v) {
        _vm.selectedReport = $$v
      },
      expression: "selectedReport"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mr-4"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.exporting),
      expression: "exporting"
    }],
    attrs: {
      "disabled": _vm.exporting
    },
    on: {
      "click": _vm.onExport
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('v-custom-date-range-picker', {
    on: {
      "dateRange": function (v) {
        _vm.dateRange = v;
      }
    }
  })], 1), _vm._v(" "), (_vm.definition) ? _c('div', {
    staticClass: "p-30"
  }, [_c('el-card', {
    staticClass: "mb-20 report__filter",
    attrs: {
      "shadow": "none"
    }
  }, [_c('div', {
    staticClass: "title mb-5"
  }, [_vm._v("Filter")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "mr-4 w-1/4"
  }, [_c('div', {
    staticClass: "report__filter-label"
  }, [_vm._v("Coupon")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.filterResults.coupon),
      callback: function($$v) {
        _vm.$set(_vm.filterResults, "coupon", $$v)
      },
      expression: "filterResults.coupon"
    }
  }, _vm._l((_vm.filterOptions.coupon), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mr-4 w-1/4"
  }, [_c('div', {
    staticClass: "report__filter-label"
  }, [_vm._v("Customer group")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.filterResults.customerGroup),
      callback: function($$v) {
        _vm.$set(_vm.filterResults, "customerGroup", $$v)
      },
      expression: "filterResults.customerGroup"
    }
  }, _vm._l((_vm.filterOptions.customerGroup), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mr-4 w-1/4"
  }, [_c('div', {
    staticClass: "report__filter-label"
  }, [_vm._v("Gender")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.filterResults.gender),
      callback: function($$v) {
        _vm.$set(_vm.filterResults, "gender", $$v)
      },
      expression: "filterResults.gender"
    }
  }, _vm._l((_vm.filterOptions.gender), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "w-1/4"
  }, [_c('div', {
    staticClass: "report__filter-label"
  }, [_vm._v("Origin")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.filterResults.origin),
      callback: function($$v) {
        _vm.$set(_vm.filterResults, "origin", $$v)
      },
      expression: "filterResults.origin"
    }
  }, _vm._l((_vm.filterOptions.origin), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex mt-4"
  }, [_c('div', {
    staticClass: "mr-4 w-1/4"
  }, [_c('div', {
    staticClass: "report__filter-label"
  }, [_vm._v("Categories")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select",
      "multiple": ""
    },
    model: {
      value: (_vm.filterResults.categories),
      callback: function($$v) {
        _vm.$set(_vm.filterResults, "categories", $$v)
      },
      expression: "filterResults.categories"
    }
  }, _vm._l((_vm.filterOptions.categories), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mr-4 w-1/4"
  }, [_c('div', {
    staticClass: "report__filter-label"
  }, [_vm._v("Payment")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select",
      "multiple": ""
    },
    model: {
      value: (_vm.filterResults.payment),
      callback: function($$v) {
        _vm.$set(_vm.filterResults, "payment", $$v)
      },
      expression: "filterResults.payment"
    }
  }, _vm._l((_vm.filterOptions.payment), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mr-4 w-1/4"
  }, [_c('div', {
    staticClass: "report__filter-label"
  }, [_vm._v("Products")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Search",
      "multiple": "",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.getProductsBySearch,
      "no-data-text": "No search result found",
      "no-match-text": "No search result found"
    },
    model: {
      value: (_vm.filterResults.products),
      callback: function($$v) {
        _vm.$set(_vm.filterResults, "products", $$v)
      },
      expression: "filterResults.products"
    }
  }, _vm._l((_vm.filterOptions.products), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "w-1/4"
  }, [_c('div', {
    staticClass: "report__filter-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select",
      "multiple": ""
    },
    model: {
      value: (_vm.filterResults.status),
      callback: function($$v) {
        _vm.$set(_vm.filterResults, "status", $$v)
      },
      expression: "filterResults.status"
    }
  }, _vm._l((_vm.filterOptions.status), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle",
      "justify": "end"
    }
  }, [_c('el-col', {
    staticClass: "mb-20",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.onBack
    }
  }, [_vm._v("Back to overview")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "mb-20",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [(_vm.reportData && _vm.reportData.length > 0) ? _c('div', {
    staticClass: "flex gap justify-end"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    on: {
      "change": _vm.filterReport
    },
    model: {
      value: (_vm.selectedFilter),
      callback: function($$v) {
        _vm.selectedFilter = $$v
      },
      expression: "selectedFilter"
    }
  }, _vm._l((_vm.reportFilterOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), (_vm.definition.filterTabs) ? _c('el-radio-group', {
    model: {
      value: (_vm.groupBy),
      callback: function($$v) {
        _vm.groupBy = $$v
      },
      expression: "groupBy"
    }
  }, _vm._l((_vm.definition.filterTabs), function(el) {
    return _c('el-radio-button', {
      key: el,
      attrs: {
        "label": el
      }
    }, [_vm._v(_vm._s(el))])
  }), 1) : _vm._e()], 1) : _vm._e()])], 1), _vm._v(" "), (
    _vm.definition.table &&
    _vm.reportData &&
    _vm.reportData.length > 0 &&
    _vm.chartData.values &&
    !_vm.chartData.values.every(function (e) { return e === 0; })
  ) ? _c('el-card', {
    staticClass: "mb-20",
    attrs: {
      "shadow": "none"
    }
  }, [(_vm.definition.chart === 'BAR_AND_LINE') ? _c('chart-bar-and-line', {
    attrs: {
      "data": _vm.chartData
    }
  }) : (_vm.definition.chart === 'PIE') ? _c('chart-pie', {
    attrs: {
      "data": _vm.chartData
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.definition.table && _vm.reportData) ? _c('el-table', {
    staticClass: "w-full",
    attrs: {
      "data": _vm.reportData,
      "stripe": ""
    }
  }, _vm._l((_vm.definition.table), function(def, index) {
    return _c('el-table-column', {
      key: def.key,
      attrs: {
        "label": def.label,
        "prop": def.key,
        "sortable": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(
            _vm.selectedReport === 'best_seller' &&
            _vm.reportData.length > 20 ?
            scope.$index !== _vm.reportData.length - 1 :
            true
          ) ? _c('div', {
            staticClass: "flex items-center"
          }, [(
            index === 0 &&
            _vm.reportData.length <= _vm.chartColors.length
          ) ? _c('span', {
            staticClass: "chart-color-indicator",
            style: ({
              background: _vm.chartColors[scope.$index],
            })
          }) : _vm._e(), _vm._v(" "), (def.format === 'DATE') ? _c('span', [_vm._v(_vm._s(_vm._f("date")(scope.row[scope.column.property])))]) : (def.format === 'CURRENCY') ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(scope.row[scope.column.property],
            scope.row['currency'] ?
            scope.row['currency'] :
            _vm.defaultCurrency
          )))]) : _c('span', [_vm._v(_vm._s(scope.row[scope.column.property]))])]) : _vm._e()]
        }
      }], null, true)
    })
  }), 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isEmpty) ? _c('div', [_vm._v("No meta data defined")]) : _vm._e(), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, _vm._l((_vm.metaData), function(val, key) {
    return _c('el-form-item', {
      key: key,
      attrs: {
        "label": key
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea"
      },
      on: {
        "input": _vm.updateValue
      },
      model: {
        value: (_vm.value[key]),
        callback: function($$v) {
          _vm.$set(_vm.value, key, $$v)
        },
        expression: "value[key]"
      }
    })], 1)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.value1 || _vm.value2) ? _c('div', [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-first",
    style: ({
      width: _vm.getPercentage1
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-bar progress-bar-second",
    style: ({
      width: _vm.getPercentage2
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "grow"
  }, [_vm._v("\n            " + _vm._s(_vm.description1) + ": " + _vm._s(this.value1) + " (" + _vm._s(_vm.getPercentage1) + ")\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "grow text-right"
  }, [_vm._v("\n            " + _vm._s(_vm.description2) + ": " + _vm._s(this.value2) + " (" + _vm._s(_vm.getPercentage2) + ")\n        ")])])]) : _c('div', {
    staticClass: "text-gray"
  }, [_vm._v("No data available.")])
},staticRenderFns: []}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.shippingModuleIsInstalled('table_rate')) ? _c('div', [_c('h4', {
    staticClass: "group__headline"
  }, [_vm._v("Table Rate")]), _vm._v(" "), (_vm.model.table_rate) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.table_rate.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.table_rate, "enabled", $$v)
      },
      expression: "model.table_rate.enabled"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.table_rate.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.table_rate, "enabled", $$v)
      },
      expression: "model.table_rate.enabled"
    }
  }, [_vm._v("No")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.activeRateGroup),
      callback: function($$v) {
        _vm.activeRateGroup = $$v
      },
      expression: "activeRateGroup"
    }
  }, _vm._l((_vm.tablerates), function(rateGroup, rateIndex) {
    return _c('el-collapse-item', {
      key: rateIndex,
      attrs: {
        "title": rateGroup.name,
        "name": rateIndex
      }
    }, [(_vm.activeRateGroup == rateIndex) ? _c('div', [_c('el-form-item', {
      attrs: {
        "label": "Name"
      }
    }, [_c('el-input', {
      model: {
        value: (rateGroup.name),
        callback: function($$v) {
          _vm.$set(rateGroup, "name", $$v)
        },
        expression: "rateGroup.name"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Country"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rateGroup.country),
        expression: "rateGroup.country"
      }],
      staticClass: "select",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(rateGroup, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.countries), function(country) {
      return _c('option', {
        key: country.id,
        domProps: {
          "value": country.id
        }
      }, [_vm._v("\n                                " + _vm._s(country.name) + "\n                            ")])
    }), 0)]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Maximum weight"
      }
    }, [_c('el-input', {
      model: {
        value: (rateGroup.max_weight),
        callback: function($$v) {
          _vm.$set(rateGroup, "max_weight", $$v)
        },
        expression: "rateGroup.max_weight"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Time"
      }
    }, [_c('el-input', {
      model: {
        value: (rateGroup.time),
        callback: function($$v) {
          _vm.$set(rateGroup, "time", $$v)
        },
        expression: "rateGroup.time"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Postcode start"
      }
    }, [_c('el-input', {
      model: {
        value: (rateGroup.cep_start),
        callback: function($$v) {
          _vm.$set(rateGroup, "cep_start", $$v)
        },
        expression: "rateGroup.cep_start"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Postcode end"
      }
    }, [_c('el-input', {
      model: {
        value: (rateGroup.cep_end),
        callback: function($$v) {
          _vm.$set(rateGroup, "cep_end", $$v)
        },
        expression: "rateGroup.cep_end"
      }
    })], 1), _vm._v(" "), _vm._l((rateGroup.rates), function(rate, index) {
      return _c('el-form-item', {
        key: index,
        attrs: {
          "label": "Rate"
        }
      }, [_c('el-row', {
        attrs: {
          "gutter": 5
        }
      }, [_c('el-col', {
        attrs: {
          "span": 5
        }
      }, [_c('el-input', {
        attrs: {
          "placeholder": "From"
        },
        model: {
          value: (rate.from),
          callback: function($$v) {
            _vm.$set(rate, "from", $$v)
          },
          expression: "rate.from"
        }
      }, [_c('template', {
        slot: "prepend"
      }, [_vm._v("Gram")])], 2)], 1), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 5
        }
      }, [_c('el-input', {
        attrs: {
          "placeholder": "Rate"
        },
        model: {
          value: (rate.rate),
          callback: function($$v) {
            _vm.$set(rate, "rate", $$v)
          },
          expression: "rate.rate"
        }
      }, [_c('template', {
        slot: "prepend"
      }, [_vm._v("Price $")])], 2)], 1), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 11
        }
      }, [_c('el-button', {
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.removeRate(rateIndex, rate)
          }
        }
      }, [_vm._v("Delete")])], 1)], 1)], 1)
    }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
      on: {
        "click": function($event) {
          return _vm.addRate(rateIndex)
        }
      }
    }, [_vm._v("New rate")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.removeRateGroup(rateIndex)
        }
      }
    }, [_vm._v("Remove rate group")])], 1)], 2) : _vm._e()])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "u__margin-top"
  }, [_c('el-button', {
    on: {
      "click": _vm.addRateGroup
    }
  }, [_vm._v("Add new rate group")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveTableRate
    }
  }, [_vm._v("Save Table Rate")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.shippingModuleIsInstalled('flatrate')) ? _c('div', [_c('h4', {
    staticClass: "group__headline mt-20"
  }, [_vm._v("Flat Rate")]), _vm._v(" "), (_vm.model.flatrate) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.flatrate.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.flatrate, "enabled", $$v)
      },
      expression: "model.flatrate.enabled"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.flatrate.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.flatrate, "enabled", $$v)
      },
      expression: "model.flatrate.enabled"
    }
  }, [_vm._v("No")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u__margin-top"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveFlatRate
    }
  }, [_vm._v("Save Flat Rate")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.shippingModuleIsInstalled('fedex')) ? _c('div', [_c('h4', {
    staticClass: "group__headline mt-20"
  }, [_vm._v("Fedex")]), _vm._v(" "), (_vm.model.fedex) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.fedex.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.fedex, "enabled", $$v)
      },
      expression: "model.fedex.enabled"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.fedex.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.fedex, "enabled", $$v)
      },
      expression: "model.fedex.enabled"
    }
  }, [_vm._v("No")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u__margin-top"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveFedex
    }
  }, [_vm._v("Save Fedex")])], 1)]) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "group__headline mt-20"
  }, [_vm._v("Shipping Discounts")]), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.activeDiscount),
      callback: function($$v) {
        _vm.activeDiscount = $$v
      },
      expression: "activeDiscount"
    }
  }, _vm._l((_vm.shiprules), function(rule, ruleIndex) {
    return _c('el-collapse-item', {
      key: ruleIndex,
      attrs: {
        "title": rule.name,
        "name": ruleIndex
      }
    }, [(_vm.activeDiscount == ruleIndex) ? _c('div', [_c('el-form-item', {
      attrs: {
        "label": "Name"
      }
    }, [_c('el-input', {
      model: {
        value: (rule.name),
        callback: function($$v) {
          _vm.$set(rule, "name", $$v)
        },
        expression: "rule.name"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Discountend shipping value"
      }
    }, [_c('el-input', {
      model: {
        value: (rule.discounted_shipping),
        callback: function($$v) {
          _vm.$set(rule, "discounted_shipping", $$v)
        },
        expression: "rule.discounted_shipping"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Minimum order value"
      }
    }, [_c('el-input', {
      model: {
        value: (rule.free_shipping),
        callback: function($$v) {
          _vm.$set(rule, "free_shipping", $$v)
        },
        expression: "rule.free_shipping"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Maximum order value (Optional)"
      }
    }, [_c('el-input', {
      model: {
        value: (rule.free_shipping_max),
        callback: function($$v) {
          _vm.$set(rule, "free_shipping_max", $$v)
        },
        expression: "rule.free_shipping_max"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Delivery type"
      }
    }, [_c('el-input', {
      model: {
        value: (rule.ratekey),
        callback: function($$v) {
          _vm.$set(rule, "ratekey", $$v)
        },
        expression: "rule.ratekey"
      }
    })], 1), _vm._v(" "), _vm._l((rule.location), function(loc, index) {
      return _c('el-form-item', {
        key: index,
        attrs: {
          "label": "Location",
          "rules": {
            required: true,
            message: 'location can not be null',
            trigger: 'blur',
          }
        }
      }, [_c('el-col', {
        attrs: {
          "span": 11
        }
      }, [_c('div', {
        staticClass: "relative"
      }, [_c('label', {
        staticClass: "inline-block text-xs text-neutral-300 bg-white ml-px absolute top-0 left-2.5 z-10 px-1 transform -translate-y-1/2"
      }, [_vm._v("Country")]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (loc.country),
          expression: "loc.country"
        }],
        staticClass: "select",
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(loc, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, function($event) {
            return _vm.getZonesOnSelectChange($event)
          }]
        }
      }, _vm._l((_vm.countries), function(country) {
        return _c('option', {
          key: country.id,
          domProps: {
            "value": country.id.toString()
          }
        }, [_vm._v("\n                                    " + _vm._s(country.name) + "\n                                ")])
      }), 0)]), _vm._v(" "), (loc.country) ? _c('div', {
        staticClass: "relative mt-4"
      }, [_c('label', {
        staticClass: "inline-block text-xs text-neutral-300 bg-white ml-px absolute top-0 left-2.5 z-10 px-1 transform -translate-y-1/2"
      }, [_vm._v("State")]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (loc.zone),
          expression: "loc.zone"
        }],
        staticClass: "select",
        attrs: {
          "disabled": _vm.isFetchingZones
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(loc, "zone", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.mappedZones[loc.country]), function(zone) {
        return _c('option', {
          key: zone.id,
          domProps: {
            "value": zone.id.toString()
          }
        }, [_vm._v("\n                                    " + _vm._s(zone.name) + "\n                                ")])
      }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "relative mt-4"
      }, [_c('label', {
        staticClass: "inline-block text-xs text-neutral-300 bg-white ml-px absolute top-0 left-2.5 z-10 px-1 transform -translate-y-1/2"
      }, [_vm._v("City")]), _vm._v(" "), _c('el-input', {
        model: {
          value: (loc.city),
          callback: function($$v) {
            _vm.$set(loc, "city", $$v)
          },
          expression: "loc.city"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "relative mt-4"
      }, [_c('label', {
        staticClass: "inline-block text-xs text-neutral-300 bg-white ml-px absolute top-0 left-2.5 z-10 px-1 transform -translate-y-1/2"
      }, [_vm._v("District")]), _vm._v(" "), _c('el-input', {
        model: {
          value: (loc.bairro),
          callback: function($$v) {
            _vm.$set(loc, "bairro", $$v)
          },
          expression: "loc.bairro"
        }
      })], 1)]), _vm._v(" "), _c('el-col', {
        staticClass: "flex justify-end",
        attrs: {
          "span": 11
        }
      }, [_c('el-button', {
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.removeLocation(ruleIndex, index)
          }
        }
      }, [_vm._v("Delete location")])], 1)], 1)
    }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
      on: {
        "click": function($event) {
          return _vm.addLocation(ruleIndex)
        }
      }
    }, [_vm._v("Add new location")])], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "mt-4"
    }, [_c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.removeShipDiscount(ruleIndex)
        }
      }
    }, [_vm._v("Remove discount")])], 1)], 2) : _vm._e()])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "u__margin-top"
  }, [_c('el-button', {
    on: {
      "click": _vm.addDiscount
    }
  }, [_vm._v("New discount")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDiscounts
    }
  }, [_vm._v("Save discounts")])], 1), _vm._v(" "), (_vm.model.shipping_discounts && _vm.model.shipping_discounts.property) ? _c('div', [_c('h4', {
    staticClass: "group__headline mt-20"
  }, [_vm._v("Property related free shipping (Free shipping only if all order items have this property set)")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Property name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.shipping_discounts.property),
      callback: function($$v) {
        _vm.$set(_vm.model.shipping_discounts, "property", $$v)
      },
      expression: "model.shipping_discounts.property"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "u__margin-top"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.savePropertyRelatedFreeShipping
    }
  }, [_vm._v("Save Property related free shipping")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-crud-category-hierarchy-select"
  }, [_c('el-select', {
    attrs: {
      "value": _vm.parentID,
      "placeholder": "Please select a category",
      "loading": _vm.loading
    },
    on: {
      "input": _vm.updateValue
    }
  }, _vm._l((_vm.remoteValues), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[335]);


// WEBPACK FOOTER //
// static/js/app.adf24347cf4b193cf315.js